"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * One Money Mail Mobile API
 * HTTP API (REST-like) for One Money Mail mobile devices. API is based on JSON API standard (http://jsonapi.org/). ## Convention in this docs worth explanation ### \'data\' null vs 404 error __This is related to paths with GET.__ In case request for resource that does not exists, but resource id was passed  for example /customers/123, there will be response with key \'data\' set to null. In case the primary part of resource URL is wrong, for example /custmerz/123, instead /customers/123, there will 404 (not found) error. ## Getting started To access this API, public/private key pair is needed. Please use POST /devices/authKeys to acquire it. For this request (\"/devices/authKeys\") only \"Date\" or \"X-Date\" http header is required. Date must be in format \'D, d M Y H:i:s T\', in GMT timezone for example ```Sun, 06 Nov 1994 08:49:37 GMT``` ## API request signing Every HTTP request to API must be signed. [HTTP signatures algorithm](https://tools.ietf.org/html/draft-cavage-http-signatures-03) implementation of PHP package [99designs/http-signatures-php](https://github.com/99designs/http-signatures-php) on API side is used for request signing and verifying. The following headers are needed for sign every HTTP request (except the one for key pair acquire): ### X-Request X-Request is SHA1 hash computed from concatenation HTTP method (lower case), \' \', path, \' \', request body. Path is URI part without query. #### Example 1 We have POST request for the following URL: ``` /v1/devices/authKeys?foo=bar ``` with body: ```   {     \"data\": {       \"type\": \"devices\",       \"attributes\": {         \"deviceId\": \"5c5be929-43ea-4d7d-836f-901f7a7f6d34\"       }     }   } ``` so SHA1 will be computed this way, where \".\" is used for string concatenation: ```   SHA1 (     \'post\' .     \' \' .     \'/v1/devices/authKeys\',     \' \' .     \'{       \"data\": {         \"type\": \"devices\",         \"attributes\": {           \"deviceId\": \"5c5be929-43ea-4d7d-836f-901f7a7f6d34\"         }       }     }\'   ) ``` #### Example 2 We have GET request for the following URL: ``` /v1/currencies ``` so SHA1 will be computed this way: ```   SHA1 (     \'get\' .     \' \' .     \'/v1/currencies\' .     \' \' .     \'\'   ) ``` ### Date or X-Date Date must be in format \'D, d M Y H:i:s T\', in GMT timezone. For example: ```Sun, 06 Nov 1994 08:49:37 GMT``` ### Signature This header is mandatory. The value of this header is HTTP signatures algorithm output. Contents of this signature are the following elements imploded with \",\": * `keyId=”%s”`, where %s is public key; * `algorithm=”%s”`, where %s is the name of signing algorithm - hmac-sha256 at the moment * `headers=”%s”`, where %s, is the list of http headers names (lowercase) required for sign (x-request, date or x-date) imploded with „ „ * `signature=”%s”`, where %s is „Signature” string encoded with base64 algorithm. \"Signature\" is \"SigningString\" encoded with signing algorithm (hmac-sha256)using private key. \"SigningString\" is string imploded with new line character (\\n) of strings with the following template \"%s: %s\", where first \"%s\" is http header name (lowercase) required for signing (x-request, date or x-date) and second \"%s\" is http header value. Example of full \"Signature\" header value: ```   keyId=\"raph\",algorithm=\"hmac-sha256\",headers=\"x-request date\",signature=\"02x/Q8hZCW07EEukX8s5FogFZ/Q2ggnAayEw9YqRI9I=\" ``` ### Authorization Value of \"Signature\" http header prefixed with \"Signature \", for example ```   Signature keyId=\"raph\",algorithm=\"hmac-sha256\",headers=\"x-request date\",signature=\"02x/Q8hZCW07EEukX8s5FogFZ/Q2ggnAayEw9YqRI9I=\" ``` ## Request authorisation - OAuth2 [Password Grant] [Refresh Token Grant] For requests where customer \"session\" is required, request should be signed (\"Signature\" header still remains - these are totally independent) with \"Authorization\" OAuth2 header, for example: ```   Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjFkZjU5ZjQ5NzA2NjA0ZTUzN2I2NzRiM2JiZjdkNWRkNDUwMmFkZmZmNTI0MTY0M2Q3MzAzZDQ3MzlmMmM4YjlkN2EwZTQ2YWI3MDliMWY4In0.eyJhdWQiOiJtb2JpbGVfYXBpIiwianRpIjoiMWRmNTlmNDk3MDY2MDRlNTM3YjY3NGIzYmJmN2Q1ZGQ0NTAyYWRmZmY1MjQxNjQzZDczMDNkNDczOWYyYzhiOWQ3YTBlNDZhYjcwOWIxZjgiLCJpYXQiOjE0OTY3NDkwNDcsIm5iZiI6MTQ5Njc0OTA0NywiZXhwIjoxNDk2NzQ5OTQ3LCJzdWIiOiIyOTI4NjEiLCJzY29wZXMiOlsibW9iaWxlX2FwaSJdfQ.r2l-8nH2jin81HwtL-nZautTjupOphJV2qMWmlH-NEHRtMst9AAV5SjbvyAa0os-HBcrFYNHZ-bg498WswcqJmo3wQEo--NqdOHMDvqpBY_Gd2jE8sWZrgwVFoG5zBDhTO55cIsJH85MEHQnp_WDre-7OHaFKOYeICnbjlpdy0DLr2WSiLOxc3va56TDeqW2fDFcXaroN6uetWW2TlwxAaEVBmKplocqH7v_PAb-AQ2UGTD_TnyR3Rpre6zlvlyfldqwaz3mPrw485YfBhb9RLlVH-SSg0k2S8rBQ8cQWomYdrdAv1fhh-1fay6aKPFt4fQZn5azui5gzKT433WOkg ``` ### OAuth2 - tokens acquire To acquire OAuth2 tokens please proceed to: ``` /customers/login ``` To refresh session token using refresh token, please proceed to: ``` /customers/refreshToken ``` ## Request authorisation for machine2machine - OAuth2 [Client Credentials Grant] For all requests from external application should be signed (“Signature” header still remains - these are totally independent) with “Authorization” OAuth2 header. Endpoint accesses with this grant is limited, is only use for machine to machine connections Header example: ```   Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjFkZjU5ZjQ5NzA2NjA0ZTUzN2I2NzRiM2JiZjdkNWRkNDUwMmFkZmZmNTI0MTY0M2Q3MzAzZDQ3MzlmMmM4YjlkN2EwZTQ2YWI3MDliMWY4In0.eyJhdWQiOiJtb2JpbGVfYXBpIiwianRpIjoiMWRmNTlmNDk3MDY2MDRlNTM3YjY3NGIzYmJmN2Q1ZGQ0NTAyYWRmZmY1MjQxNjQzZDczMDNkNDczOWYyYzhiOWQ3YTBlNDZhYjcwOWIxZjgiLCJpYXQiOjE0OTY3NDkwNDcsIm5iZiI6MTQ5Njc0OTA0NywiZXhwIjoxNDk2NzQ5OTQ3LCJzdWIiOiIyOTI4NjEiLCJzY29wZXMiOlsibW9iaWxlX2FwaSJdfQ.r2l-8nH2jin81HwtL-nZautTjupOphJV2qMWmlH-NEHRtMst9AAV5SjbvyAa0os-HBcrFYNHZ-bg498WswcqJmo3wQEo--NqdOHMDvqpBY_Gd2jE8sWZrgwVFoG5zBDhTO55cIsJH85MEHQnp_WDre-7OHaFKOYeICnbjlpdy0DLr2WSiLOxc3va56TDeqW2fDFcXaroN6uetWW2TlwxAaEVBmKplocqH7v_PAb-AQ2UGTD_TnyR3Rpre6zlvlyfldqwaz3mPrw485YfBhb9RLlVH-SSg0k2S8rBQ8cQWomYdrdAv1fhh-1fay6aKPFt4fQZn5azui5gzKT433WOkg ``` ### OAuth2 - tokens acquire To acquire OAuth2 tokens please proceed to: ``` /customers/login ```
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmlApiAxiosParamCreator = exports.AgentsGetDirectionEnum = exports.AgentsApi = exports.AgentsApiFactory = exports.AgentsApiFp = exports.AgentsApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.AddressesApi = exports.AddressesApiFactory = exports.AddressesApiFp = exports.AddressesApiAxiosParamCreator = exports.TransactionPaymentProviderEnum = exports.TransactionPaymentStatusEnum = exports.ProductsCalculatorPostRequestDataAttributesCurrencyOutEnum = exports.ProductsCalculatorPostRequestDataAttributesCurrencyInEnum = exports.ProductsCalculatorPostRequestDataAttributesClientTypeEnum = exports.ProductsCalculatorPost200ResponseDataCurrencyOutEnum = exports.ProductsCalculatorPost200ResponseDataCurrencyInEnum = exports.LiveTransactionCreatePostRequestDataAttributesForcedProviderNameEnum = exports.FeaturesGet200ResponseDataAttributesFeaturesInnerSettingsStatusEnum = exports.FeaturesFeatureNamePatchRequestDataAttributesStatusEnum = exports.FeaturesFeatureNameCustomerCustomerIdGet200ResponseDataAttributesStatusEnum = exports.CustomersRegistrationStepThirdPostRequestDataAttributesClientIdEnum = exports.CustomersRegistrationStepThirdPatchRequestDataAttributesClientIdEnum = exports.CustomersRegistrationStepSecondPostRequestDataAttributesClientIdEnum = exports.CustomersRegistrationStepFirstPostRequestDataAttributesClientIdEnum = exports.CustomersRegistrationStepFinancialValidationPostRequestDataAttributesClientIdEnum = exports.CustomersPasswordPostRequestDataAttributesClientIdEnum = exports.CustomersCustomerIdTransactionsPatchRequestDataAttributesPaymentTypeEnum = exports.CustomersCustomerIdScansPostRequestDataAttributesInnerFileTypeEnum = exports.CustomersCustomerIdScansPostRequestDataAttributesInnerDocumentTypeEnum = exports.CustomersCustomerIdReferralsRfaBalancePatchRequestDataAttributesOperationTypeEnum = exports.CustomersCustomerIdLimitGet200ResponseDataAttributesTypeEnum = exports.CustomersCustomerIdLanguagePostRequestDataAttributesLanguageEnum = exports.CustomersCustomerIdExchangeAlertPostRequestDataAttributesCurrencyOutEnum = exports.CustomersCustomerIdExchangeAlertPostRequestDataAttributesCurrencyInEnum = exports.CustomersCustomerIdExchangeAlertGet200ResponseDataAttributesCurrencyOutEnum = exports.CustomersCustomerIdExchangeAlertGet200ResponseDataAttributesCurrencyInEnum = exports.CustomerCustomerIdReferralsTransactionTransactionIdGet200ResponseDataAttributesStatusEnum = exports.CustomerCustomerDetailLanguageEnum = exports.ContactsCallMeBackPostRequestDataAttributesClientTypeEnum = exports.ContactsCallMeBackCustomerCustomerIdPostRequestDataAttributesClientTypeEnum = exports.ContactsBokRequestPostRequestDataAttributesClientTypeEnum = exports.ContactsBokRequestCustomerCustomerIdPostRequestDataAttributesClientTypeEnum = exports.ClientType = exports.AmlComplaintCreatePostRequestDataAttributesClientIdEnum = exports.AdminCustomerIdAuthStatusGet200ResponseDataAttributesStatusEnum = void 0;
exports.CustomerAccountApi = exports.CustomerAccountApiFactory = exports.CustomerAccountApiFp = exports.CustomerAccountApiAxiosParamCreator = exports.CustomerApi = exports.CustomerApiFactory = exports.CustomerApiFp = exports.CustomerApiAxiosParamCreator = exports.CurrenciesInGetInEnum = exports.CurrenciesApi = exports.CurrenciesApiFactory = exports.CurrenciesApiFp = exports.CurrenciesApiAxiosParamCreator = exports.CountriesGetFilterTypeEnum = exports.CountriesApi = exports.CountriesApiFactory = exports.CountriesApiFp = exports.CountriesApiAxiosParamCreator = exports.ContactApi = exports.ContactApiFactory = exports.ContactApiFp = exports.ContactApiAxiosParamCreator = exports.CalendarApi = exports.CalendarApiFactory = exports.CalendarApiFp = exports.CalendarApiAxiosParamCreator = exports.BlikApi = exports.BlikApiFactory = exports.BlikApiFp = exports.BlikApiAxiosParamCreator = exports.CustomersCustomerIdBeneficiariesGetDirectionEnum = exports.CustomersCustomerIdBeneficiariesGetFilterEwalletImportEnum = exports.CustomersCustomerIdBeneficiariesGetFilterIsCompanyEnum = exports.CustomersCustomerIdBeneficiariesGetOptionsPhoneMobileEnum = exports.CustomersCustomerIdBeneficiariesGetOptionsEmailEnum = exports.CustomersCustomerIdBeneficiariesGetOptionsCompanyNameEnum = exports.CustomersCustomerIdBeneficiariesGetOptionsLastnameEnum = exports.CustomersCustomerIdBeneficiariesGetOptionsFirstnameEnum = exports.BeneficiariesApi = exports.BeneficiariesApiFactory = exports.BeneficiariesApiFp = exports.BeneficiariesApiAxiosParamCreator = exports.ApiAccessApi = exports.ApiAccessApiFactory = exports.ApiAccessApiFp = exports.ApiAccessApiAxiosParamCreator = exports.AmlFieldValueGetFilterSystemAmlFieldTypeIdEnum = exports.AmlApi = exports.AmlApiFactory = exports.AmlApiFp = void 0;
exports.ProductsApiFp = exports.ProductsApiAxiosParamCreator = exports.PaymentCardsApi = exports.PaymentCardsApiFactory = exports.PaymentCardsApiFp = exports.PaymentCardsApiAxiosParamCreator = exports.LiveApi = exports.LiveApiFactory = exports.LiveApiFp = exports.LiveApiAxiosParamCreator = exports.LimitApi = exports.LimitApiFactory = exports.LimitApiFp = exports.LimitApiAxiosParamCreator = exports.GlobalPaymentApi = exports.GlobalPaymentApiFactory = exports.GlobalPaymentApiFp = exports.GlobalPaymentApiAxiosParamCreator = exports.FileApi = exports.FileApiFactory = exports.FileApiFp = exports.FileApiAxiosParamCreator = exports.FeaturesApi = exports.FeaturesApiFactory = exports.FeaturesApiFp = exports.FeaturesApiAxiosParamCreator = exports.CustomersCustomerIdEwalletBeneficiariesGetDirectionEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetFilterEwalletImportEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetFilterIsCompanyEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsPhoneMobileEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsEmailEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsCompanyNameEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsLastnameEnum = exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsFirstnameEnum = exports.EwalletApi = exports.EwalletApiFactory = exports.EwalletApiFp = exports.EwalletApiAxiosParamCreator = exports.EpanelApi = exports.EpanelApiFactory = exports.EpanelApiFp = exports.EpanelApiAxiosParamCreator = exports.DevicesApi = exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.CustomerLoginApi = exports.CustomerLoginApiFactory = exports.CustomerLoginApiFp = exports.CustomerLoginApiAxiosParamCreator = void 0;
exports.CustomersCustomerIdTransactionsGetOptionsBeneficiaryCompanyNameEnum = exports.CustomersCustomerIdTransactionsGetOptionsBeneficiaryLastnameEnum = exports.CustomersCustomerIdTransactionsGetOptionsBeneficiaryFirstnameEnum = exports.CustomersCustomerIdTransactionsGetDirectionEnum = exports.CustomersCustomerIdTransactionsGetOptionsPayoutAmountEnum = exports.CustomersCustomerIdTransactionsGetOptionsSendingAmountEnum = exports.CustomersCustomerIdTransactionsGetFilterTypeEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryCompanyNameEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryLastnameEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryFirstnameEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetDirectionEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsPayoutAmountEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsSendingAmountEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsDateTimeEnum = exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetBrandEnum = exports.TransactionsApi = exports.TransactionsApiFactory = exports.TransactionsApiFp = exports.TransactionsApiAxiosParamCreator = exports.SurveysSurveyTypeIdQuestionQuestionIdAnswerPostSurveyTypeIdEnum = exports.SurveysSurveyTypeIdQuestionGetSurveyTypeIdEnum = exports.CustomerCompanyInfoSourcesGetDirectionEnum = exports.SurveysApi = exports.SurveysApiFactory = exports.SurveysApiFp = exports.SurveysApiAxiosParamCreator = exports.ScanIdApi = exports.ScanIdApiFactory = exports.ScanIdApiFp = exports.ScanIdApiAxiosParamCreator = exports.SantanderApi = exports.SantanderApiFactory = exports.SantanderApiFp = exports.SantanderApiAxiosParamCreator = exports.CustomersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGetDirectionEnum = exports.CustomersCustomerIdRepeatPaymentsGetDirectionEnum = exports.RepeatPaymentsApi = exports.RepeatPaymentsApiFactory = exports.RepeatPaymentsApiFp = exports.RepeatPaymentsApiAxiosParamCreator = exports.RegistrationApi = exports.RegistrationApiFactory = exports.RegistrationApiFp = exports.RegistrationApiAxiosParamCreator = exports.ReferralSystemApi = exports.ReferralSystemApiFactory = exports.ReferralSystemApiFp = exports.ReferralSystemApiAxiosParamCreator = exports.ProductsApi = exports.ProductsApiFactory = void 0;
exports.TransactionsTrackingTransactionIdGetFilterTypeEnum = exports.CustomersCustomerIdTransactionsGetFilterStatusEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.AdminCustomerIdAuthStatusGet200ResponseDataAttributesStatusEnum = {
    _0: '0',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4'
};
exports.AmlComplaintCreatePostRequestDataAttributesClientIdEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ClientType = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
exports.ContactsBokRequestCustomerCustomerIdPostRequestDataAttributesClientTypeEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
exports.ContactsBokRequestPostRequestDataAttributesClientTypeEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
exports.ContactsCallMeBackCustomerCustomerIdPostRequestDataAttributesClientTypeEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
exports.ContactsCallMeBackPostRequestDataAttributesClientTypeEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
exports.CustomerCustomerDetailLanguageEnum = {
    PlPl: 'pl_PL',
    EnUs: 'en_US'
};
exports.CustomerCustomerIdReferralsTransactionTransactionIdGet200ResponseDataAttributesStatusEnum = {
    LockForWithdrawal: 'lock_for_withdrawal',
    ReleasePending: 'release_pending',
    AbortPending: 'abort_pending'
};
exports.CustomersCustomerIdExchangeAlertGet200ResponseDataAttributesCurrencyInEnum = {
    Gbp: 'GBP'
};
exports.CustomersCustomerIdExchangeAlertGet200ResponseDataAttributesCurrencyOutEnum = {
    Pln: 'PLN',
    Eur: 'EUR'
};
exports.CustomersCustomerIdExchangeAlertPostRequestDataAttributesCurrencyInEnum = {
    Gbp: 'GBP'
};
exports.CustomersCustomerIdExchangeAlertPostRequestDataAttributesCurrencyOutEnum = {
    Pln: 'PLN',
    Eur: 'EUR'
};
exports.CustomersCustomerIdLanguagePostRequestDataAttributesLanguageEnum = {
    PlPl: 'pl_PL',
    EnUs: 'en_US'
};
exports.CustomersCustomerIdLimitGet200ResponseDataAttributesTypeEnum = {
    Day: 'day',
    Month: 'month'
};
exports.CustomersCustomerIdReferralsRfaBalancePatchRequestDataAttributesOperationTypeEnum = {
    ReleasePending: 'release_pending',
    AbortPending: 'abort_pending'
};
exports.CustomersCustomerIdScansPostRequestDataAttributesInnerDocumentTypeEnum = {
    Id: 'id',
    Passport: 'passport',
    DrivingLicense: 'driving_license',
    ProofOfSource: 'proof_of_source',
    ProofOfAddress: 'proof_of_address',
    BanksStatements: 'banks_statements',
    Other: 'other'
};
exports.CustomersCustomerIdScansPostRequestDataAttributesInnerFileTypeEnum = {
    Front: 'front',
    Back: 'back',
    Face: 'face'
};
exports.CustomersCustomerIdTransactionsPatchRequestDataAttributesPaymentTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
exports.CustomersPasswordPostRequestDataAttributesClientIdEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
exports.CustomersRegistrationStepFinancialValidationPostRequestDataAttributesClientIdEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
exports.CustomersRegistrationStepFirstPostRequestDataAttributesClientIdEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
exports.CustomersRegistrationStepSecondPostRequestDataAttributesClientIdEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
exports.CustomersRegistrationStepThirdPatchRequestDataAttributesClientIdEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
exports.CustomersRegistrationStepThirdPostRequestDataAttributesClientIdEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
exports.FeaturesFeatureNameCustomerCustomerIdGet200ResponseDataAttributesStatusEnum = {
    On: 'on',
    Off: 'off'
};
exports.FeaturesFeatureNamePatchRequestDataAttributesStatusEnum = {
    On: 'on',
    Off: 'off'
};
exports.FeaturesGet200ResponseDataAttributesFeaturesInnerSettingsStatusEnum = {
    On: 'on',
    Off: 'off'
};
exports.LiveTransactionCreatePostRequestDataAttributesForcedProviderNameEnum = {
    Dialcom: 'Dialcom',
    Bluecash: 'Bluecash',
    Santander: 'Santander'
};
exports.ProductsCalculatorPost200ResponseDataCurrencyInEnum = {
    Gbp: 'GBP'
};
exports.ProductsCalculatorPost200ResponseDataCurrencyOutEnum = {
    Pln: 'PLN',
    Eur: 'EUR'
};
exports.ProductsCalculatorPostRequestDataAttributesClientTypeEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
exports.ProductsCalculatorPostRequestDataAttributesCurrencyInEnum = {
    Gbp: 'GBP'
};
exports.ProductsCalculatorPostRequestDataAttributesCurrencyOutEnum = {
    Pln: 'PLN',
    Eur: 'EUR'
};
exports.TransactionPaymentStatusEnum = {
    NoData: 'NO_DATA',
    Initiated: 'INITIATED',
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Declined: 'DECLINED'
};
exports.TransactionPaymentProviderEnum = {
    NotSet: 'NOT_SET',
    MyOpayo: 'MY_OPAYO',
    OpayoCard: 'OPAYO_CARD',
    GlobalPayment: 'GLOBAL_PAYMENT'
};
/**
 * AddressesApi - axios parameter creator
 * @export
 */
var AddressesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get suggestions for addresses autocomplete - based on post code.
         * @summary Get address autocomplete data.
         * @param {string} postCode Post code.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesPostCodeGet: function (postCode, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postCode' is not null or undefined
                            (0, common_1.assertParamExists)('addressesPostCodeGet', 'postCode', postCode);
                            localVarPath = "/addresses/{postCode}"
                                .replace("{".concat("postCode", "}"), encodeURIComponent(String(postCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AddressesApiAxiosParamCreator = AddressesApiAxiosParamCreator;
/**
 * AddressesApi - functional programming interface
 * @export
 */
var AddressesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AddressesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get suggestions for addresses autocomplete - based on post code.
         * @summary Get address autocomplete data.
         * @param {string} postCode Post code.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesPostCodeGet: function (postCode, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressesPostCodeGet(postCode, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AddressesApi.addressesPostCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AddressesApiFp = AddressesApiFp;
/**
 * AddressesApi - factory interface
 * @export
 */
var AddressesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AddressesApiFp)(configuration);
    return {
        /**
         * Get suggestions for addresses autocomplete - based on post code.
         * @summary Get address autocomplete data.
         * @param {string} postCode Post code.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesPostCodeGet: function (postCode, acceptLanguage, options) {
            return localVarFp.addressesPostCodeGet(postCode, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AddressesApiFactory = AddressesApiFactory;
/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
var AddressesApi = /** @class */ (function (_super) {
    __extends(AddressesApi, _super);
    function AddressesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get suggestions for addresses autocomplete - based on post code.
     * @summary Get address autocomplete data.
     * @param {string} postCode Post code.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    AddressesApi.prototype.addressesPostCodeGet = function (postCode, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AddressesApiFp)(this.configuration).addressesPostCodeGet(postCode, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressesApi;
}(base_1.BaseAPI));
exports.AddressesApi = AddressesApi;
/**
 * AdminApi - axios parameter creator
 * @export
 */
var AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get customer\'s auth status
         * @summary Get customer\'s auth status
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdAuthStatusGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('adminCustomerIdAuthStatusGet', 'customerId', customerId);
                            localVarPath = "/admin/{customerId}/authStatus"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Change customer\'s status
         * @summary Change customer\'s status
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AdminCustomerIdAuthStatusPatchRequest} [adminCustomerIdAuthStatusPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdAuthStatusPatch: function (customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('adminCustomerIdAuthStatusPatch', 'customerId', customerId);
                            localVarPath = "/admin/{customerId}/authStatus"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminCustomerIdAuthStatusPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get personal data by customer\'s id
         * @summary Get personal data by customer\'s id
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdCustomerGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('adminCustomerIdCustomerGet', 'customerId', customerId);
                            localVarPath = "/admin/{customerId}/customer"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get phone mobile by customer id
         * @summary Get phone mobile by customer id
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdPhoneGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('adminCustomerIdPhoneGet', 'customerId', customerId);
                            localVarPath = "/admin/{customerId}/phone"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get customer\'s id by phone number or email
         * @summary Get customer\'s id by phone number or email
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterEmail] Filter by email. For example /admin/customers?filter[email]&#x3D;mail@1mm.eu. One of filter is required (phone or email)
         * @param {string} [filterPhone] Filter by phone. For example /admin/customers?filter[phone]&#x3D;1222. One of filter is required (phone or email)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet: function (acceptLanguage, filterEmail, filterPhone, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/admin/customers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterEmail !== undefined) {
                                localVarQueryParameter['filter[email]'] = filterEmail;
                            }
                            if (filterPhone !== undefined) {
                                localVarQueryParameter['filter[phone]'] = filterPhone;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
var AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get customer\'s auth status
         * @summary Get customer\'s auth status
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdAuthStatusGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCustomerIdAuthStatusGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.adminCustomerIdAuthStatusGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Change customer\'s status
         * @summary Change customer\'s status
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AdminCustomerIdAuthStatusPatchRequest} [adminCustomerIdAuthStatusPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdAuthStatusPatch: function (customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCustomerIdAuthStatusPatch(customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.adminCustomerIdAuthStatusPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get personal data by customer\'s id
         * @summary Get personal data by customer\'s id
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdCustomerGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCustomerIdCustomerGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.adminCustomerIdCustomerGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get phone mobile by customer id
         * @summary Get phone mobile by customer id
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdPhoneGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCustomerIdPhoneGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.adminCustomerIdPhoneGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get customer\'s id by phone number or email
         * @summary Get customer\'s id by phone number or email
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterEmail] Filter by email. For example /admin/customers?filter[email]&#x3D;mail@1mm.eu. One of filter is required (phone or email)
         * @param {string} [filterPhone] Filter by phone. For example /admin/customers?filter[phone]&#x3D;1222. One of filter is required (phone or email)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet: function (acceptLanguage, filterEmail, filterPhone, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCustomersGet(acceptLanguage, filterEmail, filterPhone, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.adminCustomersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
var AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         * Get customer\'s auth status
         * @summary Get customer\'s auth status
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdAuthStatusGet: function (customerId, acceptLanguage, options) {
            return localVarFp.adminCustomerIdAuthStatusGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change customer\'s status
         * @summary Change customer\'s status
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AdminCustomerIdAuthStatusPatchRequest} [adminCustomerIdAuthStatusPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdAuthStatusPatch: function (customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options) {
            return localVarFp.adminCustomerIdAuthStatusPatch(customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get personal data by customer\'s id
         * @summary Get personal data by customer\'s id
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdCustomerGet: function (customerId, acceptLanguage, options) {
            return localVarFp.adminCustomerIdCustomerGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get phone mobile by customer id
         * @summary Get phone mobile by customer id
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerIdPhoneGet: function (customerId, acceptLanguage, options) {
            return localVarFp.adminCustomerIdPhoneGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get customer\'s id by phone number or email
         * @summary Get customer\'s id by phone number or email
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterEmail] Filter by email. For example /admin/customers?filter[email]&#x3D;mail@1mm.eu. One of filter is required (phone or email)
         * @param {string} [filterPhone] Filter by phone. For example /admin/customers?filter[phone]&#x3D;1222. One of filter is required (phone or email)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet: function (acceptLanguage, filterEmail, filterPhone, options) {
            return localVarFp.adminCustomersGet(acceptLanguage, filterEmail, filterPhone, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get customer\'s auth status
     * @summary Get customer\'s auth status
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminCustomerIdAuthStatusGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminCustomerIdAuthStatusGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change customer\'s status
     * @summary Change customer\'s status
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {AdminCustomerIdAuthStatusPatchRequest} [adminCustomerIdAuthStatusPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminCustomerIdAuthStatusPatch = function (customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminCustomerIdAuthStatusPatch(customerId, acceptLanguage, adminCustomerIdAuthStatusPatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get personal data by customer\'s id
     * @summary Get personal data by customer\'s id
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminCustomerIdCustomerGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminCustomerIdCustomerGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get phone mobile by customer id
     * @summary Get phone mobile by customer id
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminCustomerIdPhoneGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminCustomerIdPhoneGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get customer\'s id by phone number or email
     * @summary Get customer\'s id by phone number or email
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterEmail] Filter by email. For example /admin/customers?filter[email]&#x3D;mail@1mm.eu. One of filter is required (phone or email)
     * @param {string} [filterPhone] Filter by phone. For example /admin/customers?filter[phone]&#x3D;1222. One of filter is required (phone or email)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.adminCustomersGet = function (acceptLanguage, filterEmail, filterPhone, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).adminCustomersGet(acceptLanguage, filterEmail, filterPhone, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * AgentsApi - axios parameter creator
 * @export
 */
var AgentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * List of agents. Supports `filter` and `sort` by `post_code`, `city_name`, `street`, `displaying_name`
         * @summary Get list of agents
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example &#x60;/agents?page&#x3D;1&#x60;. Use with limit.
         * @param {number} [limit] Size of result. Min is 1. For example &#x60;/agents?limit&#x3D;1&#x60;. Use with page.
         * @param {string} [filterPostCode] Filter by postcode. For example &#x60;/agents?filter[post_code]&#x3D;1222&#x60;.
         * @param {string} [filterCityName] Filter by locations of city. For example &#x60;/agents?filter[city_name]&#x3D;Lon&amp;options[city_name]&#x3D;like&#x60;.
         * @param {string} [filterStreet] Filter by street. For example &#x60;/agents?filter[street]&#x3D;RestRoad&#x60;.
         * @param {string} [filterDisplayingName] Filter by name of merchant agent. For example &#x60;/agents?filter[displaying_name]&#x3D;1MM&#x60;.
         * @param {string} [sort] Sort by agent fields. For example &#x60;/agents?sort&#x3D;name&amp;direction&#x3D;desc&#x60;.
         * @param {AgentsGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGet: function (acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/agents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filterPostCode !== undefined) {
                                localVarQueryParameter['filter[post_code]'] = filterPostCode;
                            }
                            if (filterCityName !== undefined) {
                                localVarQueryParameter['filter[city_name]'] = filterCityName;
                            }
                            if (filterStreet !== undefined) {
                                localVarQueryParameter['filter[street]'] = filterStreet;
                            }
                            if (filterDisplayingName !== undefined) {
                                localVarQueryParameter['filter[displaying_name]'] = filterDisplayingName;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AgentsApiAxiosParamCreator = AgentsApiAxiosParamCreator;
/**
 * AgentsApi - functional programming interface
 * @export
 */
var AgentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AgentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * List of agents. Supports `filter` and `sort` by `post_code`, `city_name`, `street`, `displaying_name`
         * @summary Get list of agents
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example &#x60;/agents?page&#x3D;1&#x60;. Use with limit.
         * @param {number} [limit] Size of result. Min is 1. For example &#x60;/agents?limit&#x3D;1&#x60;. Use with page.
         * @param {string} [filterPostCode] Filter by postcode. For example &#x60;/agents?filter[post_code]&#x3D;1222&#x60;.
         * @param {string} [filterCityName] Filter by locations of city. For example &#x60;/agents?filter[city_name]&#x3D;Lon&amp;options[city_name]&#x3D;like&#x60;.
         * @param {string} [filterStreet] Filter by street. For example &#x60;/agents?filter[street]&#x3D;RestRoad&#x60;.
         * @param {string} [filterDisplayingName] Filter by name of merchant agent. For example &#x60;/agents?filter[displaying_name]&#x3D;1MM&#x60;.
         * @param {string} [sort] Sort by agent fields. For example &#x60;/agents?sort&#x3D;name&amp;direction&#x3D;desc&#x60;.
         * @param {AgentsGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGet: function (acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agentsGet(acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AgentsApi.agentsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AgentsApiFp = AgentsApiFp;
/**
 * AgentsApi - factory interface
 * @export
 */
var AgentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AgentsApiFp)(configuration);
    return {
        /**
         * List of agents. Supports `filter` and `sort` by `post_code`, `city_name`, `street`, `displaying_name`
         * @summary Get list of agents
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example &#x60;/agents?page&#x3D;1&#x60;. Use with limit.
         * @param {number} [limit] Size of result. Min is 1. For example &#x60;/agents?limit&#x3D;1&#x60;. Use with page.
         * @param {string} [filterPostCode] Filter by postcode. For example &#x60;/agents?filter[post_code]&#x3D;1222&#x60;.
         * @param {string} [filterCityName] Filter by locations of city. For example &#x60;/agents?filter[city_name]&#x3D;Lon&amp;options[city_name]&#x3D;like&#x60;.
         * @param {string} [filterStreet] Filter by street. For example &#x60;/agents?filter[street]&#x3D;RestRoad&#x60;.
         * @param {string} [filterDisplayingName] Filter by name of merchant agent. For example &#x60;/agents?filter[displaying_name]&#x3D;1MM&#x60;.
         * @param {string} [sort] Sort by agent fields. For example &#x60;/agents?sort&#x3D;name&amp;direction&#x3D;desc&#x60;.
         * @param {AgentsGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsGet: function (acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options) {
            return localVarFp.agentsGet(acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AgentsApiFactory = AgentsApiFactory;
/**
 * AgentsApi - object-oriented interface
 * @export
 * @class AgentsApi
 * @extends {BaseAPI}
 */
var AgentsApi = /** @class */ (function (_super) {
    __extends(AgentsApi, _super);
    function AgentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List of agents. Supports `filter` and `sort` by `post_code`, `city_name`, `street`, `displaying_name`
     * @summary Get list of agents
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {number} [page] Number of result. Start is 1. For example &#x60;/agents?page&#x3D;1&#x60;. Use with limit.
     * @param {number} [limit] Size of result. Min is 1. For example &#x60;/agents?limit&#x3D;1&#x60;. Use with page.
     * @param {string} [filterPostCode] Filter by postcode. For example &#x60;/agents?filter[post_code]&#x3D;1222&#x60;.
     * @param {string} [filterCityName] Filter by locations of city. For example &#x60;/agents?filter[city_name]&#x3D;Lon&amp;options[city_name]&#x3D;like&#x60;.
     * @param {string} [filterStreet] Filter by street. For example &#x60;/agents?filter[street]&#x3D;RestRoad&#x60;.
     * @param {string} [filterDisplayingName] Filter by name of merchant agent. For example &#x60;/agents?filter[displaying_name]&#x3D;1MM&#x60;.
     * @param {string} [sort] Sort by agent fields. For example &#x60;/agents?sort&#x3D;name&amp;direction&#x3D;desc&#x60;.
     * @param {AgentsGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsApi
     */
    AgentsApi.prototype.agentsGet = function (acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options) {
        var _this = this;
        return (0, exports.AgentsApiFp)(this.configuration).agentsGet(acceptLanguage, page, limit, filterPostCode, filterCityName, filterStreet, filterDisplayingName, sort, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AgentsApi;
}(base_1.BaseAPI));
exports.AgentsApi = AgentsApi;
/**
 * @export
 */
exports.AgentsGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * AmlApi - axios parameter creator
 * @export
 */
var AmlApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Send complaint to customer service as an email via MESSAGE_COMPLAINT_CREATED_INTERNAL event. Supports any system.
         * @summary Send complaint to customer service. Does not require authentication.
         * @param {AmlComplaintCreatePostRequest} amlComplaintCreatePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlComplaintCreatePost: function (amlComplaintCreatePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'amlComplaintCreatePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('amlComplaintCreatePost', 'amlComplaintCreatePostRequest', amlComplaintCreatePostRequest);
                            localVarPath = "/aml/complaint/create";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(amlComplaintCreatePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list of field value.
         * @summary Get list of field value.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AmlFieldValueGetFilterSystemAmlFieldTypeIdEnum} [filterSystemAmlFieldTypeId] Display fields depending of type. For example systemAmlFieldTypeId&#x3D;1 return only Nationality field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlFieldValueGet: function (acceptLanguage, filterSystemAmlFieldTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/aml/fieldValue";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterSystemAmlFieldTypeId !== undefined) {
                                localVarQueryParameter['filter[systemAmlFieldTypeId]'] = filterSystemAmlFieldTypeId;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get peps and sanction data for beneficiary
         * @summary Get peps and sanction data for beneficiary
         * @param {number} beneficiaryId Beneficiary id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlPepsSanctionsBeneficiariesBeneficiaryIdGet: function (beneficiaryId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'beneficiaryId' is not null or undefined
                            (0, common_1.assertParamExists)('amlPepsSanctionsBeneficiariesBeneficiaryIdGet', 'beneficiaryId', beneficiaryId);
                            localVarPath = "/aml/pepsSanctions/beneficiaries/{beneficiaryId}"
                                .replace("{".concat("beneficiaryId", "}"), encodeURIComponent(String(beneficiaryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get peps and sanction data for customer
         * @summary Get peps and sanction data for customer
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlPepsSanctionsCustomersCustomerIdGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('amlPepsSanctionsCustomersCustomerIdGet', 'customerId', customerId);
                            localVarPath = "/aml/pepsSanctions/customers/{customerId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Save transaction survey result.
         * @summary Save transaction survey result.
         * @param {string} trxId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AmlTransactionTrxIdCheckerPostRequest} [amlTransactionTrxIdCheckerPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionTrxIdCheckerPost: function (trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'trxId' is not null or undefined
                            (0, common_1.assertParamExists)('amlTransactionTrxIdCheckerPost', 'trxId', trxId);
                            localVarPath = "/aml/transaction/{trxId}/checker"
                                .replace("{".concat("trxId", "}"), encodeURIComponent(String(trxId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(amlTransactionTrxIdCheckerPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list of source of funds categories.
         * @summary Get list of source of funds categories.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/transactions/dictionaries/sourceOfFunds/category"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list of proof of source.
         * @summary Get list of proof of source.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesSourceOfFundsGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsDictionariesSourceOfFundsGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/transactions/dictionaries/sourceOfFunds"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AmlApiAxiosParamCreator = AmlApiAxiosParamCreator;
/**
 * AmlApi - functional programming interface
 * @export
 */
var AmlApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AmlApiAxiosParamCreator)(configuration);
    return {
        /**
         * Send complaint to customer service as an email via MESSAGE_COMPLAINT_CREATED_INTERNAL event. Supports any system.
         * @summary Send complaint to customer service. Does not require authentication.
         * @param {AmlComplaintCreatePostRequest} amlComplaintCreatePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlComplaintCreatePost: function (amlComplaintCreatePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlComplaintCreatePost(amlComplaintCreatePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.amlComplaintCreatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list of field value.
         * @summary Get list of field value.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AmlFieldValueGetFilterSystemAmlFieldTypeIdEnum} [filterSystemAmlFieldTypeId] Display fields depending of type. For example systemAmlFieldTypeId&#x3D;1 return only Nationality field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlFieldValueGet: function (acceptLanguage, filterSystemAmlFieldTypeId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlFieldValueGet(acceptLanguage, filterSystemAmlFieldTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.amlFieldValueGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get peps and sanction data for beneficiary
         * @summary Get peps and sanction data for beneficiary
         * @param {number} beneficiaryId Beneficiary id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlPepsSanctionsBeneficiariesBeneficiaryIdGet: function (beneficiaryId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlPepsSanctionsBeneficiariesBeneficiaryIdGet(beneficiaryId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.amlPepsSanctionsBeneficiariesBeneficiaryIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get peps and sanction data for customer
         * @summary Get peps and sanction data for customer
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlPepsSanctionsCustomersCustomerIdGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlPepsSanctionsCustomersCustomerIdGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.amlPepsSanctionsCustomersCustomerIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Save transaction survey result.
         * @summary Save transaction survey result.
         * @param {string} trxId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AmlTransactionTrxIdCheckerPostRequest} [amlTransactionTrxIdCheckerPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionTrxIdCheckerPost: function (trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlTransactionTrxIdCheckerPost(trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.amlTransactionTrxIdCheckerPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list of source of funds categories.
         * @summary Get list of source of funds categories.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list of proof of source.
         * @summary Get list of proof of source.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesSourceOfFundsGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsDictionariesSourceOfFundsGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AmlApi.customersCustomerIdTransactionsDictionariesSourceOfFundsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AmlApiFp = AmlApiFp;
/**
 * AmlApi - factory interface
 * @export
 */
var AmlApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AmlApiFp)(configuration);
    return {
        /**
         * Send complaint to customer service as an email via MESSAGE_COMPLAINT_CREATED_INTERNAL event. Supports any system.
         * @summary Send complaint to customer service. Does not require authentication.
         * @param {AmlComplaintCreatePostRequest} amlComplaintCreatePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlComplaintCreatePost: function (amlComplaintCreatePostRequest, acceptLanguage, options) {
            return localVarFp.amlComplaintCreatePost(amlComplaintCreatePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of field value.
         * @summary Get list of field value.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AmlFieldValueGetFilterSystemAmlFieldTypeIdEnum} [filterSystemAmlFieldTypeId] Display fields depending of type. For example systemAmlFieldTypeId&#x3D;1 return only Nationality field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlFieldValueGet: function (acceptLanguage, filterSystemAmlFieldTypeId, options) {
            return localVarFp.amlFieldValueGet(acceptLanguage, filterSystemAmlFieldTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get peps and sanction data for beneficiary
         * @summary Get peps and sanction data for beneficiary
         * @param {number} beneficiaryId Beneficiary id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlPepsSanctionsBeneficiariesBeneficiaryIdGet: function (beneficiaryId, acceptLanguage, options) {
            return localVarFp.amlPepsSanctionsBeneficiariesBeneficiaryIdGet(beneficiaryId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get peps and sanction data for customer
         * @summary Get peps and sanction data for customer
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlPepsSanctionsCustomersCustomerIdGet: function (customerId, acceptLanguage, options) {
            return localVarFp.amlPepsSanctionsCustomersCustomerIdGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Save transaction survey result.
         * @summary Save transaction survey result.
         * @param {string} trxId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {AmlTransactionTrxIdCheckerPostRequest} [amlTransactionTrxIdCheckerPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionTrxIdCheckerPost: function (trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options) {
            return localVarFp.amlTransactionTrxIdCheckerPost(trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of source of funds categories.
         * @summary Get list of source of funds categories.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of proof of source.
         * @summary Get list of proof of source.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesSourceOfFundsGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsDictionariesSourceOfFundsGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AmlApiFactory = AmlApiFactory;
/**
 * AmlApi - object-oriented interface
 * @export
 * @class AmlApi
 * @extends {BaseAPI}
 */
var AmlApi = /** @class */ (function (_super) {
    __extends(AmlApi, _super);
    function AmlApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Send complaint to customer service as an email via MESSAGE_COMPLAINT_CREATED_INTERNAL event. Supports any system.
     * @summary Send complaint to customer service. Does not require authentication.
     * @param {AmlComplaintCreatePostRequest} amlComplaintCreatePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.amlComplaintCreatePost = function (amlComplaintCreatePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).amlComplaintCreatePost(amlComplaintCreatePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of field value.
     * @summary Get list of field value.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {AmlFieldValueGetFilterSystemAmlFieldTypeIdEnum} [filterSystemAmlFieldTypeId] Display fields depending of type. For example systemAmlFieldTypeId&#x3D;1 return only Nationality field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.amlFieldValueGet = function (acceptLanguage, filterSystemAmlFieldTypeId, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).amlFieldValueGet(acceptLanguage, filterSystemAmlFieldTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get peps and sanction data for beneficiary
     * @summary Get peps and sanction data for beneficiary
     * @param {number} beneficiaryId Beneficiary id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.amlPepsSanctionsBeneficiariesBeneficiaryIdGet = function (beneficiaryId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).amlPepsSanctionsBeneficiariesBeneficiaryIdGet(beneficiaryId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get peps and sanction data for customer
     * @summary Get peps and sanction data for customer
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.amlPepsSanctionsCustomersCustomerIdGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).amlPepsSanctionsCustomersCustomerIdGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Save transaction survey result.
     * @summary Save transaction survey result.
     * @param {string} trxId Transaction id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {AmlTransactionTrxIdCheckerPostRequest} [amlTransactionTrxIdCheckerPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.amlTransactionTrxIdCheckerPost = function (trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).amlTransactionTrxIdCheckerPost(trxId, acceptLanguage, amlTransactionTrxIdCheckerPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of source of funds categories.
     * @summary Get list of source of funds categories.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).customersCustomerIdTransactionsDictionariesSourceOfFundsCategoryGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of proof of source.
     * @summary Get list of proof of source.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmlApi
     */
    AmlApi.prototype.customersCustomerIdTransactionsDictionariesSourceOfFundsGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.AmlApiFp)(this.configuration).customersCustomerIdTransactionsDictionariesSourceOfFundsGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AmlApi;
}(base_1.BaseAPI));
exports.AmlApi = AmlApi;
/**
 * @export
 */
exports.AmlFieldValueGetFilterSystemAmlFieldTypeIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7
};
/**
 * ApiAccessApi - axios parameter creator
 * @export
 */
var ApiAccessApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This endpoint allows to negotiate keys pair needed with API communication.
         * @summary API authentication keys negotiation
         * @param {string} xDate
         * @param {DevicesAuthKeysPostRequest} devicesAuthKeysPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesAuthKeysPost: function (xDate, devicesAuthKeysPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'xDate' is not null or undefined
                            (0, common_1.assertParamExists)('devicesAuthKeysPost', 'xDate', xDate);
                            // verify required parameter 'devicesAuthKeysPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('devicesAuthKeysPost', 'devicesAuthKeysPostRequest', devicesAuthKeysPostRequest);
                            localVarPath = "/devices/authKeys";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication GetKeys required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 1:
                            // authentication GetKeys required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            if (xDate != null) {
                                localVarHeaderParameter['X-Date'] = String(xDate);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(devicesAuthKeysPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ApiAccessApiAxiosParamCreator = ApiAccessApiAxiosParamCreator;
/**
 * ApiAccessApi - functional programming interface
 * @export
 */
var ApiAccessApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApiAccessApiAxiosParamCreator)(configuration);
    return {
        /**
         * This endpoint allows to negotiate keys pair needed with API communication.
         * @summary API authentication keys negotiation
         * @param {string} xDate
         * @param {DevicesAuthKeysPostRequest} devicesAuthKeysPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesAuthKeysPost: function (xDate, devicesAuthKeysPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesAuthKeysPost(xDate, devicesAuthKeysPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ApiAccessApi.devicesAuthKeysPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ApiAccessApiFp = ApiAccessApiFp;
/**
 * ApiAccessApi - factory interface
 * @export
 */
var ApiAccessApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApiAccessApiFp)(configuration);
    return {
        /**
         * This endpoint allows to negotiate keys pair needed with API communication.
         * @summary API authentication keys negotiation
         * @param {string} xDate
         * @param {DevicesAuthKeysPostRequest} devicesAuthKeysPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesAuthKeysPost: function (xDate, devicesAuthKeysPostRequest, acceptLanguage, options) {
            return localVarFp.devicesAuthKeysPost(xDate, devicesAuthKeysPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApiAccessApiFactory = ApiAccessApiFactory;
/**
 * ApiAccessApi - object-oriented interface
 * @export
 * @class ApiAccessApi
 * @extends {BaseAPI}
 */
var ApiAccessApi = /** @class */ (function (_super) {
    __extends(ApiAccessApi, _super);
    function ApiAccessApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint allows to negotiate keys pair needed with API communication.
     * @summary API authentication keys negotiation
     * @param {string} xDate
     * @param {DevicesAuthKeysPostRequest} devicesAuthKeysPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAccessApi
     */
    ApiAccessApi.prototype.devicesAuthKeysPost = function (xDate, devicesAuthKeysPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ApiAccessApiFp)(this.configuration).devicesAuthKeysPost(xDate, devicesAuthKeysPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiAccessApi;
}(base_1.BaseAPI));
exports.ApiAccessApi = ApiAccessApi;
/**
 * BeneficiariesApi - axios parameter creator
 * @export
 */
var BeneficiariesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * If customer session is active and beneficiary belongs to customer - delete beneficiary.
         * @summary Delete beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdDelete: function (customerId, beneficiaryId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdDelete', 'customerId', customerId);
                            // verify required parameter 'beneficiaryId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdDelete', 'beneficiaryId', beneficiaryId);
                            localVarPath = "/customers/{customerId}/beneficiaries/{beneficiaryId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("beneficiaryId", "}"), encodeURIComponent(String(beneficiaryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If data are correct - save beneficiary.
         * @summary Update beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdPatch: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdPatch', 'customerId', customerId);
                            // verify required parameter 'beneficiaryId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdPatch', 'beneficiaryId', beneficiaryId);
                            // verify required parameter 'customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdPatch', 'customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest', customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest);
                            localVarPath = "/customers/{customerId}/beneficiaries/{beneficiaryId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("beneficiaryId", "}"), encodeURIComponent(String(beneficiaryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Confirm SMS token to  activate beneficiary.
         * @summary Confirm SMS token to activate beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch', 'customerId', customerId);
                            // verify required parameter 'beneficiaryId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch', 'beneficiaryId', beneficiaryId);
                            // verify required parameter 'customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch', 'customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest', customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest);
                            localVarPath = "/customers/{customerId}/beneficiaries/{beneficiaryId}/verify"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("beneficiaryId", "}"), encodeURIComponent(String(beneficiaryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send SMS token to customer.
         * @summary Send token to customer via SMS.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost', 'customerId', customerId);
                            // verify required parameter 'beneficiaryId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost', 'beneficiaryId', beneficiaryId);
                            // verify required parameter 'customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost', 'customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest', customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest);
                            localVarPath = "/customers/{customerId}/beneficiaries/{beneficiaryId}/verify"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("beneficiaryId", "}"), encodeURIComponent(String(beneficiaryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list of beneficiary relationship values.
         * @summary Get list of beneficiary relationship values.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesDictionariesRelationshipsGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesDictionariesRelationshipsGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/beneficiaries/dictionaries/relationships"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List of of customers beneficiaries.
         * @summary Get list of customers beneficiaries
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
         * @param {CustomersCustomerIdBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
         * @param {CustomersCustomerIdBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
         * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
         * @param {CustomersCustomerIdBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesGet: function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesGet', 'customerId', customerId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesGet', 'page', page);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesGet', 'limit', limit);
                            localVarPath = "/customers/{customerId}/beneficiaries"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filterFirstname !== undefined) {
                                localVarQueryParameter['filter[firstname]'] = filterFirstname;
                            }
                            if (optionsFirstname !== undefined) {
                                localVarQueryParameter['options[firstname]'] = optionsFirstname;
                            }
                            if (filterLastname !== undefined) {
                                localVarQueryParameter['filter[lastname]'] = filterLastname;
                            }
                            if (optionsLastname !== undefined) {
                                localVarQueryParameter['options[lastname]'] = optionsLastname;
                            }
                            if (filterCompanyName !== undefined) {
                                localVarQueryParameter['filter[company_name]'] = filterCompanyName;
                            }
                            if (optionsCompanyName !== undefined) {
                                localVarQueryParameter['options[company_name]'] = optionsCompanyName;
                            }
                            if (filterEmail !== undefined) {
                                localVarQueryParameter['filter[email]'] = filterEmail;
                            }
                            if (optionsEmail !== undefined) {
                                localVarQueryParameter['options[email]'] = optionsEmail;
                            }
                            if (filterPhoneMobile !== undefined) {
                                localVarQueryParameter['filter[phone_mobile]'] = filterPhoneMobile;
                            }
                            if (optionsPhoneMobile !== undefined) {
                                localVarQueryParameter['options[phone_mobile]'] = optionsPhoneMobile;
                            }
                            if (filterSearch !== undefined) {
                                localVarQueryParameter['filter[search]'] = filterSearch;
                            }
                            if (filterIsCompany !== undefined) {
                                localVarQueryParameter['filter[is_company]'] = filterIsCompany;
                            }
                            if (filterEwalletImport !== undefined) {
                                localVarQueryParameter['filter[ewallet_import]'] = filterEwalletImport;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If data are correct - save beneficiary.
         * @summary Create beneficiary
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdBeneficiariesPostRequest} customersCustomerIdBeneficiariesPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesPost: function (customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdBeneficiariesPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBeneficiariesPost', 'customersCustomerIdBeneficiariesPostRequest', customersCustomerIdBeneficiariesPostRequest);
                            localVarPath = "/customers/{customerId}/beneficiaries"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdBeneficiariesPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BeneficiariesApiAxiosParamCreator = BeneficiariesApiAxiosParamCreator;
/**
 * BeneficiariesApi - functional programming interface
 * @export
 */
var BeneficiariesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BeneficiariesApiAxiosParamCreator)(configuration);
    return {
        /**
         * If customer session is active and beneficiary belongs to customer - delete beneficiary.
         * @summary Delete beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdDelete: function (customerId, beneficiaryId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesBeneficiaryIdDelete(customerId, beneficiaryId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesBeneficiaryIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If data are correct - save beneficiary.
         * @summary Update beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdPatch: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesBeneficiaryIdPatch(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesBeneficiaryIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Confirm SMS token to  activate beneficiary.
         * @summary Confirm SMS token to activate beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send SMS token to customer.
         * @summary Send token to customer via SMS.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list of beneficiary relationship values.
         * @summary Get list of beneficiary relationship values.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesDictionariesRelationshipsGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesDictionariesRelationshipsGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesDictionariesRelationshipsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * List of of customers beneficiaries.
         * @summary Get list of customers beneficiaries
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
         * @param {CustomersCustomerIdBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
         * @param {CustomersCustomerIdBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
         * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
         * @param {CustomersCustomerIdBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesGet: function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesGet(customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If data are correct - save beneficiary.
         * @summary Create beneficiary
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdBeneficiariesPostRequest} customersCustomerIdBeneficiariesPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesPost: function (customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBeneficiariesPost(customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BeneficiariesApi.customersCustomerIdBeneficiariesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.BeneficiariesApiFp = BeneficiariesApiFp;
/**
 * BeneficiariesApi - factory interface
 * @export
 */
var BeneficiariesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BeneficiariesApiFp)(configuration);
    return {
        /**
         * If customer session is active and beneficiary belongs to customer - delete beneficiary.
         * @summary Delete beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdDelete: function (customerId, beneficiaryId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBeneficiariesBeneficiaryIdDelete(customerId, beneficiaryId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If data are correct - save beneficiary.
         * @summary Update beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdPatch: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBeneficiariesBeneficiaryIdPatch(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Confirm SMS token to  activate beneficiary.
         * @summary Confirm SMS token to activate beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send SMS token to customer.
         * @summary Send token to customer via SMS.
         * @param {number} customerId Customer id.
         * @param {number} beneficiaryId Beneficiary id
         * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost: function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of beneficiary relationship values.
         * @summary Get list of beneficiary relationship values.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesDictionariesRelationshipsGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBeneficiariesDictionariesRelationshipsGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of of customers beneficiaries.
         * @summary Get list of customers beneficiaries
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {CustomersCustomerIdBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
         * @param {CustomersCustomerIdBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
         * @param {CustomersCustomerIdBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
         * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
         * @param {CustomersCustomerIdBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesGet: function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
            return localVarFp.customersCustomerIdBeneficiariesGet(customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If data are correct - save beneficiary.
         * @summary Create beneficiary
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdBeneficiariesPostRequest} customersCustomerIdBeneficiariesPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBeneficiariesPost: function (customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBeneficiariesPost(customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BeneficiariesApiFactory = BeneficiariesApiFactory;
/**
 * BeneficiariesApi - object-oriented interface
 * @export
 * @class BeneficiariesApi
 * @extends {BaseAPI}
 */
var BeneficiariesApi = /** @class */ (function (_super) {
    __extends(BeneficiariesApi, _super);
    function BeneficiariesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If customer session is active and beneficiary belongs to customer - delete beneficiary.
     * @summary Delete beneficiary.
     * @param {number} customerId Customer id.
     * @param {number} beneficiaryId Beneficiary id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesBeneficiaryIdDelete = function (customerId, beneficiaryId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesBeneficiaryIdDelete(customerId, beneficiaryId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If data are correct - save beneficiary.
     * @summary Update beneficiary.
     * @param {number} customerId Customer id.
     * @param {number} beneficiaryId Beneficiary id
     * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesBeneficiaryIdPatch = function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesBeneficiaryIdPatch(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Confirm SMS token to  activate beneficiary.
     * @summary Confirm SMS token to activate beneficiary.
     * @param {number} customerId Customer id.
     * @param {number} beneficiaryId Beneficiary id
     * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch = function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatch(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send SMS token to customer.
     * @summary Send token to customer via SMS.
     * @param {number} customerId Customer id.
     * @param {number} beneficiaryId Beneficiary id
     * @param {CustomersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest} customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost = function (customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesBeneficiaryIdVerifyPost(customerId, beneficiaryId, customersCustomerIdBeneficiariesBeneficiaryIdVerifyPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of beneficiary relationship values.
     * @summary Get list of beneficiary relationship values.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesDictionariesRelationshipsGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesDictionariesRelationshipsGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of of customers beneficiaries.
     * @summary Get list of customers beneficiaries
     * @param {number} customerId Customer id.
     * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
     * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
     * @param {CustomersCustomerIdBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
     * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
     * @param {CustomersCustomerIdBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
     * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
     * @param {CustomersCustomerIdBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
     * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
     * @param {CustomersCustomerIdBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
     * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
     * @param {CustomersCustomerIdBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
     * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
     * @param {CustomersCustomerIdBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
     * @param {CustomersCustomerIdBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
     * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
     * @param {CustomersCustomerIdBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesGet = function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesGet(customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If data are correct - save beneficiary.
     * @summary Create beneficiary
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdBeneficiariesPostRequest} customersCustomerIdBeneficiariesPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiariesApi
     */
    BeneficiariesApi.prototype.customersCustomerIdBeneficiariesPost = function (customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BeneficiariesApiFp)(this.configuration).customersCustomerIdBeneficiariesPost(customerId, customersCustomerIdBeneficiariesPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BeneficiariesApi;
}(base_1.BaseAPI));
exports.BeneficiariesApi = BeneficiariesApi;
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetOptionsFirstnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetOptionsLastnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetOptionsCompanyNameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetOptionsEmailEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetOptionsPhoneMobileEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetFilterIsCompanyEnum = {
    _0: '0',
    _1: '1'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetFilterEwalletImportEnum = {
    _0: '0',
    _1: '1'
};
/**
 * @export
 */
exports.CustomersCustomerIdBeneficiariesGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * BlikApi - axios parameter creator
 * @export
 */
var BlikApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Validate transaction data (for now check blik santander)
         * @summary Validate transaction data
         * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionValidatedataPost: function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'amlTransactionValidatedataPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('amlTransactionValidatedataPost', 'amlTransactionValidatedataPostRequest', amlTransactionValidatedataPostRequest);
                            localVarPath = "/aml/transaction/validatedata";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(amlTransactionValidatedataPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
         * @summary Santander Cheque Blik Transaction
         * @param {SantanderChequePostRequest} santanderChequePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderChequePost: function (santanderChequePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'santanderChequePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('santanderChequePost', 'santanderChequePostRequest', santanderChequePostRequest);
                            localVarPath = "/santander/cheque";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(santanderChequePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BlikApiAxiosParamCreator = BlikApiAxiosParamCreator;
/**
 * BlikApi - functional programming interface
 * @export
 */
var BlikApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BlikApiAxiosParamCreator)(configuration);
    return {
        /**
         * Validate transaction data (for now check blik santander)
         * @summary Validate transaction data
         * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionValidatedataPost: function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlTransactionValidatedataPost(amlTransactionValidatedataPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BlikApi.amlTransactionValidatedataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
         * @summary Santander Cheque Blik Transaction
         * @param {SantanderChequePostRequest} santanderChequePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderChequePost: function (santanderChequePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.santanderChequePost(santanderChequePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BlikApi.santanderChequePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.BlikApiFp = BlikApiFp;
/**
 * BlikApi - factory interface
 * @export
 */
var BlikApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BlikApiFp)(configuration);
    return {
        /**
         * Validate transaction data (for now check blik santander)
         * @summary Validate transaction data
         * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionValidatedataPost: function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
            return localVarFp.amlTransactionValidatedataPost(amlTransactionValidatedataPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
         * @summary Santander Cheque Blik Transaction
         * @param {SantanderChequePostRequest} santanderChequePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderChequePost: function (santanderChequePostRequest, acceptLanguage, options) {
            return localVarFp.santanderChequePost(santanderChequePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BlikApiFactory = BlikApiFactory;
/**
 * BlikApi - object-oriented interface
 * @export
 * @class BlikApi
 * @extends {BaseAPI}
 */
var BlikApi = /** @class */ (function (_super) {
    __extends(BlikApi, _super);
    function BlikApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Validate transaction data (for now check blik santander)
     * @summary Validate transaction data
     * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlikApi
     */
    BlikApi.prototype.amlTransactionValidatedataPost = function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BlikApiFp)(this.configuration).amlTransactionValidatedataPost(amlTransactionValidatedataPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
     * @summary Santander Cheque Blik Transaction
     * @param {SantanderChequePostRequest} santanderChequePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlikApi
     */
    BlikApi.prototype.santanderChequePost = function (santanderChequePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.BlikApiFp)(this.configuration).santanderChequePost(santanderChequePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BlikApi;
}(base_1.BaseAPI));
exports.BlikApi = BlikApi;
/**
 * CalendarApi - axios parameter creator
 * @export
 */
var CalendarApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get of list events from calendar.
         * @summary Get list of events from calendar.
         * @param {number} customerId Customer id.
         * @param {number} sort Sort list of repeat payment.  Available sorting by: * eventDate * name  For example: &#x60;/customers/{customerId}calendarEvents?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example /customers/{customerId}/calendarEvents?page&#x3D;1.
         * @param {number} [limit] Size of result. Min is 1. For example /customers/{customerId}/calendarEvents?limit&#x3D;1.
         * @param {string} [filterEventDate] Filter by date. For example /customers/{customerId}/calendarEvents?filter[eventDate]&#x3D;2017-03-03|2017-03-03&amp;options[eventDate]&#x3D;between.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdCalendarEventsGet: function (customerId, sort, acceptLanguage, page, limit, filterEventDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdCalendarEventsGet', 'customerId', customerId);
                            // verify required parameter 'sort' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdCalendarEventsGet', 'sort', sort);
                            localVarPath = "/customers/{customerId}/calendarEvents"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (filterEventDate !== undefined) {
                                localVarQueryParameter['filter[eventDate]'] = filterEventDate;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CalendarApiAxiosParamCreator = CalendarApiAxiosParamCreator;
/**
 * CalendarApi - functional programming interface
 * @export
 */
var CalendarApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CalendarApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get of list events from calendar.
         * @summary Get list of events from calendar.
         * @param {number} customerId Customer id.
         * @param {number} sort Sort list of repeat payment.  Available sorting by: * eventDate * name  For example: &#x60;/customers/{customerId}calendarEvents?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example /customers/{customerId}/calendarEvents?page&#x3D;1.
         * @param {number} [limit] Size of result. Min is 1. For example /customers/{customerId}/calendarEvents?limit&#x3D;1.
         * @param {string} [filterEventDate] Filter by date. For example /customers/{customerId}/calendarEvents?filter[eventDate]&#x3D;2017-03-03|2017-03-03&amp;options[eventDate]&#x3D;between.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdCalendarEventsGet: function (customerId, sort, acceptLanguage, page, limit, filterEventDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdCalendarEventsGet(customerId, sort, acceptLanguage, page, limit, filterEventDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CalendarApi.customersCustomerIdCalendarEventsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CalendarApiFp = CalendarApiFp;
/**
 * CalendarApi - factory interface
 * @export
 */
var CalendarApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CalendarApiFp)(configuration);
    return {
        /**
         * Get of list events from calendar.
         * @summary Get list of events from calendar.
         * @param {number} customerId Customer id.
         * @param {number} sort Sort list of repeat payment.  Available sorting by: * eventDate * name  For example: &#x60;/customers/{customerId}calendarEvents?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example /customers/{customerId}/calendarEvents?page&#x3D;1.
         * @param {number} [limit] Size of result. Min is 1. For example /customers/{customerId}/calendarEvents?limit&#x3D;1.
         * @param {string} [filterEventDate] Filter by date. For example /customers/{customerId}/calendarEvents?filter[eventDate]&#x3D;2017-03-03|2017-03-03&amp;options[eventDate]&#x3D;between.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdCalendarEventsGet: function (customerId, sort, acceptLanguage, page, limit, filterEventDate, options) {
            return localVarFp.customersCustomerIdCalendarEventsGet(customerId, sort, acceptLanguage, page, limit, filterEventDate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CalendarApiFactory = CalendarApiFactory;
/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
var CalendarApi = /** @class */ (function (_super) {
    __extends(CalendarApi, _super);
    function CalendarApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get of list events from calendar.
     * @summary Get list of events from calendar.
     * @param {number} customerId Customer id.
     * @param {number} sort Sort list of repeat payment.  Available sorting by: * eventDate * name  For example: &#x60;/customers/{customerId}calendarEvents?sort&#x3D;name.&#x60;
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {number} [page] Number of result. Start is 1. For example /customers/{customerId}/calendarEvents?page&#x3D;1.
     * @param {number} [limit] Size of result. Min is 1. For example /customers/{customerId}/calendarEvents?limit&#x3D;1.
     * @param {string} [filterEventDate] Filter by date. For example /customers/{customerId}/calendarEvents?filter[eventDate]&#x3D;2017-03-03|2017-03-03&amp;options[eventDate]&#x3D;between.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    CalendarApi.prototype.customersCustomerIdCalendarEventsGet = function (customerId, sort, acceptLanguage, page, limit, filterEventDate, options) {
        var _this = this;
        return (0, exports.CalendarApiFp)(this.configuration).customersCustomerIdCalendarEventsGet(customerId, sort, acceptLanguage, page, limit, filterEventDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CalendarApi;
}(base_1.BaseAPI));
exports.CalendarApi = CalendarApi;
/**
 * ContactApi - axios parameter creator
 * @export
 */
var ContactApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Send message to customer service as customer.
         * @summary Send message to customer service as customer.
         * @param {number} customerId Customer id.
         * @param {ContactsBokRequestCustomerCustomerIdPostRequest} contactsBokRequestCustomerCustomerIdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsBokRequestCustomerCustomerIdPost: function (customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('contactsBokRequestCustomerCustomerIdPost', 'customerId', customerId);
                            // verify required parameter 'contactsBokRequestCustomerCustomerIdPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('contactsBokRequestCustomerCustomerIdPost', 'contactsBokRequestCustomerCustomerIdPostRequest', contactsBokRequestCustomerCustomerIdPostRequest);
                            localVarPath = "/contacts/bokRequest/customer/{customerId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactsBokRequestCustomerCustomerIdPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send message to customer service.
         * @summary Send message to customer service.
         * @param {ContactsBokRequestPostRequest} contactsBokRequestPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsBokRequestPost: function (contactsBokRequestPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contactsBokRequestPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('contactsBokRequestPost', 'contactsBokRequestPostRequest', contactsBokRequestPostRequest);
                            localVarPath = "/contacts/bokRequest";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactsBokRequestPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send call me back request to customer service as customer.
         * @summary Send call me back request to customer service as customer.
         * @param {number} customerId Customer id.
         * @param {ContactsCallMeBackCustomerCustomerIdPostRequest} contactsCallMeBackCustomerCustomerIdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCallMeBackCustomerCustomerIdPost: function (customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('contactsCallMeBackCustomerCustomerIdPost', 'customerId', customerId);
                            // verify required parameter 'contactsCallMeBackCustomerCustomerIdPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('contactsCallMeBackCustomerCustomerIdPost', 'contactsCallMeBackCustomerCustomerIdPostRequest', contactsCallMeBackCustomerCustomerIdPostRequest);
                            localVarPath = "/contacts/callMeBack/customer/{customerId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactsCallMeBackCustomerCustomerIdPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send call me back request to customer service.
         * @summary Send call me back request to customer service.
         * @param {ContactsCallMeBackPostRequest} contactsCallMeBackPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCallMeBackPost: function (contactsCallMeBackPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contactsCallMeBackPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('contactsCallMeBackPost', 'contactsCallMeBackPostRequest', contactsCallMeBackPostRequest);
                            localVarPath = "/contacts/callMeBack";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactsCallMeBackPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ContactApiAxiosParamCreator = ContactApiAxiosParamCreator;
/**
 * ContactApi - functional programming interface
 * @export
 */
var ContactApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContactApiAxiosParamCreator)(configuration);
    return {
        /**
         * Send message to customer service as customer.
         * @summary Send message to customer service as customer.
         * @param {number} customerId Customer id.
         * @param {ContactsBokRequestCustomerCustomerIdPostRequest} contactsBokRequestCustomerCustomerIdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsBokRequestCustomerCustomerIdPost: function (customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contactsBokRequestCustomerCustomerIdPost(customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactApi.contactsBokRequestCustomerCustomerIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send message to customer service.
         * @summary Send message to customer service.
         * @param {ContactsBokRequestPostRequest} contactsBokRequestPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsBokRequestPost: function (contactsBokRequestPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contactsBokRequestPost(contactsBokRequestPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactApi.contactsBokRequestPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send call me back request to customer service as customer.
         * @summary Send call me back request to customer service as customer.
         * @param {number} customerId Customer id.
         * @param {ContactsCallMeBackCustomerCustomerIdPostRequest} contactsCallMeBackCustomerCustomerIdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCallMeBackCustomerCustomerIdPost: function (customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contactsCallMeBackCustomerCustomerIdPost(customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactApi.contactsCallMeBackCustomerCustomerIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send call me back request to customer service.
         * @summary Send call me back request to customer service.
         * @param {ContactsCallMeBackPostRequest} contactsCallMeBackPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCallMeBackPost: function (contactsCallMeBackPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contactsCallMeBackPost(contactsCallMeBackPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactApi.contactsCallMeBackPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ContactApiFp = ContactApiFp;
/**
 * ContactApi - factory interface
 * @export
 */
var ContactApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContactApiFp)(configuration);
    return {
        /**
         * Send message to customer service as customer.
         * @summary Send message to customer service as customer.
         * @param {number} customerId Customer id.
         * @param {ContactsBokRequestCustomerCustomerIdPostRequest} contactsBokRequestCustomerCustomerIdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsBokRequestCustomerCustomerIdPost: function (customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options) {
            return localVarFp.contactsBokRequestCustomerCustomerIdPost(customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send message to customer service.
         * @summary Send message to customer service.
         * @param {ContactsBokRequestPostRequest} contactsBokRequestPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsBokRequestPost: function (contactsBokRequestPostRequest, acceptLanguage, options) {
            return localVarFp.contactsBokRequestPost(contactsBokRequestPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send call me back request to customer service as customer.
         * @summary Send call me back request to customer service as customer.
         * @param {number} customerId Customer id.
         * @param {ContactsCallMeBackCustomerCustomerIdPostRequest} contactsCallMeBackCustomerCustomerIdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCallMeBackCustomerCustomerIdPost: function (customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options) {
            return localVarFp.contactsCallMeBackCustomerCustomerIdPost(customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send call me back request to customer service.
         * @summary Send call me back request to customer service.
         * @param {ContactsCallMeBackPostRequest} contactsCallMeBackPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsCallMeBackPost: function (contactsCallMeBackPostRequest, acceptLanguage, options) {
            return localVarFp.contactsCallMeBackPost(contactsCallMeBackPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContactApiFactory = ContactApiFactory;
/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
var ContactApi = /** @class */ (function (_super) {
    __extends(ContactApi, _super);
    function ContactApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Send message to customer service as customer.
     * @summary Send message to customer service as customer.
     * @param {number} customerId Customer id.
     * @param {ContactsBokRequestCustomerCustomerIdPostRequest} contactsBokRequestCustomerCustomerIdPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    ContactApi.prototype.contactsBokRequestCustomerCustomerIdPost = function (customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ContactApiFp)(this.configuration).contactsBokRequestCustomerCustomerIdPost(customerId, contactsBokRequestCustomerCustomerIdPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send message to customer service.
     * @summary Send message to customer service.
     * @param {ContactsBokRequestPostRequest} contactsBokRequestPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    ContactApi.prototype.contactsBokRequestPost = function (contactsBokRequestPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ContactApiFp)(this.configuration).contactsBokRequestPost(contactsBokRequestPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send call me back request to customer service as customer.
     * @summary Send call me back request to customer service as customer.
     * @param {number} customerId Customer id.
     * @param {ContactsCallMeBackCustomerCustomerIdPostRequest} contactsCallMeBackCustomerCustomerIdPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    ContactApi.prototype.contactsCallMeBackCustomerCustomerIdPost = function (customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ContactApiFp)(this.configuration).contactsCallMeBackCustomerCustomerIdPost(customerId, contactsCallMeBackCustomerCustomerIdPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send call me back request to customer service.
     * @summary Send call me back request to customer service.
     * @param {ContactsCallMeBackPostRequest} contactsCallMeBackPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    ContactApi.prototype.contactsCallMeBackPost = function (contactsCallMeBackPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ContactApiFp)(this.configuration).contactsCallMeBackPost(contactsCallMeBackPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContactApi;
}(base_1.BaseAPI));
exports.ContactApi = ContactApi;
/**
 * CountriesApi - axios parameter creator
 * @export
 */
var CountriesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves the list of countries.
         * @summary Get list of all countries
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CountriesGetFilterTypeEnum} [filterType] Display countries depending of type. For example ?type&#x3D;ppi3 return only ppi3 countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countriesGet: function (acceptLanguage, filterType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/countries/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterType !== undefined) {
                                localVarQueryParameter['filter[type]'] = filterType;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CountriesApiAxiosParamCreator = CountriesApiAxiosParamCreator;
/**
 * CountriesApi - functional programming interface
 * @export
 */
var CountriesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CountriesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieves the list of countries.
         * @summary Get list of all countries
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CountriesGetFilterTypeEnum} [filterType] Display countries depending of type. For example ?type&#x3D;ppi3 return only ppi3 countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countriesGet: function (acceptLanguage, filterType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.countriesGet(acceptLanguage, filterType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CountriesApi.countriesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CountriesApiFp = CountriesApiFp;
/**
 * CountriesApi - factory interface
 * @export
 */
var CountriesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CountriesApiFp)(configuration);
    return {
        /**
         * Retrieves the list of countries.
         * @summary Get list of all countries
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CountriesGetFilterTypeEnum} [filterType] Display countries depending of type. For example ?type&#x3D;ppi3 return only ppi3 countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countriesGet: function (acceptLanguage, filterType, options) {
            return localVarFp.countriesGet(acceptLanguage, filterType, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CountriesApiFactory = CountriesApiFactory;
/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
var CountriesApi = /** @class */ (function (_super) {
    __extends(CountriesApi, _super);
    function CountriesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves the list of countries.
     * @summary Get list of all countries
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {CountriesGetFilterTypeEnum} [filterType] Display countries depending of type. For example ?type&#x3D;ppi3 return only ppi3 countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    CountriesApi.prototype.countriesGet = function (acceptLanguage, filterType, options) {
        var _this = this;
        return (0, exports.CountriesApiFp)(this.configuration).countriesGet(acceptLanguage, filterType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CountriesApi;
}(base_1.BaseAPI));
exports.CountriesApi = CountriesApi;
/**
 * @export
 */
exports.CountriesGetFilterTypeEnum = {
    MobileApi: 'mobile_api',
    Ppi3: 'ppi3',
    Cpanel: 'cpanel',
    Ppi: 'ppi',
    Trx: 'trx',
    Minutka: 'minutka',
    Funcik: 'funcik',
    B2b: 'b2b',
    Ewallet: 'ewallet',
    EwalletUser: 'ewallet_user'
};
/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
var CurrenciesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * The list includes input and output currencies with their ids.
         * @summary Get list of currencies in use.
         * @param {CurrenciesInGetInEnum} _in Currency \&#39;in\&#39; or \&#39;out\&#39;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesInGet: function (_in, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter '_in' is not null or undefined
                            (0, common_1.assertParamExists)('currenciesInGet', '_in', _in);
                            localVarPath = "/currencies/{in}"
                                .replace("{".concat("in", "}"), encodeURIComponent(String(_in)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CurrenciesApiAxiosParamCreator = CurrenciesApiAxiosParamCreator;
/**
 * CurrenciesApi - functional programming interface
 * @export
 */
var CurrenciesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CurrenciesApiAxiosParamCreator)(configuration);
    return {
        /**
         * The list includes input and output currencies with their ids.
         * @summary Get list of currencies in use.
         * @param {CurrenciesInGetInEnum} _in Currency \&#39;in\&#39; or \&#39;out\&#39;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesInGet: function (_in, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.currenciesInGet(_in, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CurrenciesApi.currenciesInGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CurrenciesApiFp = CurrenciesApiFp;
/**
 * CurrenciesApi - factory interface
 * @export
 */
var CurrenciesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CurrenciesApiFp)(configuration);
    return {
        /**
         * The list includes input and output currencies with their ids.
         * @summary Get list of currencies in use.
         * @param {CurrenciesInGetInEnum} _in Currency \&#39;in\&#39; or \&#39;out\&#39;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesInGet: function (_in, acceptLanguage, options) {
            return localVarFp.currenciesInGet(_in, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CurrenciesApiFactory = CurrenciesApiFactory;
/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
var CurrenciesApi = /** @class */ (function (_super) {
    __extends(CurrenciesApi, _super);
    function CurrenciesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The list includes input and output currencies with their ids.
     * @summary Get list of currencies in use.
     * @param {CurrenciesInGetInEnum} _in Currency \&#39;in\&#39; or \&#39;out\&#39;
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    CurrenciesApi.prototype.currenciesInGet = function (_in, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CurrenciesApiFp)(this.configuration).currenciesInGet(_in, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CurrenciesApi;
}(base_1.BaseAPI));
exports.CurrenciesApi = CurrenciesApi;
/**
 * @export
 */
exports.CurrenciesInGetInEnum = {
    In: 'in',
    Out: 'out'
};
/**
 * CustomerApi - axios parameter creator
 * @export
 */
var CustomerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Scan files.
         * @summary Scan files.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdScansPost: function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdScansPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdScansPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdScansPost', 'customersCustomerIdScansPostRequest', customersCustomerIdScansPostRequest);
                            localVarPath = "/customers/{customerId}/scans"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdScansPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CustomerApiAxiosParamCreator = CustomerApiAxiosParamCreator;
/**
 * CustomerApi - functional programming interface
 * @export
 */
var CustomerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Scan files.
         * @summary Scan files.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdScansPost: function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdScansPost(customerId, customersCustomerIdScansPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerApi.customersCustomerIdScansPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CustomerApiFp = CustomerApiFp;
/**
 * CustomerApi - factory interface
 * @export
 */
var CustomerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerApiFp)(configuration);
    return {
        /**
         * Scan files.
         * @summary Scan files.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdScansPost: function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdScansPost(customerId, customersCustomerIdScansPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerApiFactory = CustomerApiFactory;
/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
var CustomerApi = /** @class */ (function (_super) {
    __extends(CustomerApi, _super);
    function CustomerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Scan files.
     * @summary Scan files.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.customersCustomerIdScansPost = function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerApiFp)(this.configuration).customersCustomerIdScansPost(customerId, customersCustomerIdScansPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerApi;
}(base_1.BaseAPI));
exports.CustomerApi = CustomerApi;
/**
 * CustomerAccountApi - axios parameter creator
 * @export
 */
var CustomerAccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Method to activate an account. Should be used after user registration with token from email.
         * @summary Customer account activation
         * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersAccountActivationPost: function (customersAccountActivationPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'customersAccountActivationPostRequest' is not null or undefined
                    (0, common_1.assertParamExists)('customersAccountActivationPost', 'customersAccountActivationPostRequest', customersAccountActivationPostRequest);
                    localVarPath = "/customers/accountActivation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersAccountActivationPostRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Method to change the address
         * @summary Customer account address change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdAddressPatchRequest} customersCustomerIdAddressPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressPatch: function (customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdAddressPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdAddressPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdAddressPatch', 'customersCustomerIdAddressPatchRequest', customersCustomerIdAddressPatchRequest);
                            localVarPath = "/customers/{customerId}/address"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdAddressPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to block / remove customer account
         * @summary Request customer to block account
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdBlockAccountPatchRequest} customersCustomerIdBlockAccountPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBlockAccountPatch: function (customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBlockAccountPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdBlockAccountPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdBlockAccountPatch', 'customersCustomerIdBlockAccountPatchRequest', customersCustomerIdBlockAccountPatchRequest);
                            localVarPath = "/customers/{customerId}/blockAccount"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdBlockAccountPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrives customer exchange alert value.
         * @summary Get customer exchange alert value.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdExchangeAlertGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdExchangeAlertGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/exchangeAlert"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to set exchange alert
         * @summary Customer set exchane alert
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdExchangeAlertPostRequest} customersCustomerIdExchangeAlertPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdExchangeAlertPost: function (customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdExchangeAlertPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdExchangeAlertPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdExchangeAlertPost', 'customersCustomerIdExchangeAlertPostRequest', customersCustomerIdExchangeAlertPostRequest);
                            localVarPath = "/customers/{customerId}/exchangeAlert"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdExchangeAlertPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Save and upload file.
         * @summary Upload file.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdFilePostRequest} customersCustomerIdFilePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFilePost: function (customerId, customersCustomerIdFilePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdFilePost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdFilePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdFilePost', 'customersCustomerIdFilePostRequest', customersCustomerIdFilePostRequest);
                            localVarPath = "/customers/{customerId}/file"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdFilePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to change the
         * @summary Customer account financial
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFinancialGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdFinancialGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/financial"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to change the financial
         * @summary Customer account financial change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdFinancialPatchRequest} customersCustomerIdFinancialPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFinancialPatch: function (customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdFinancialPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdFinancialPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdFinancialPatch', 'customersCustomerIdFinancialPatchRequest', customersCustomerIdFinancialPatchRequest);
                            localVarPath = "/customers/{customerId}/financial"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdFinancialPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Change GDPR agreement.
         * @summary Change GDPR agreement
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdGdprPatchRequest} customersCustomerIdGdprPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdGdprPatch: function (customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdGdprPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdGdprPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdGdprPatch', 'customersCustomerIdGdprPatchRequest', customersCustomerIdGdprPatchRequest);
                            localVarPath = "/customers/{customerId}/gdpr"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdGdprPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves customer data. Customer session must be active.
         * @summary Get customer data.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Set user hideOnScreenGuidance preference
         * @summary Set user hideOnScreenGuidance preference
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdHideOnScreenGuidancePostRequest} customersCustomerIdHideOnScreenGuidancePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdHideOnScreenGuidancePost: function (customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdHideOnScreenGuidancePost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdHideOnScreenGuidancePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdHideOnScreenGuidancePost', 'customersCustomerIdHideOnScreenGuidancePostRequest', customersCustomerIdHideOnScreenGuidancePostRequest);
                            localVarPath = "/customers/{customerId}/hideOnScreenGuidance"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdHideOnScreenGuidancePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Change user language
         * @summary Change user language
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdLanguagePostRequest} customersCustomerIdLanguagePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdLanguagePost: function (customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdLanguagePost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdLanguagePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdLanguagePost', 'customersCustomerIdLanguagePostRequest', customersCustomerIdLanguagePostRequest);
                            localVarPath = "/customers/{customerId}/language"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdLanguagePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to change the password
         * @summary Customer account password change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPasswordPatchRequest} customersCustomerIdPasswordPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPasswordPatch: function (customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPasswordPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdPasswordPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPasswordPatch', 'customersCustomerIdPasswordPatchRequest', customersCustomerIdPasswordPatchRequest);
                            localVarPath = "/customers/{customerId}/password"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdPasswordPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Change approvals.
         * @summary Change acceptations for privacy policies, e-mail and SMS sending.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPatchRequest} customersCustomerIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPatch: function (customerId, customersCustomerIdPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPatch', 'customersCustomerIdPatchRequest', customersCustomerIdPatchRequest);
                            localVarPath = "/customers/{customerId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to send request for change the phone number
         * @summary Customer account phone number change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPhoneNumberPostRequest} customersCustomerIdPhoneNumberPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPhoneNumberPost: function (customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPhoneNumberPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdPhoneNumberPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPhoneNumberPost', 'customersCustomerIdPhoneNumberPostRequest', customersCustomerIdPhoneNumberPostRequest);
                            localVarPath = "/customers/{customerId}/phoneNumber"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdPhoneNumberPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list active promotional code.
         * @summary Get promotional codes list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
         * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPromotionCodesGet: function (customerId, acceptLanguage, filterProductId, filterCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPromotionCodesGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/promotionCodes"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterProductId !== undefined) {
                                localVarQueryParameter['filter[productId]'] = filterProductId;
                            }
                            if (filterCode !== undefined) {
                                localVarQueryParameter['filter[code]'] = filterCode;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get customer referral link.
         * @summary Get customer referral link.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralLinkGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralLinkGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/referralLink"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to confirm password reset
         * @summary Customer account password confirmed
         * @param {CustomersResetPasswordConfirmationPatchRequest} customersResetPasswordConfirmationPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersResetPasswordConfirmationPatch: function (customersResetPasswordConfirmationPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersResetPasswordConfirmationPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersResetPasswordConfirmationPatch', 'customersResetPasswordConfirmationPatchRequest', customersResetPasswordConfirmationPatchRequest);
                            localVarPath = "/customers/resetPasswordConfirmation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersResetPasswordConfirmationPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CustomerAccountApiAxiosParamCreator = CustomerAccountApiAxiosParamCreator;
/**
 * CustomerAccountApi - functional programming interface
 * @export
 */
var CustomerAccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerAccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Method to activate an account. Should be used after user registration with token from email.
         * @summary Customer account activation
         * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersAccountActivationPost: function (customersAccountActivationPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersAccountActivationPost(customersAccountActivationPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersAccountActivationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to change the address
         * @summary Customer account address change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdAddressPatchRequest} customersCustomerIdAddressPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressPatch: function (customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdAddressPatch(customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdAddressPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to block / remove customer account
         * @summary Request customer to block account
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdBlockAccountPatchRequest} customersCustomerIdBlockAccountPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBlockAccountPatch: function (customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdBlockAccountPatch(customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdBlockAccountPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Retrives customer exchange alert value.
         * @summary Get customer exchange alert value.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdExchangeAlertGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdExchangeAlertGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdExchangeAlertGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to set exchange alert
         * @summary Customer set exchane alert
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdExchangeAlertPostRequest} customersCustomerIdExchangeAlertPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdExchangeAlertPost: function (customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdExchangeAlertPost(customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdExchangeAlertPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Save and upload file.
         * @summary Upload file.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdFilePostRequest} customersCustomerIdFilePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFilePost: function (customerId, customersCustomerIdFilePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdFilePost(customerId, customersCustomerIdFilePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdFilePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to change the
         * @summary Customer account financial
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFinancialGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdFinancialGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdFinancialGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to change the financial
         * @summary Customer account financial change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdFinancialPatchRequest} customersCustomerIdFinancialPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFinancialPatch: function (customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdFinancialPatch(customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdFinancialPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Change GDPR agreement.
         * @summary Change GDPR agreement
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdGdprPatchRequest} customersCustomerIdGdprPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdGdprPatch: function (customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdGdprPatch(customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdGdprPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Retrieves customer data. Customer session must be active.
         * @summary Get customer data.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Set user hideOnScreenGuidance preference
         * @summary Set user hideOnScreenGuidance preference
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdHideOnScreenGuidancePostRequest} customersCustomerIdHideOnScreenGuidancePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdHideOnScreenGuidancePost: function (customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdHideOnScreenGuidancePost(customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdHideOnScreenGuidancePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Change user language
         * @summary Change user language
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdLanguagePostRequest} customersCustomerIdLanguagePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdLanguagePost: function (customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdLanguagePost(customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdLanguagePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to change the password
         * @summary Customer account password change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPasswordPatchRequest} customersCustomerIdPasswordPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPasswordPatch: function (customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPasswordPatch(customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdPasswordPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Change approvals.
         * @summary Change acceptations for privacy policies, e-mail and SMS sending.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPatchRequest} customersCustomerIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPatch: function (customerId, customersCustomerIdPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPatch(customerId, customersCustomerIdPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to send request for change the phone number
         * @summary Customer account phone number change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPhoneNumberPostRequest} customersCustomerIdPhoneNumberPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPhoneNumberPost: function (customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPhoneNumberPost(customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdPhoneNumberPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list active promotional code.
         * @summary Get promotional codes list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
         * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPromotionCodesGet: function (customerId, acceptLanguage, filterProductId, filterCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPromotionCodesGet(customerId, acceptLanguage, filterProductId, filterCode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdPromotionCodesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get customer referral link.
         * @summary Get customer referral link.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralLinkGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralLinkGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersCustomerIdReferralLinkGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to confirm password reset
         * @summary Customer account password confirmed
         * @param {CustomersResetPasswordConfirmationPatchRequest} customersResetPasswordConfirmationPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersResetPasswordConfirmationPatch: function (customersResetPasswordConfirmationPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersResetPasswordConfirmationPatch(customersResetPasswordConfirmationPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerAccountApi.customersResetPasswordConfirmationPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CustomerAccountApiFp = CustomerAccountApiFp;
/**
 * CustomerAccountApi - factory interface
 * @export
 */
var CustomerAccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerAccountApiFp)(configuration);
    return {
        /**
         * Method to activate an account. Should be used after user registration with token from email.
         * @summary Customer account activation
         * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersAccountActivationPost: function (customersAccountActivationPostRequest, acceptLanguage, options) {
            return localVarFp.customersAccountActivationPost(customersAccountActivationPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to change the address
         * @summary Customer account address change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdAddressPatchRequest} customersCustomerIdAddressPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressPatch: function (customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdAddressPatch(customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to block / remove customer account
         * @summary Request customer to block account
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdBlockAccountPatchRequest} customersCustomerIdBlockAccountPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBlockAccountPatch: function (customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdBlockAccountPatch(customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrives customer exchange alert value.
         * @summary Get customer exchange alert value.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdExchangeAlertGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdExchangeAlertGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to set exchange alert
         * @summary Customer set exchane alert
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdExchangeAlertPostRequest} customersCustomerIdExchangeAlertPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdExchangeAlertPost: function (customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdExchangeAlertPost(customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Save and upload file.
         * @summary Upload file.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdFilePostRequest} customersCustomerIdFilePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFilePost: function (customerId, customersCustomerIdFilePostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdFilePost(customerId, customersCustomerIdFilePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to change the
         * @summary Customer account financial
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFinancialGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdFinancialGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to change the financial
         * @summary Customer account financial change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdFinancialPatchRequest} customersCustomerIdFinancialPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdFinancialPatch: function (customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdFinancialPatch(customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change GDPR agreement.
         * @summary Change GDPR agreement
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdGdprPatchRequest} customersCustomerIdGdprPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdGdprPatch: function (customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdGdprPatch(customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves customer data. Customer session must be active.
         * @summary Get customer data.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Set user hideOnScreenGuidance preference
         * @summary Set user hideOnScreenGuidance preference
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdHideOnScreenGuidancePostRequest} customersCustomerIdHideOnScreenGuidancePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdHideOnScreenGuidancePost: function (customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdHideOnScreenGuidancePost(customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change user language
         * @summary Change user language
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdLanguagePostRequest} customersCustomerIdLanguagePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdLanguagePost: function (customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdLanguagePost(customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to change the password
         * @summary Customer account password change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPasswordPatchRequest} customersCustomerIdPasswordPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPasswordPatch: function (customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdPasswordPatch(customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change approvals.
         * @summary Change acceptations for privacy policies, e-mail and SMS sending.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPatchRequest} customersCustomerIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPatch: function (customerId, customersCustomerIdPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdPatch(customerId, customersCustomerIdPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to send request for change the phone number
         * @summary Customer account phone number change
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPhoneNumberPostRequest} customersCustomerIdPhoneNumberPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPhoneNumberPost: function (customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdPhoneNumberPost(customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list active promotional code.
         * @summary Get promotional codes list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
         * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPromotionCodesGet: function (customerId, acceptLanguage, filterProductId, filterCode, options) {
            return localVarFp.customersCustomerIdPromotionCodesGet(customerId, acceptLanguage, filterProductId, filterCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get customer referral link.
         * @summary Get customer referral link.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralLinkGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralLinkGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to confirm password reset
         * @summary Customer account password confirmed
         * @param {CustomersResetPasswordConfirmationPatchRequest} customersResetPasswordConfirmationPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersResetPasswordConfirmationPatch: function (customersResetPasswordConfirmationPatchRequest, acceptLanguage, options) {
            return localVarFp.customersResetPasswordConfirmationPatch(customersResetPasswordConfirmationPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerAccountApiFactory = CustomerAccountApiFactory;
/**
 * CustomerAccountApi - object-oriented interface
 * @export
 * @class CustomerAccountApi
 * @extends {BaseAPI}
 */
var CustomerAccountApi = /** @class */ (function (_super) {
    __extends(CustomerAccountApi, _super);
    function CustomerAccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Method to activate an account. Should be used after user registration with token from email.
     * @summary Customer account activation
     * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersAccountActivationPost = function (customersAccountActivationPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersAccountActivationPost(customersAccountActivationPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to change the address
     * @summary Customer account address change
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdAddressPatchRequest} customersCustomerIdAddressPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdAddressPatch = function (customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdAddressPatch(customerId, customersCustomerIdAddressPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to block / remove customer account
     * @summary Request customer to block account
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdBlockAccountPatchRequest} customersCustomerIdBlockAccountPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdBlockAccountPatch = function (customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdBlockAccountPatch(customerId, customersCustomerIdBlockAccountPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrives customer exchange alert value.
     * @summary Get customer exchange alert value.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdExchangeAlertGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdExchangeAlertGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to set exchange alert
     * @summary Customer set exchane alert
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdExchangeAlertPostRequest} customersCustomerIdExchangeAlertPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdExchangeAlertPost = function (customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdExchangeAlertPost(customerId, customersCustomerIdExchangeAlertPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Save and upload file.
     * @summary Upload file.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdFilePostRequest} customersCustomerIdFilePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdFilePost = function (customerId, customersCustomerIdFilePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdFilePost(customerId, customersCustomerIdFilePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to change the
     * @summary Customer account financial
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdFinancialGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdFinancialGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to change the financial
     * @summary Customer account financial change
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdFinancialPatchRequest} customersCustomerIdFinancialPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdFinancialPatch = function (customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdFinancialPatch(customerId, customersCustomerIdFinancialPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change GDPR agreement.
     * @summary Change GDPR agreement
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdGdprPatchRequest} customersCustomerIdGdprPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdGdprPatch = function (customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdGdprPatch(customerId, customersCustomerIdGdprPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves customer data. Customer session must be active.
     * @summary Get customer data.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Set user hideOnScreenGuidance preference
     * @summary Set user hideOnScreenGuidance preference
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdHideOnScreenGuidancePostRequest} customersCustomerIdHideOnScreenGuidancePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdHideOnScreenGuidancePost = function (customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdHideOnScreenGuidancePost(customerId, customersCustomerIdHideOnScreenGuidancePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change user language
     * @summary Change user language
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdLanguagePostRequest} customersCustomerIdLanguagePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdLanguagePost = function (customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdLanguagePost(customerId, customersCustomerIdLanguagePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to change the password
     * @summary Customer account password change
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdPasswordPatchRequest} customersCustomerIdPasswordPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdPasswordPatch = function (customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdPasswordPatch(customerId, customersCustomerIdPasswordPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change approvals.
     * @summary Change acceptations for privacy policies, e-mail and SMS sending.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdPatchRequest} customersCustomerIdPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdPatch = function (customerId, customersCustomerIdPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdPatch(customerId, customersCustomerIdPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to send request for change the phone number
     * @summary Customer account phone number change
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdPhoneNumberPostRequest} customersCustomerIdPhoneNumberPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdPhoneNumberPost = function (customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdPhoneNumberPost(customerId, customersCustomerIdPhoneNumberPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list active promotional code.
     * @summary Get promotional codes list.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
     * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdPromotionCodesGet = function (customerId, acceptLanguage, filterProductId, filterCode, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdPromotionCodesGet(customerId, acceptLanguage, filterProductId, filterCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get customer referral link.
     * @summary Get customer referral link.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersCustomerIdReferralLinkGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersCustomerIdReferralLinkGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to confirm password reset
     * @summary Customer account password confirmed
     * @param {CustomersResetPasswordConfirmationPatchRequest} customersResetPasswordConfirmationPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAccountApi
     */
    CustomerAccountApi.prototype.customersResetPasswordConfirmationPatch = function (customersResetPasswordConfirmationPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerAccountApiFp)(this.configuration).customersResetPasswordConfirmationPatch(customersResetPasswordConfirmationPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerAccountApi;
}(base_1.BaseAPI));
exports.CustomerAccountApi = CustomerAccountApi;
/**
 * CustomerLoginApi - axios parameter creator
 * @export
 */
var CustomerLoginApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Allows customer login by e-mail and password and get OAuth2 tokens. For \"system to system\" authentication secret key is being used.
         * @summary Proceed with customer and merchant user log in.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersLoginPostRequest} [customersLoginPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersLoginPost: function (acceptLanguage, customersLoginPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/customers/login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication DateAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 3:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersLoginPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Allows initiate reset password process for standard email/password login procedure. E-mail with activation link is sent.
         * @summary Initiate password reset process.
         * @param {CustomersPasswordPostRequest} customersPasswordPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPasswordPost: function (customersPasswordPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersPasswordPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersPasswordPost', 'customersPasswordPostRequest', customersPasswordPostRequest);
                            localVarPath = "/customers/password";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersPasswordPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Allows customer refresh session token using her refresh token.
         * @summary Refresh OAuth2 session token.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersRefreshTokenPostRequest} [customersRefreshTokenPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRefreshTokenPost: function (acceptLanguage, customersRefreshTokenPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/customers/refreshToken";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication DateAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 3:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRefreshTokenPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CustomerLoginApiAxiosParamCreator = CustomerLoginApiAxiosParamCreator;
/**
 * CustomerLoginApi - functional programming interface
 * @export
 */
var CustomerLoginApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerLoginApiAxiosParamCreator)(configuration);
    return {
        /**
         * Allows customer login by e-mail and password and get OAuth2 tokens. For \"system to system\" authentication secret key is being used.
         * @summary Proceed with customer and merchant user log in.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersLoginPostRequest} [customersLoginPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersLoginPost: function (acceptLanguage, customersLoginPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersLoginPost(acceptLanguage, customersLoginPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerLoginApi.customersLoginPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Allows initiate reset password process for standard email/password login procedure. E-mail with activation link is sent.
         * @summary Initiate password reset process.
         * @param {CustomersPasswordPostRequest} customersPasswordPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPasswordPost: function (customersPasswordPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersPasswordPost(customersPasswordPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerLoginApi.customersPasswordPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Allows customer refresh session token using her refresh token.
         * @summary Refresh OAuth2 session token.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersRefreshTokenPostRequest} [customersRefreshTokenPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRefreshTokenPost: function (acceptLanguage, customersRefreshTokenPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRefreshTokenPost(acceptLanguage, customersRefreshTokenPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CustomerLoginApi.customersRefreshTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CustomerLoginApiFp = CustomerLoginApiFp;
/**
 * CustomerLoginApi - factory interface
 * @export
 */
var CustomerLoginApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerLoginApiFp)(configuration);
    return {
        /**
         * Allows customer login by e-mail and password and get OAuth2 tokens. For \"system to system\" authentication secret key is being used.
         * @summary Proceed with customer and merchant user log in.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersLoginPostRequest} [customersLoginPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersLoginPost: function (acceptLanguage, customersLoginPostRequest, options) {
            return localVarFp.customersLoginPost(acceptLanguage, customersLoginPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Allows initiate reset password process for standard email/password login procedure. E-mail with activation link is sent.
         * @summary Initiate password reset process.
         * @param {CustomersPasswordPostRequest} customersPasswordPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPasswordPost: function (customersPasswordPostRequest, acceptLanguage, options) {
            return localVarFp.customersPasswordPost(customersPasswordPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Allows customer refresh session token using her refresh token.
         * @summary Refresh OAuth2 session token.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersRefreshTokenPostRequest} [customersRefreshTokenPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRefreshTokenPost: function (acceptLanguage, customersRefreshTokenPostRequest, options) {
            return localVarFp.customersRefreshTokenPost(acceptLanguage, customersRefreshTokenPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerLoginApiFactory = CustomerLoginApiFactory;
/**
 * CustomerLoginApi - object-oriented interface
 * @export
 * @class CustomerLoginApi
 * @extends {BaseAPI}
 */
var CustomerLoginApi = /** @class */ (function (_super) {
    __extends(CustomerLoginApi, _super);
    function CustomerLoginApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Allows customer login by e-mail and password and get OAuth2 tokens. For \"system to system\" authentication secret key is being used.
     * @summary Proceed with customer and merchant user log in.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {CustomersLoginPostRequest} [customersLoginPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerLoginApi
     */
    CustomerLoginApi.prototype.customersLoginPost = function (acceptLanguage, customersLoginPostRequest, options) {
        var _this = this;
        return (0, exports.CustomerLoginApiFp)(this.configuration).customersLoginPost(acceptLanguage, customersLoginPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Allows initiate reset password process for standard email/password login procedure. E-mail with activation link is sent.
     * @summary Initiate password reset process.
     * @param {CustomersPasswordPostRequest} customersPasswordPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerLoginApi
     */
    CustomerLoginApi.prototype.customersPasswordPost = function (customersPasswordPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.CustomerLoginApiFp)(this.configuration).customersPasswordPost(customersPasswordPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Allows customer refresh session token using her refresh token.
     * @summary Refresh OAuth2 session token.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {CustomersRefreshTokenPostRequest} [customersRefreshTokenPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerLoginApi
     */
    CustomerLoginApi.prototype.customersRefreshTokenPost = function (acceptLanguage, customersRefreshTokenPostRequest, options) {
        var _this = this;
        return (0, exports.CustomerLoginApiFp)(this.configuration).customersRefreshTokenPost(acceptLanguage, customersRefreshTokenPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerLoginApi;
}(base_1.BaseAPI));
exports.CustomerLoginApi = CustomerLoginApi;
/**
 * DevicesApi - axios parameter creator
 * @export
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Can be used to check if device is being paired with customer account.
         * @summary Gets device, paired with customer account data.
         * @param {number} customerId Customer id.
         * @param {string} deviceId Device id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdDevicesDeviceIdGet: function (customerId, deviceId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdDevicesDeviceIdGet', 'customerId', customerId);
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdDevicesDeviceIdGet', 'deviceId', deviceId);
                            localVarPath = "/customers/{customerId}/devices/{deviceId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Platform:   android   ios   windows
         * @summary Add the notify registration token.
         * @param {DevicesNotifyTokenRegisterPostRequest} devicesNotifyTokenRegisterPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesNotifyTokenRegisterPost: function (devicesNotifyTokenRegisterPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'devicesNotifyTokenRegisterPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('devicesNotifyTokenRegisterPost', 'devicesNotifyTokenRegisterPostRequest', devicesNotifyTokenRegisterPostRequest);
                            localVarPath = "/devices/notify/tokenRegister";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(devicesNotifyTokenRegisterPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Mobile device unique id will be paired with customer account. There are two possible scenarios of mobile device pairing:   1. Initiated from website (desktop) - deviceId, phoneNumber and code parameters are required.   2. Initiated from mobile application - deviceId, customerId parameters are required.
         * @summary Pair mobile device with customer account.
         * @param {DevicesPairPostRequest} devicesPairPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPairPost: function (devicesPairPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'devicesPairPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('devicesPairPost', 'devicesPairPostRequest', devicesPairPostRequest);
                            localVarPath = "/devices/pair";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(devicesPairPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Mobile device unique id will be unpaired with customer account.
         * @summary Unpair mobile device with customer account.
         * @param {DevicesUnpairPostRequest} devicesUnpairPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesUnpairPost: function (devicesUnpairPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'devicesUnpairPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('devicesUnpairPost', 'devicesUnpairPostRequest', devicesUnpairPostRequest);
                            localVarPath = "/devices/unpair";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(devicesUnpairPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 * @export
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Can be used to check if device is being paired with customer account.
         * @summary Gets device, paired with customer account data.
         * @param {number} customerId Customer id.
         * @param {string} deviceId Device id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdDevicesDeviceIdGet: function (customerId, deviceId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdDevicesDeviceIdGet(customerId, deviceId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.customersCustomerIdDevicesDeviceIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Platform:   android   ios   windows
         * @summary Add the notify registration token.
         * @param {DevicesNotifyTokenRegisterPostRequest} devicesNotifyTokenRegisterPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesNotifyTokenRegisterPost: function (devicesNotifyTokenRegisterPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesNotifyTokenRegisterPost(devicesNotifyTokenRegisterPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesNotifyTokenRegisterPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Mobile device unique id will be paired with customer account. There are two possible scenarios of mobile device pairing:   1. Initiated from website (desktop) - deviceId, phoneNumber and code parameters are required.   2. Initiated from mobile application - deviceId, customerId parameters are required.
         * @summary Pair mobile device with customer account.
         * @param {DevicesPairPostRequest} devicesPairPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPairPost: function (devicesPairPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesPairPost(devicesPairPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesPairPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Mobile device unique id will be unpaired with customer account.
         * @summary Unpair mobile device with customer account.
         * @param {DevicesUnpairPostRequest} devicesUnpairPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesUnpairPost: function (devicesUnpairPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesUnpairPost(devicesUnpairPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevicesApi.devicesUnpairPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 * @export
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicesApiFp)(configuration);
    return {
        /**
         * Can be used to check if device is being paired with customer account.
         * @summary Gets device, paired with customer account data.
         * @param {number} customerId Customer id.
         * @param {string} deviceId Device id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdDevicesDeviceIdGet: function (customerId, deviceId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdDevicesDeviceIdGet(customerId, deviceId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Platform:   android   ios   windows
         * @summary Add the notify registration token.
         * @param {DevicesNotifyTokenRegisterPostRequest} devicesNotifyTokenRegisterPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesNotifyTokenRegisterPost: function (devicesNotifyTokenRegisterPostRequest, options) {
            return localVarFp.devicesNotifyTokenRegisterPost(devicesNotifyTokenRegisterPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Mobile device unique id will be paired with customer account. There are two possible scenarios of mobile device pairing:   1. Initiated from website (desktop) - deviceId, phoneNumber and code parameters are required.   2. Initiated from mobile application - deviceId, customerId parameters are required.
         * @summary Pair mobile device with customer account.
         * @param {DevicesPairPostRequest} devicesPairPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPairPost: function (devicesPairPostRequest, acceptLanguage, options) {
            return localVarFp.devicesPairPost(devicesPairPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Mobile device unique id will be unpaired with customer account.
         * @summary Unpair mobile device with customer account.
         * @param {DevicesUnpairPostRequest} devicesUnpairPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesUnpairPost: function (devicesUnpairPostRequest, acceptLanguage, options) {
            return localVarFp.devicesUnpairPost(devicesUnpairPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Can be used to check if device is being paired with customer account.
     * @summary Gets device, paired with customer account data.
     * @param {number} customerId Customer id.
     * @param {string} deviceId Device id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.customersCustomerIdDevicesDeviceIdGet = function (customerId, deviceId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).customersCustomerIdDevicesDeviceIdGet(customerId, deviceId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Platform:   android   ios   windows
     * @summary Add the notify registration token.
     * @param {DevicesNotifyTokenRegisterPostRequest} devicesNotifyTokenRegisterPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesNotifyTokenRegisterPost = function (devicesNotifyTokenRegisterPostRequest, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesNotifyTokenRegisterPost(devicesNotifyTokenRegisterPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Mobile device unique id will be paired with customer account. There are two possible scenarios of mobile device pairing:   1. Initiated from website (desktop) - deviceId, phoneNumber and code parameters are required.   2. Initiated from mobile application - deviceId, customerId parameters are required.
     * @summary Pair mobile device with customer account.
     * @param {DevicesPairPostRequest} devicesPairPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesPairPost = function (devicesPairPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesPairPost(devicesPairPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Mobile device unique id will be unpaired with customer account.
     * @summary Unpair mobile device with customer account.
     * @param {DevicesUnpairPostRequest} devicesUnpairPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesUnpairPost = function (devicesUnpairPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesUnpairPost(devicesUnpairPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * EpanelApi - axios parameter creator
 * @export
 */
var EpanelApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get list payout exceptions.
         * @summary Get list payout exceptions.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionGet: function (acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/epanel/finance/payoutScheduleException";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete Payout Exception Schedule
         * @summary Delete Payout Exception Schedule
         * @param {string} id Id of payment exception.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionIdDelete: function (id, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('epanelFinancePayoutScheduleExceptionIdDelete', 'id', id);
                            localVarPath = "/epanel/finance/payoutScheduleException/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Edit Payout Exception Schedule
         * @summary Edit Payout Exception Schedule
         * @param {string} id Id of payment exception.
         * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionIdPatch: function (id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('epanelFinancePayoutScheduleExceptionIdPatch', 'id', id);
                            // verify required parameter 'epanelFinancePayoutScheduleExceptionPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('epanelFinancePayoutScheduleExceptionIdPatch', 'epanelFinancePayoutScheduleExceptionPostRequest', epanelFinancePayoutScheduleExceptionPostRequest);
                            localVarPath = "/epanel/finance/payoutScheduleException/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(epanelFinancePayoutScheduleExceptionPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add Payout Exception Schedule
         * @summary Add Payout Exception Schedule
         * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionPost: function (epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'epanelFinancePayoutScheduleExceptionPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('epanelFinancePayoutScheduleExceptionPost', 'epanelFinancePayoutScheduleExceptionPostRequest', epanelFinancePayoutScheduleExceptionPostRequest);
                            localVarPath = "/epanel/finance/payoutScheduleException";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(epanelFinancePayoutScheduleExceptionPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EpanelApiAxiosParamCreator = EpanelApiAxiosParamCreator;
/**
 * EpanelApi - functional programming interface
 * @export
 */
var EpanelApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EpanelApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get list payout exceptions.
         * @summary Get list payout exceptions.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionGet: function (acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.epanelFinancePayoutScheduleExceptionGet(acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EpanelApi.epanelFinancePayoutScheduleExceptionGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete Payout Exception Schedule
         * @summary Delete Payout Exception Schedule
         * @param {string} id Id of payment exception.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionIdDelete: function (id, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.epanelFinancePayoutScheduleExceptionIdDelete(id, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EpanelApi.epanelFinancePayoutScheduleExceptionIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Edit Payout Exception Schedule
         * @summary Edit Payout Exception Schedule
         * @param {string} id Id of payment exception.
         * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionIdPatch: function (id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.epanelFinancePayoutScheduleExceptionIdPatch(id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EpanelApi.epanelFinancePayoutScheduleExceptionIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add Payout Exception Schedule
         * @summary Add Payout Exception Schedule
         * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionPost: function (epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.epanelFinancePayoutScheduleExceptionPost(epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EpanelApi.epanelFinancePayoutScheduleExceptionPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EpanelApiFp = EpanelApiFp;
/**
 * EpanelApi - factory interface
 * @export
 */
var EpanelApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EpanelApiFp)(configuration);
    return {
        /**
         * Get list payout exceptions.
         * @summary Get list payout exceptions.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionGet: function (acceptLanguage, options) {
            return localVarFp.epanelFinancePayoutScheduleExceptionGet(acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete Payout Exception Schedule
         * @summary Delete Payout Exception Schedule
         * @param {string} id Id of payment exception.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionIdDelete: function (id, acceptLanguage, options) {
            return localVarFp.epanelFinancePayoutScheduleExceptionIdDelete(id, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Edit Payout Exception Schedule
         * @summary Edit Payout Exception Schedule
         * @param {string} id Id of payment exception.
         * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionIdPatch: function (id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
            return localVarFp.epanelFinancePayoutScheduleExceptionIdPatch(id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add Payout Exception Schedule
         * @summary Add Payout Exception Schedule
         * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        epanelFinancePayoutScheduleExceptionPost: function (epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
            return localVarFp.epanelFinancePayoutScheduleExceptionPost(epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EpanelApiFactory = EpanelApiFactory;
/**
 * EpanelApi - object-oriented interface
 * @export
 * @class EpanelApi
 * @extends {BaseAPI}
 */
var EpanelApi = /** @class */ (function (_super) {
    __extends(EpanelApi, _super);
    function EpanelApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get list payout exceptions.
     * @summary Get list payout exceptions.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpanelApi
     */
    EpanelApi.prototype.epanelFinancePayoutScheduleExceptionGet = function (acceptLanguage, options) {
        var _this = this;
        return (0, exports.EpanelApiFp)(this.configuration).epanelFinancePayoutScheduleExceptionGet(acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete Payout Exception Schedule
     * @summary Delete Payout Exception Schedule
     * @param {string} id Id of payment exception.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpanelApi
     */
    EpanelApi.prototype.epanelFinancePayoutScheduleExceptionIdDelete = function (id, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EpanelApiFp)(this.configuration).epanelFinancePayoutScheduleExceptionIdDelete(id, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Edit Payout Exception Schedule
     * @summary Edit Payout Exception Schedule
     * @param {string} id Id of payment exception.
     * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpanelApi
     */
    EpanelApi.prototype.epanelFinancePayoutScheduleExceptionIdPatch = function (id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EpanelApiFp)(this.configuration).epanelFinancePayoutScheduleExceptionIdPatch(id, epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add Payout Exception Schedule
     * @summary Add Payout Exception Schedule
     * @param {EpanelFinancePayoutScheduleExceptionPostRequest} epanelFinancePayoutScheduleExceptionPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpanelApi
     */
    EpanelApi.prototype.epanelFinancePayoutScheduleExceptionPost = function (epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EpanelApiFp)(this.configuration).epanelFinancePayoutScheduleExceptionPost(epanelFinancePayoutScheduleExceptionPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EpanelApi;
}(base_1.BaseAPI));
exports.EpanelApi = EpanelApi;
/**
 * EwalletApi - axios parameter creator
 * @export
 */
var EwalletApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete ewallet beneficiary. The actual customer won\'t be deleted, only customers relationship will be removed.
         * @summary Delete ewallet beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryId Ewallet Beneficiary id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete: function (customerId, ewalletBeneficiaryId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete', 'customerId', customerId);
                            // verify required parameter 'ewalletBeneficiaryId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete', 'ewalletBeneficiaryId', ewalletBeneficiaryId);
                            localVarPath = "/customers/{customerId}/ewalletBeneficiaries/{ewalletBeneficiaryId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("ewalletBeneficiaryId", "}"), encodeURIComponent(String(ewalletBeneficiaryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Confirm SMS token to activate ewallet beneficiary template.
         * @summary Confirm SMS token to activate ewallet beneficiary template.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
         * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch: function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch', 'customerId', customerId);
                            // verify required parameter 'ewalletBeneficiaryTemplate' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch', 'ewalletBeneficiaryTemplate', ewalletBeneficiaryTemplate);
                            // verify required parameter 'customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch', 'customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest', customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest);
                            localVarPath = "/customers/{customerId}/ewalletBeneficiaries/{ewalletBeneficiaryTemplate}/verify"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("ewalletBeneficiaryTemplate", "}"), encodeURIComponent(String(ewalletBeneficiaryTemplate)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send SMS token to customer.
         * @summary Verify ewallet beneficiary template via SMS.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
         * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost: function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost', 'customerId', customerId);
                            // verify required parameter 'ewalletBeneficiaryTemplate' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost', 'ewalletBeneficiaryTemplate', ewalletBeneficiaryTemplate);
                            // verify required parameter 'customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost', 'customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest', customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest);
                            localVarPath = "/customers/{customerId}/ewalletBeneficiaries/{ewalletBeneficiaryTemplate}/verify"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("ewalletBeneficiaryTemplate", "}"), encodeURIComponent(String(ewalletBeneficiaryTemplate)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get ewallet customers.
         * @summary Get ewallet customers
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
         * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesGet: function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesGet', 'customerId', customerId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesGet', 'page', page);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesGet', 'limit', limit);
                            localVarPath = "/customers/{customerId}/ewalletBeneficiaries"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filterFirstname !== undefined) {
                                localVarQueryParameter['filter[firstname]'] = filterFirstname;
                            }
                            if (optionsFirstname !== undefined) {
                                localVarQueryParameter['options[firstname]'] = optionsFirstname;
                            }
                            if (filterLastname !== undefined) {
                                localVarQueryParameter['filter[lastname]'] = filterLastname;
                            }
                            if (optionsLastname !== undefined) {
                                localVarQueryParameter['options[lastname]'] = optionsLastname;
                            }
                            if (filterCompanyName !== undefined) {
                                localVarQueryParameter['filter[company_name]'] = filterCompanyName;
                            }
                            if (optionsCompanyName !== undefined) {
                                localVarQueryParameter['options[company_name]'] = optionsCompanyName;
                            }
                            if (filterEmail !== undefined) {
                                localVarQueryParameter['filter[email]'] = filterEmail;
                            }
                            if (optionsEmail !== undefined) {
                                localVarQueryParameter['options[email]'] = optionsEmail;
                            }
                            if (filterPhoneMobile !== undefined) {
                                localVarQueryParameter['filter[phone_mobile]'] = filterPhoneMobile;
                            }
                            if (optionsPhoneMobile !== undefined) {
                                localVarQueryParameter['options[phone_mobile]'] = optionsPhoneMobile;
                            }
                            if (filterSearch !== undefined) {
                                localVarQueryParameter['filter[search]'] = filterSearch;
                            }
                            if (filterIsCompany !== undefined) {
                                localVarQueryParameter['filter[is_company]'] = filterIsCompany;
                            }
                            if (filterEwalletImport !== undefined) {
                                localVarQueryParameter['filter[ewallet_import]'] = filterEwalletImport;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If data are correct - save ewallet beneficiary template.
         * @summary Create ewallet beneficiary template
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdEwalletBeneficiariesPostRequest} customersCustomerIdEwalletBeneficiariesPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesPost: function (customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdEwalletBeneficiariesPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdEwalletBeneficiariesPost', 'customersCustomerIdEwalletBeneficiariesPostRequest', customersCustomerIdEwalletBeneficiariesPostRequest);
                            localVarPath = "/customers/{customerId}/ewalletBeneficiaries"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdEwalletBeneficiariesPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EwalletApiAxiosParamCreator = EwalletApiAxiosParamCreator;
/**
 * EwalletApi - functional programming interface
 * @export
 */
var EwalletApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EwalletApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete ewallet beneficiary. The actual customer won\'t be deleted, only customers relationship will be removed.
         * @summary Delete ewallet beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryId Ewallet Beneficiary id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete: function (customerId, ewalletBeneficiaryId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete(customerId, ewalletBeneficiaryId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EwalletApi.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Confirm SMS token to activate ewallet beneficiary template.
         * @summary Confirm SMS token to activate ewallet beneficiary template.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
         * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch: function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch(customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EwalletApi.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send SMS token to customer.
         * @summary Verify ewallet beneficiary template via SMS.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
         * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost: function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost(customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EwalletApi.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get ewallet customers.
         * @summary Get ewallet customers
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
         * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesGet: function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdEwalletBeneficiariesGet(customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EwalletApi.customersCustomerIdEwalletBeneficiariesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If data are correct - save ewallet beneficiary template.
         * @summary Create ewallet beneficiary template
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdEwalletBeneficiariesPostRequest} customersCustomerIdEwalletBeneficiariesPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesPost: function (customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdEwalletBeneficiariesPost(customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EwalletApi.customersCustomerIdEwalletBeneficiariesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EwalletApiFp = EwalletApiFp;
/**
 * EwalletApi - factory interface
 * @export
 */
var EwalletApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EwalletApiFp)(configuration);
    return {
        /**
         * Delete ewallet beneficiary. The actual customer won\'t be deleted, only customers relationship will be removed.
         * @summary Delete ewallet beneficiary.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryId Ewallet Beneficiary id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete: function (customerId, ewalletBeneficiaryId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete(customerId, ewalletBeneficiaryId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Confirm SMS token to activate ewallet beneficiary template.
         * @summary Confirm SMS token to activate ewallet beneficiary template.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
         * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch: function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch(customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send SMS token to customer.
         * @summary Verify ewallet beneficiary template via SMS.
         * @param {number} customerId Customer id.
         * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
         * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost: function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost(customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get ewallet customers.
         * @summary Get ewallet customers
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
         * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
         * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
         * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
         * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
         * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
         * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
         * @param {CustomersCustomerIdEwalletBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesGet: function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
            return localVarFp.customersCustomerIdEwalletBeneficiariesGet(customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If data are correct - save ewallet beneficiary template.
         * @summary Create ewallet beneficiary template
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdEwalletBeneficiariesPostRequest} customersCustomerIdEwalletBeneficiariesPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdEwalletBeneficiariesPost: function (customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdEwalletBeneficiariesPost(customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EwalletApiFactory = EwalletApiFactory;
/**
 * EwalletApi - object-oriented interface
 * @export
 * @class EwalletApi
 * @extends {BaseAPI}
 */
var EwalletApi = /** @class */ (function (_super) {
    __extends(EwalletApi, _super);
    function EwalletApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete ewallet beneficiary. The actual customer won\'t be deleted, only customers relationship will be removed.
     * @summary Delete ewallet beneficiary.
     * @param {number} customerId Customer id.
     * @param {number} ewalletBeneficiaryId Ewallet Beneficiary id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EwalletApi
     */
    EwalletApi.prototype.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete = function (customerId, ewalletBeneficiaryId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EwalletApiFp)(this.configuration).customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryIdDelete(customerId, ewalletBeneficiaryId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Confirm SMS token to activate ewallet beneficiary template.
     * @summary Confirm SMS token to activate ewallet beneficiary template.
     * @param {number} customerId Customer id.
     * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
     * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EwalletApi
     */
    EwalletApi.prototype.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch = function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EwalletApiFp)(this.configuration).customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatch(customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send SMS token to customer.
     * @summary Verify ewallet beneficiary template via SMS.
     * @param {number} customerId Customer id.
     * @param {number} ewalletBeneficiaryTemplate Ewallet beneficiary template id
     * @param {CustomersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest} customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EwalletApi
     */
    EwalletApi.prototype.customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost = function (customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EwalletApiFp)(this.configuration).customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPost(customerId, ewalletBeneficiaryTemplate, customersCustomerIdEwalletBeneficiariesEwalletBeneficiaryTemplateVerifyPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get ewallet customers.
     * @summary Get ewallet customers
     * @param {number} customerId Customer id.
     * @param {number} page Number of result. Start is 0. For example /customers/123/beneficiaries?page&#x3D;1.
     * @param {number} limit Size of result. Min is 1. For example /customers/123/beneficiaries?limit&#x3D;1.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterFirstname] Filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsFirstnameEnum} [optionsFirstname] Option for filter by firstname. For example /customers/123/beneficiaries?filter[firstname]&#x3D;test&amp;options[firstname]&#x3D;like.
     * @param {string} [filterLastname] Filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsLastnameEnum} [optionsLastname] Option for filter by lastname. For example /customers/123/beneficiaries?filter[lastname]&#x3D;test&amp;options[lastname]&#x3D;like.
     * @param {string} [filterCompanyName] Filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsCompanyNameEnum} [optionsCompanyName] Option for filter by company_name. For example /customers/123/beneficiaries?filter[company_name]&#x3D;test&amp;options[company_name]&#x3D;like.
     * @param {string} [filterEmail] Filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsEmailEnum} [optionsEmail] Option for filter by email. For example /customers/123/beneficiaries?filter[email]&#x3D;test&amp;options[email]&#x3D;like.
     * @param {string} [filterPhoneMobile] Filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetOptionsPhoneMobileEnum} [optionsPhoneMobile] Option for filter by phone_mobile. For example /customers/123/beneficiaries?filter[phone_mobile]&#x3D;0123&amp;options[phone_mobile]&#x3D;like.
     * @param {string} [filterSearch] Search by name or company. For example /customers/123/beneficiaries?filter[search]&#x3D;Tom will return \&#39;Tom X\&#39;, \&#39;X Tomaszewski\&#39; and \&#39;ALTOM\&#39;.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterIsCompanyEnum} [filterIsCompany] Filter by type of beneficiary. For example /customers/123/beneficiaries?filter[is_company]&#x3D;1.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetFilterEwalletImportEnum} [filterEwalletImport] Filter by ewallet_import status. Status 1 means this beneficiary was previously imported to ewallet. For example /customers/123/beneficiaries?filter[ewallet_import]&#x3D;1.
     * @param {string} [sort] Sort by beneficiary fields (firstname, lastname, search (if searching)). For example /customers/123/beneficiaries?sort&#x3D;firstname&amp;direction&#x3D;desc /customers/123/beneficiaries?filter[search]&#x3D;BoB&amp;sort&#x3D;search&amp;direction&#x3D;desc Using sort by firstname, lastname or company name can result in unexpected order of items due to fact, that search uses all these fields simultaneously.
     * @param {CustomersCustomerIdEwalletBeneficiariesGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EwalletApi
     */
    EwalletApi.prototype.customersCustomerIdEwalletBeneficiariesGet = function (customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options) {
        var _this = this;
        return (0, exports.EwalletApiFp)(this.configuration).customersCustomerIdEwalletBeneficiariesGet(customerId, page, limit, acceptLanguage, filterFirstname, optionsFirstname, filterLastname, optionsLastname, filterCompanyName, optionsCompanyName, filterEmail, optionsEmail, filterPhoneMobile, optionsPhoneMobile, filterSearch, filterIsCompany, filterEwalletImport, sort, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If data are correct - save ewallet beneficiary template.
     * @summary Create ewallet beneficiary template
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdEwalletBeneficiariesPostRequest} customersCustomerIdEwalletBeneficiariesPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EwalletApi
     */
    EwalletApi.prototype.customersCustomerIdEwalletBeneficiariesPost = function (customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.EwalletApiFp)(this.configuration).customersCustomerIdEwalletBeneficiariesPost(customerId, customersCustomerIdEwalletBeneficiariesPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EwalletApi;
}(base_1.BaseAPI));
exports.EwalletApi = EwalletApi;
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsFirstnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsLastnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsCompanyNameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsEmailEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetOptionsPhoneMobileEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetFilterIsCompanyEnum = {
    _0: '0',
    _1: '1'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetFilterEwalletImportEnum = {
    _0: '0',
    _1: '1'
};
/**
 * @export
 */
exports.CustomersCustomerIdEwalletBeneficiariesGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * FeaturesApi - axios parameter creator
 * @export
 */
var FeaturesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get feature status
         * @summary Get feature status
         * @param {string} featureName Feature name.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameCustomerCustomerIdGet: function (featureName, customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'featureName' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNameCustomerCustomerIdGet', 'featureName', featureName);
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNameCustomerCustomerIdGet', 'customerId', customerId);
                            localVarPath = "/features/{featureName}/customer/{customerId}"
                                .replace("{".concat("featureName", "}"), encodeURIComponent(String(featureName)))
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update customers of feature by changing the list to supplied one.
         * @summary Update customers of feature
         * @param {string} featureName Feature name.
         * @param {FeaturesFeatureNameCustomersPatchRequest} featuresFeatureNameCustomersPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameCustomersPatch: function (featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'featureName' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNameCustomersPatch', 'featureName', featureName);
                            // verify required parameter 'featuresFeatureNameCustomersPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNameCustomersPatch', 'featuresFeatureNameCustomersPatchRequest', featuresFeatureNameCustomersPatchRequest);
                            localVarPath = "/features/{featureName}/customers"
                                .replace("{".concat("featureName", "}"), encodeURIComponent(String(featureName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(featuresFeatureNameCustomersPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get feature status
         * @summary Get feature status
         * @param {string} featureName Feature name.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameGet: function (featureName, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'featureName' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNameGet', 'featureName', featureName);
                            localVarPath = "/features/{featureName}"
                                .replace("{".concat("featureName", "}"), encodeURIComponent(String(featureName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Change feature status
         * @summary Change feature status
         * @param {string} featureName Feature name.
         * @param {FeaturesFeatureNamePatchRequest} featuresFeatureNamePatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNamePatch: function (featureName, featuresFeatureNamePatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'featureName' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNamePatch', 'featureName', featureName);
                            // verify required parameter 'featuresFeatureNamePatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('featuresFeatureNamePatch', 'featuresFeatureNamePatchRequest', featuresFeatureNamePatchRequest);
                            localVarPath = "/features/{featureName}"
                                .replace("{".concat("featureName", "}"), encodeURIComponent(String(featureName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(featuresFeatureNamePatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get features details
         * @summary Get all features
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: function (acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/features";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FeaturesApiAxiosParamCreator = FeaturesApiAxiosParamCreator;
/**
 * FeaturesApi - functional programming interface
 * @export
 */
var FeaturesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FeaturesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get feature status
         * @summary Get feature status
         * @param {string} featureName Feature name.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameCustomerCustomerIdGet: function (featureName, customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.featuresFeatureNameCustomerCustomerIdGet(featureName, customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FeaturesApi.featuresFeatureNameCustomerCustomerIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update customers of feature by changing the list to supplied one.
         * @summary Update customers of feature
         * @param {string} featureName Feature name.
         * @param {FeaturesFeatureNameCustomersPatchRequest} featuresFeatureNameCustomersPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameCustomersPatch: function (featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.featuresFeatureNameCustomersPatch(featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FeaturesApi.featuresFeatureNameCustomersPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get feature status
         * @summary Get feature status
         * @param {string} featureName Feature name.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameGet: function (featureName, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.featuresFeatureNameGet(featureName, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FeaturesApi.featuresFeatureNameGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Change feature status
         * @summary Change feature status
         * @param {string} featureName Feature name.
         * @param {FeaturesFeatureNamePatchRequest} featuresFeatureNamePatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNamePatch: function (featureName, featuresFeatureNamePatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.featuresFeatureNamePatch(featureName, featuresFeatureNamePatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FeaturesApi.featuresFeatureNamePatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get features details
         * @summary Get all features
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: function (acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.featuresGet(acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FeaturesApi.featuresGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FeaturesApiFp = FeaturesApiFp;
/**
 * FeaturesApi - factory interface
 * @export
 */
var FeaturesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FeaturesApiFp)(configuration);
    return {
        /**
         * Get feature status
         * @summary Get feature status
         * @param {string} featureName Feature name.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameCustomerCustomerIdGet: function (featureName, customerId, acceptLanguage, options) {
            return localVarFp.featuresFeatureNameCustomerCustomerIdGet(featureName, customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update customers of feature by changing the list to supplied one.
         * @summary Update customers of feature
         * @param {string} featureName Feature name.
         * @param {FeaturesFeatureNameCustomersPatchRequest} featuresFeatureNameCustomersPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameCustomersPatch: function (featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options) {
            return localVarFp.featuresFeatureNameCustomersPatch(featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get feature status
         * @summary Get feature status
         * @param {string} featureName Feature name.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNameGet: function (featureName, acceptLanguage, options) {
            return localVarFp.featuresFeatureNameGet(featureName, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change feature status
         * @summary Change feature status
         * @param {string} featureName Feature name.
         * @param {FeaturesFeatureNamePatchRequest} featuresFeatureNamePatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresFeatureNamePatch: function (featureName, featuresFeatureNamePatchRequest, acceptLanguage, options) {
            return localVarFp.featuresFeatureNamePatch(featureName, featuresFeatureNamePatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get features details
         * @summary Get all features
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: function (acceptLanguage, options) {
            return localVarFp.featuresGet(acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FeaturesApiFactory = FeaturesApiFactory;
/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
var FeaturesApi = /** @class */ (function (_super) {
    __extends(FeaturesApi, _super);
    function FeaturesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get feature status
     * @summary Get feature status
     * @param {string} featureName Feature name.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    FeaturesApi.prototype.featuresFeatureNameCustomerCustomerIdGet = function (featureName, customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.FeaturesApiFp)(this.configuration).featuresFeatureNameCustomerCustomerIdGet(featureName, customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update customers of feature by changing the list to supplied one.
     * @summary Update customers of feature
     * @param {string} featureName Feature name.
     * @param {FeaturesFeatureNameCustomersPatchRequest} featuresFeatureNameCustomersPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    FeaturesApi.prototype.featuresFeatureNameCustomersPatch = function (featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.FeaturesApiFp)(this.configuration).featuresFeatureNameCustomersPatch(featureName, featuresFeatureNameCustomersPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get feature status
     * @summary Get feature status
     * @param {string} featureName Feature name.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    FeaturesApi.prototype.featuresFeatureNameGet = function (featureName, acceptLanguage, options) {
        var _this = this;
        return (0, exports.FeaturesApiFp)(this.configuration).featuresFeatureNameGet(featureName, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change feature status
     * @summary Change feature status
     * @param {string} featureName Feature name.
     * @param {FeaturesFeatureNamePatchRequest} featuresFeatureNamePatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    FeaturesApi.prototype.featuresFeatureNamePatch = function (featureName, featuresFeatureNamePatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.FeaturesApiFp)(this.configuration).featuresFeatureNamePatch(featureName, featuresFeatureNamePatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get features details
     * @summary Get all features
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    FeaturesApi.prototype.featuresGet = function (acceptLanguage, options) {
        var _this = this;
        return (0, exports.FeaturesApiFp)(this.configuration).featuresGet(acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeaturesApi;
}(base_1.BaseAPI));
exports.FeaturesApi = FeaturesApi;
/**
 * FileApi - axios parameter creator
 * @export
 */
var FileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Scan files.
         * @summary Scan files.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdScansPost: function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdScansPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdScansPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdScansPost', 'customersCustomerIdScansPostRequest', customersCustomerIdScansPostRequest);
                            localVarPath = "/customers/{customerId}/scans"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdScansPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FileApiAxiosParamCreator = FileApiAxiosParamCreator;
/**
 * FileApi - functional programming interface
 * @export
 */
var FileApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FileApiAxiosParamCreator)(configuration);
    return {
        /**
         * Scan files.
         * @summary Scan files.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdScansPost: function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdScansPost(customerId, customersCustomerIdScansPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FileApi.customersCustomerIdScansPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FileApiFp = FileApiFp;
/**
 * FileApi - factory interface
 * @export
 */
var FileApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FileApiFp)(configuration);
    return {
        /**
         * Scan files.
         * @summary Scan files.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdScansPost: function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdScansPost(customerId, customersCustomerIdScansPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FileApiFactory = FileApiFactory;
/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
var FileApi = /** @class */ (function (_super) {
    __extends(FileApi, _super);
    function FileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Scan files.
     * @summary Scan files.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdScansPostRequest} customersCustomerIdScansPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    FileApi.prototype.customersCustomerIdScansPost = function (customerId, customersCustomerIdScansPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.FileApiFp)(this.configuration).customersCustomerIdScansPost(customerId, customersCustomerIdScansPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FileApi;
}(base_1.BaseAPI));
exports.FileApi = FileApi;
/**
 * GlobalPaymentApi - axios parameter creator
 * @export
 */
var GlobalPaymentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Webhook about global payment.
         * @summary Webhook about global payment.
         * @param {GlobalPaymentWebhookPostRequest} [globalPaymentWebhookPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalPaymentWebhookPost: function (globalPaymentWebhookPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/globalPayment/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(globalPaymentWebhookPostRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GlobalPaymentApiAxiosParamCreator = GlobalPaymentApiAxiosParamCreator;
/**
 * GlobalPaymentApi - functional programming interface
 * @export
 */
var GlobalPaymentApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GlobalPaymentApiAxiosParamCreator)(configuration);
    return {
        /**
         * Webhook about global payment.
         * @summary Webhook about global payment.
         * @param {GlobalPaymentWebhookPostRequest} [globalPaymentWebhookPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalPaymentWebhookPost: function (globalPaymentWebhookPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.globalPaymentWebhookPost(globalPaymentWebhookPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['GlobalPaymentApi.globalPaymentWebhookPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.GlobalPaymentApiFp = GlobalPaymentApiFp;
/**
 * GlobalPaymentApi - factory interface
 * @export
 */
var GlobalPaymentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GlobalPaymentApiFp)(configuration);
    return {
        /**
         * Webhook about global payment.
         * @summary Webhook about global payment.
         * @param {GlobalPaymentWebhookPostRequest} [globalPaymentWebhookPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalPaymentWebhookPost: function (globalPaymentWebhookPostRequest, options) {
            return localVarFp.globalPaymentWebhookPost(globalPaymentWebhookPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GlobalPaymentApiFactory = GlobalPaymentApiFactory;
/**
 * GlobalPaymentApi - object-oriented interface
 * @export
 * @class GlobalPaymentApi
 * @extends {BaseAPI}
 */
var GlobalPaymentApi = /** @class */ (function (_super) {
    __extends(GlobalPaymentApi, _super);
    function GlobalPaymentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Webhook about global payment.
     * @summary Webhook about global payment.
     * @param {GlobalPaymentWebhookPostRequest} [globalPaymentWebhookPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalPaymentApi
     */
    GlobalPaymentApi.prototype.globalPaymentWebhookPost = function (globalPaymentWebhookPostRequest, options) {
        var _this = this;
        return (0, exports.GlobalPaymentApiFp)(this.configuration).globalPaymentWebhookPost(globalPaymentWebhookPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GlobalPaymentApi;
}(base_1.BaseAPI));
exports.GlobalPaymentApi = GlobalPaymentApi;
/**
 * LimitApi - axios parameter creator
 * @export
 */
var LimitApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get customer limit.
         * @summary Get customer limit
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdLimitGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdLimitGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/limit"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LimitApiAxiosParamCreator = LimitApiAxiosParamCreator;
/**
 * LimitApi - functional programming interface
 * @export
 */
var LimitApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LimitApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get customer limit.
         * @summary Get customer limit
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdLimitGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdLimitGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LimitApi.customersCustomerIdLimitGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LimitApiFp = LimitApiFp;
/**
 * LimitApi - factory interface
 * @export
 */
var LimitApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LimitApiFp)(configuration);
    return {
        /**
         * Get customer limit.
         * @summary Get customer limit
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdLimitGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdLimitGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LimitApiFactory = LimitApiFactory;
/**
 * LimitApi - object-oriented interface
 * @export
 * @class LimitApi
 * @extends {BaseAPI}
 */
var LimitApi = /** @class */ (function (_super) {
    __extends(LimitApi, _super);
    function LimitApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get customer limit.
     * @summary Get customer limit
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LimitApi
     */
    LimitApi.prototype.customersCustomerIdLimitGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.LimitApiFp)(this.configuration).customersCustomerIdLimitGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LimitApi;
}(base_1.BaseAPI));
exports.LimitApi = LimitApi;
/**
 * LiveApi - axios parameter creator
 * @export
 */
var LiveApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Live Transaction check bank availability
         * @summary Live Transaction check bank availability
         * @param {string} bankAccountNumber Iban bank account number
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveBankAvailabilityBankAccountNumberGet: function (bankAccountNumber, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bankAccountNumber' is not null or undefined
                            (0, common_1.assertParamExists)('liveBankAvailabilityBankAccountNumberGet', 'bankAccountNumber', bankAccountNumber);
                            localVarPath = "/live/bankAvailability/{bankAccountNumber}"
                                .replace("{".concat("bankAccountNumber", "}"), encodeURIComponent(String(bankAccountNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to confirm live transaction
         * @summary Live Transaction Confirm
         * @param {LiveTransactionConfirmPatchRequest} liveTransactionConfirmPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveTransactionConfirmPatch: function (liveTransactionConfirmPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'liveTransactionConfirmPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('liveTransactionConfirmPatch', 'liveTransactionConfirmPatchRequest', liveTransactionConfirmPatchRequest);
                            localVarPath = "/live/transactionConfirm";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liveTransactionConfirmPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to create live transaction
         * @summary Live Transaction Create
         * @param {LiveTransactionCreatePostRequest} liveTransactionCreatePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveTransactionCreatePost: function (liveTransactionCreatePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'liveTransactionCreatePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('liveTransactionCreatePost', 'liveTransactionCreatePostRequest', liveTransactionCreatePostRequest);
                            localVarPath = "/live/transactionCreate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liveTransactionCreatePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LiveApiAxiosParamCreator = LiveApiAxiosParamCreator;
/**
 * LiveApi - functional programming interface
 * @export
 */
var LiveApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LiveApiAxiosParamCreator)(configuration);
    return {
        /**
         * Live Transaction check bank availability
         * @summary Live Transaction check bank availability
         * @param {string} bankAccountNumber Iban bank account number
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveBankAvailabilityBankAccountNumberGet: function (bankAccountNumber, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.liveBankAvailabilityBankAccountNumberGet(bankAccountNumber, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LiveApi.liveBankAvailabilityBankAccountNumberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to confirm live transaction
         * @summary Live Transaction Confirm
         * @param {LiveTransactionConfirmPatchRequest} liveTransactionConfirmPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveTransactionConfirmPatch: function (liveTransactionConfirmPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.liveTransactionConfirmPatch(liveTransactionConfirmPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LiveApi.liveTransactionConfirmPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to create live transaction
         * @summary Live Transaction Create
         * @param {LiveTransactionCreatePostRequest} liveTransactionCreatePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveTransactionCreatePost: function (liveTransactionCreatePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.liveTransactionCreatePost(liveTransactionCreatePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LiveApi.liveTransactionCreatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LiveApiFp = LiveApiFp;
/**
 * LiveApi - factory interface
 * @export
 */
var LiveApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LiveApiFp)(configuration);
    return {
        /**
         * Live Transaction check bank availability
         * @summary Live Transaction check bank availability
         * @param {string} bankAccountNumber Iban bank account number
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveBankAvailabilityBankAccountNumberGet: function (bankAccountNumber, acceptLanguage, options) {
            return localVarFp.liveBankAvailabilityBankAccountNumberGet(bankAccountNumber, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to confirm live transaction
         * @summary Live Transaction Confirm
         * @param {LiveTransactionConfirmPatchRequest} liveTransactionConfirmPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveTransactionConfirmPatch: function (liveTransactionConfirmPatchRequest, acceptLanguage, options) {
            return localVarFp.liveTransactionConfirmPatch(liveTransactionConfirmPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to create live transaction
         * @summary Live Transaction Create
         * @param {LiveTransactionCreatePostRequest} liveTransactionCreatePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveTransactionCreatePost: function (liveTransactionCreatePostRequest, acceptLanguage, options) {
            return localVarFp.liveTransactionCreatePost(liveTransactionCreatePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LiveApiFactory = LiveApiFactory;
/**
 * LiveApi - object-oriented interface
 * @export
 * @class LiveApi
 * @extends {BaseAPI}
 */
var LiveApi = /** @class */ (function (_super) {
    __extends(LiveApi, _super);
    function LiveApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Live Transaction check bank availability
     * @summary Live Transaction check bank availability
     * @param {string} bankAccountNumber Iban bank account number
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    LiveApi.prototype.liveBankAvailabilityBankAccountNumberGet = function (bankAccountNumber, acceptLanguage, options) {
        var _this = this;
        return (0, exports.LiveApiFp)(this.configuration).liveBankAvailabilityBankAccountNumberGet(bankAccountNumber, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to confirm live transaction
     * @summary Live Transaction Confirm
     * @param {LiveTransactionConfirmPatchRequest} liveTransactionConfirmPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    LiveApi.prototype.liveTransactionConfirmPatch = function (liveTransactionConfirmPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.LiveApiFp)(this.configuration).liveTransactionConfirmPatch(liveTransactionConfirmPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to create live transaction
     * @summary Live Transaction Create
     * @param {LiveTransactionCreatePostRequest} liveTransactionCreatePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveApi
     */
    LiveApi.prototype.liveTransactionCreatePost = function (liveTransactionCreatePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.LiveApiFp)(this.configuration).liveTransactionCreatePost(liveTransactionCreatePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LiveApi;
}(base_1.BaseAPI));
exports.LiveApi = LiveApi;
/**
 * PaymentCardsApi - axios parameter creator
 * @export
 */
var PaymentCardsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete card.
         * @summary Delete card.
         * @param {number} customerId Customer id.
         * @param {number} cardId Card id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsCardIdDelete: function (customerId, cardId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsCardIdDelete', 'customerId', customerId);
                            // verify required parameter 'cardId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsCardIdDelete', 'cardId', cardId);
                            localVarPath = "/customers/{customerId}/paymentCards/{cardId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("cardId", "}"), encodeURIComponent(String(cardId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Customer\'s payment cards list. Filtering allowed.
         * @summary Get customer\'s payment cards list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterCardType] Optional filter by payment card type,  for example /customers/123/paymentsCards?filter[cardType]&#x3D;DELTA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsGet: function (customerId, acceptLanguage, filterCardType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/paymentCards"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterCardType !== undefined) {
                                localVarQueryParameter['filter[cardType]'] = filterCardType;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add card token via 1£ payment
         * @summary Add card token via 1£ payment
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPaymentCardsPostRequest} customersCustomerIdPaymentCardsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsPost: function (customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdPaymentCardsPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsPost', 'customersCustomerIdPaymentCardsPostRequest', customersCustomerIdPaymentCardsPostRequest);
                            localVarPath = "/customers/{customerId}/paymentCards"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdPaymentCardsPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Card verification with remote card operator
         * @summary Card verification.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPaymentCardsVerificationPostRequest} customersCustomerIdPaymentCardsVerificationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsVerificationPost: function (customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsVerificationPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdPaymentCardsVerificationPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPaymentCardsVerificationPost', 'customersCustomerIdPaymentCardsVerificationPostRequest', customersCustomerIdPaymentCardsVerificationPostRequest);
                            localVarPath = "/customers/{customerId}/paymentCards/verification"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdPaymentCardsVerificationPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PaymentCardsApiAxiosParamCreator = PaymentCardsApiAxiosParamCreator;
/**
 * PaymentCardsApi - functional programming interface
 * @export
 */
var PaymentCardsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PaymentCardsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete card.
         * @summary Delete card.
         * @param {number} customerId Customer id.
         * @param {number} cardId Card id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsCardIdDelete: function (customerId, cardId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPaymentCardsCardIdDelete(customerId, cardId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PaymentCardsApi.customersCustomerIdPaymentCardsCardIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Customer\'s payment cards list. Filtering allowed.
         * @summary Get customer\'s payment cards list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterCardType] Optional filter by payment card type,  for example /customers/123/paymentsCards?filter[cardType]&#x3D;DELTA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsGet: function (customerId, acceptLanguage, filterCardType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPaymentCardsGet(customerId, acceptLanguage, filterCardType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PaymentCardsApi.customersCustomerIdPaymentCardsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add card token via 1£ payment
         * @summary Add card token via 1£ payment
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPaymentCardsPostRequest} customersCustomerIdPaymentCardsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsPost: function (customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPaymentCardsPost(customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PaymentCardsApi.customersCustomerIdPaymentCardsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Card verification with remote card operator
         * @summary Card verification.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPaymentCardsVerificationPostRequest} customersCustomerIdPaymentCardsVerificationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsVerificationPost: function (customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPaymentCardsVerificationPost(customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PaymentCardsApi.customersCustomerIdPaymentCardsVerificationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PaymentCardsApiFp = PaymentCardsApiFp;
/**
 * PaymentCardsApi - factory interface
 * @export
 */
var PaymentCardsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PaymentCardsApiFp)(configuration);
    return {
        /**
         * Delete card.
         * @summary Delete card.
         * @param {number} customerId Customer id.
         * @param {number} cardId Card id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsCardIdDelete: function (customerId, cardId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdPaymentCardsCardIdDelete(customerId, cardId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Customer\'s payment cards list. Filtering allowed.
         * @summary Get customer\'s payment cards list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterCardType] Optional filter by payment card type,  for example /customers/123/paymentsCards?filter[cardType]&#x3D;DELTA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsGet: function (customerId, acceptLanguage, filterCardType, options) {
            return localVarFp.customersCustomerIdPaymentCardsGet(customerId, acceptLanguage, filterCardType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add card token via 1£ payment
         * @summary Add card token via 1£ payment
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPaymentCardsPostRequest} customersCustomerIdPaymentCardsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsPost: function (customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdPaymentCardsPost(customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Card verification with remote card operator
         * @summary Card verification.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdPaymentCardsVerificationPostRequest} customersCustomerIdPaymentCardsVerificationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPaymentCardsVerificationPost: function (customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdPaymentCardsVerificationPost(customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PaymentCardsApiFactory = PaymentCardsApiFactory;
/**
 * PaymentCardsApi - object-oriented interface
 * @export
 * @class PaymentCardsApi
 * @extends {BaseAPI}
 */
var PaymentCardsApi = /** @class */ (function (_super) {
    __extends(PaymentCardsApi, _super);
    function PaymentCardsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete card.
     * @summary Delete card.
     * @param {number} customerId Customer id.
     * @param {number} cardId Card id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardsApi
     */
    PaymentCardsApi.prototype.customersCustomerIdPaymentCardsCardIdDelete = function (customerId, cardId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.PaymentCardsApiFp)(this.configuration).customersCustomerIdPaymentCardsCardIdDelete(customerId, cardId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Customer\'s payment cards list. Filtering allowed.
     * @summary Get customer\'s payment cards list.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterCardType] Optional filter by payment card type,  for example /customers/123/paymentsCards?filter[cardType]&#x3D;DELTA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardsApi
     */
    PaymentCardsApi.prototype.customersCustomerIdPaymentCardsGet = function (customerId, acceptLanguage, filterCardType, options) {
        var _this = this;
        return (0, exports.PaymentCardsApiFp)(this.configuration).customersCustomerIdPaymentCardsGet(customerId, acceptLanguage, filterCardType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add card token via 1£ payment
     * @summary Add card token via 1£ payment
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdPaymentCardsPostRequest} customersCustomerIdPaymentCardsPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardsApi
     */
    PaymentCardsApi.prototype.customersCustomerIdPaymentCardsPost = function (customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.PaymentCardsApiFp)(this.configuration).customersCustomerIdPaymentCardsPost(customerId, customersCustomerIdPaymentCardsPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Card verification with remote card operator
     * @summary Card verification.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdPaymentCardsVerificationPostRequest} customersCustomerIdPaymentCardsVerificationPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardsApi
     */
    PaymentCardsApi.prototype.customersCustomerIdPaymentCardsVerificationPost = function (customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.PaymentCardsApiFp)(this.configuration).customersCustomerIdPaymentCardsVerificationPost(customerId, customersCustomerIdPaymentCardsVerificationPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PaymentCardsApi;
}(base_1.BaseAPI));
exports.PaymentCardsApi = PaymentCardsApi;
/**
 * ProductsApi - axios parameter creator
 * @export
 */
var ProductsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * List of products for logged user.
         * @summary Get list of products for logged user
         * @param {number} customerId Customer id.
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdProductsLoggedGet: function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdProductsLoggedGet', 'customerId', customerId);
                            // verify required parameter 'filterCurrencyIn' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdProductsLoggedGet', 'filterCurrencyIn', filterCurrencyIn);
                            // verify required parameter 'filterCurrencyOut' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdProductsLoggedGet', 'filterCurrencyOut', filterCurrencyOut);
                            localVarPath = "/customers/{customerId}/products/logged"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterCurrencyIn !== undefined) {
                                localVarQueryParameter['filter[currencyIn]'] = filterCurrencyIn;
                            }
                            if (filterCurrencyOut !== undefined) {
                                localVarQueryParameter['filter[currencyOut]'] = filterCurrencyOut;
                            }
                            if (filterProductType !== undefined) {
                                localVarQueryParameter['filter[productType]'] = filterProductType;
                            }
                            if (filterClientType !== undefined) {
                                localVarQueryParameter['filter[clientType]'] = filterClientType;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Calculator.
         * @summary Calculator
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCalculatorPost: function (acceptLanguage, productsCalculatorPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/products/calculator";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productsCalculatorPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ProductsApiAxiosParamCreator = ProductsApiAxiosParamCreator;
/**
 * ProductsApi - functional programming interface
 * @export
 */
var ProductsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProductsApiAxiosParamCreator)(configuration);
    return {
        /**
         * List of products for logged user.
         * @summary Get list of products for logged user
         * @param {number} customerId Customer id.
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdProductsLoggedGet: function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdProductsLoggedGet(customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductsApi.customersCustomerIdProductsLoggedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Calculator.
         * @summary Calculator
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCalculatorPost: function (acceptLanguage, productsCalculatorPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsCalculatorPost(acceptLanguage, productsCalculatorPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductsApi.productsCalculatorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ProductsApiFp = ProductsApiFp;
/**
 * ProductsApi - factory interface
 * @export
 */
var ProductsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProductsApiFp)(configuration);
    return {
        /**
         * List of products for logged user.
         * @summary Get list of products for logged user
         * @param {number} customerId Customer id.
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdProductsLoggedGet: function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            return localVarFp.customersCustomerIdProductsLoggedGet(customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Calculator.
         * @summary Calculator
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCalculatorPost: function (acceptLanguage, productsCalculatorPostRequest, options) {
            return localVarFp.productsCalculatorPost(acceptLanguage, productsCalculatorPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProductsApiFactory = ProductsApiFactory;
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List of products for logged user.
     * @summary Get list of products for logged user
     * @param {number} customerId Customer id.
     * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
     * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
     * @param {ClientType} [filterClientType] Display products by client type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.customersCustomerIdProductsLoggedGet = function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).customersCustomerIdProductsLoggedGet(customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Calculator.
     * @summary Calculator
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.productsCalculatorPost = function (acceptLanguage, productsCalculatorPostRequest, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).productsCalculatorPost(acceptLanguage, productsCalculatorPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductsApi;
}(base_1.BaseAPI));
exports.ProductsApi = ProductsApi;
/**
 * ReferralSystemApi - axios parameter creator
 * @export
 */
var ReferralSystemApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get RFA details (money, status) for transaction
         * @summary Get RFA details for transaction
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCustomerIdReferralsTransactionTransactionIdGet: function (customerId, transactionId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customerCustomerIdReferralsTransactionTransactionIdGet', 'customerId', customerId);
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('customerCustomerIdReferralsTransactionTransactionIdGet', 'transactionId', transactionId);
                            localVarPath = "/customer/{customerId}/referrals/transaction/{transactionId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get customer referral code
         * @summary Get customer referral code
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/referrals"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get invitation for specific {invitationType} type.
         * @summary Get invitation to send
         * @param {number} customerId Customer id.
         * @param {string} invitationType Invitation type.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsInvitationInvitationTypeGet: function (customerId, invitationType, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsInvitationInvitationTypeGet', 'customerId', customerId);
                            // verify required parameter 'invitationType' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsInvitationInvitationTypeGet', 'invitationType', invitationType);
                            localVarPath = "/customers/{customerId}/referrals/invitation/{invitationType}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("invitationType", "}"), encodeURIComponent(String(invitationType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get invitees count for inviter with optional filter by status
         * @summary Get invitees count for inviter
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterStatus] Filter by invitee status, for example /customers/123/referrals/invitee/count?filter[status]&#x3D;active. Allowed statuses: awaiting_activation, active, threshold_fulfilled, expired
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsInviteeCountGet: function (customerId, acceptLanguage, filterStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsInviteeCountGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/referrals/invitee/count"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterStatus !== undefined) {
                                localVarQueryParameter['filter[status]'] = filterStatus;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate unique code used to invite people. One per customer.
         * @summary Generate referral code
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsPostRequest} customersCustomerIdReferralsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsPost: function (customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdReferralsPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsPost', 'customersCustomerIdReferralsPostRequest', customersCustomerIdReferralsPostRequest);
                            localVarPath = "/customers/{customerId}/referrals"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdReferralsPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Referral Founds Account actual balance. Cached for 10 seconds.
         * @summary Get Referral Founds Account actual balance
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalanceGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsRfaBalanceGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/referrals/rfa/balance"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Release or abort blocked funds on RFA
         * @summary Release or abort blocked funds on RFA
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsRfaBalancePatchRequest} customersCustomerIdReferralsRfaBalancePatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalancePatch: function (customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsRfaBalancePatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdReferralsRfaBalancePatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsRfaBalancePatch', 'customersCustomerIdReferralsRfaBalancePatchRequest', customersCustomerIdReferralsRfaBalancePatchRequest);
                            localVarPath = "/customers/{customerId}/referrals/rfa/balance"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdReferralsRfaBalancePatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Start using money from RFA (blocking funds). Endpoint for external applications such as PPI. Within this API much more convenient is to use field \"referralFoundsAccountMoney\" in:  ``` PATCH /customers/{customerId}/transactions ```
         * @summary Initiate Referral Founds Account Usage
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsRfaBalancePostRequest} customersCustomerIdReferralsRfaBalancePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalancePost: function (customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsRfaBalancePost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdReferralsRfaBalancePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsRfaBalancePost', 'customersCustomerIdReferralsRfaBalancePostRequest', customersCustomerIdReferralsRfaBalancePostRequest);
                            localVarPath = "/customers/{customerId}/referrals/rfa/balance"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdReferralsRfaBalancePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Referral Founds Account operations list. Cached for 10 seconds.
         * @summary Get Referral Founds Account operations list
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaOperationsGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdReferralsRfaOperationsGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/referrals/rfa/operations"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get inviter groups list with awards
         * @summary Get inviter groups list
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsGroupGet: function (acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/referrals/group";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * One of main keys is required - for example \"inviteeMoneyAward\"
         * @summary Update group settings
         * @param {string} groupId Group ID.
         * @param {ReferralsGroupGroupIdPatchRequest} referralsGroupGroupIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsGroupGroupIdPatch: function (groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('referralsGroupGroupIdPatch', 'groupId', groupId);
                            // verify required parameter 'referralsGroupGroupIdPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('referralsGroupGroupIdPatch', 'referralsGroupGroupIdPatchRequest', referralsGroupGroupIdPatchRequest);
                            localVarPath = "/referrals/group/{groupId}"
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(referralsGroupGroupIdPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check code existence
         * @summary Validate invitation code
         * @param {string} invitationCode Referral invitation code.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInvitationCodeGet: function (invitationCode, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invitationCode' is not null or undefined
                            (0, common_1.assertParamExists)('referralsInvitationCodeGet', 'invitationCode', invitationCode);
                            localVarPath = "/referrals/{invitationCode}"
                                .replace("{".concat("invitationCode", "}"), encodeURIComponent(String(invitationCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Inviter group
         * @summary Get Inviter details
         * @param {string} inviterId Inviter Id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInviterInviterIdGet: function (inviterId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inviterId' is not null or undefined
                            (0, common_1.assertParamExists)('referralsInviterInviterIdGet', 'inviterId', inviterId);
                            localVarPath = "/referrals/inviter/{inviterId}"
                                .replace("{".concat("inviterId", "}"), encodeURIComponent(String(inviterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Edit inviter
         * @summary Edit Inviter
         * @param {string} inviterId Inviter Id.
         * @param {ReferralsInviterInviterIdPatchRequest} referralsInviterInviterIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInviterInviterIdPatch: function (inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inviterId' is not null or undefined
                            (0, common_1.assertParamExists)('referralsInviterInviterIdPatch', 'inviterId', inviterId);
                            // verify required parameter 'referralsInviterInviterIdPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('referralsInviterInviterIdPatch', 'referralsInviterInviterIdPatchRequest', referralsInviterInviterIdPatchRequest);
                            localVarPath = "/referrals/inviter/{inviterId}"
                                .replace("{".concat("inviterId", "}"), encodeURIComponent(String(inviterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(referralsInviterInviterIdPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ReferralSystemApiAxiosParamCreator = ReferralSystemApiAxiosParamCreator;
/**
 * ReferralSystemApi - functional programming interface
 * @export
 */
var ReferralSystemApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReferralSystemApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get RFA details (money, status) for transaction
         * @summary Get RFA details for transaction
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCustomerIdReferralsTransactionTransactionIdGet: function (customerId, transactionId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerCustomerIdReferralsTransactionTransactionIdGet(customerId, transactionId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customerCustomerIdReferralsTransactionTransactionIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get customer referral code
         * @summary Get customer referral code
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get invitation for specific {invitationType} type.
         * @summary Get invitation to send
         * @param {number} customerId Customer id.
         * @param {string} invitationType Invitation type.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsInvitationInvitationTypeGet: function (customerId, invitationType, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsInvitationInvitationTypeGet(customerId, invitationType, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsInvitationInvitationTypeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get invitees count for inviter with optional filter by status
         * @summary Get invitees count for inviter
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterStatus] Filter by invitee status, for example /customers/123/referrals/invitee/count?filter[status]&#x3D;active. Allowed statuses: awaiting_activation, active, threshold_fulfilled, expired
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsInviteeCountGet: function (customerId, acceptLanguage, filterStatus, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsInviteeCountGet(customerId, acceptLanguage, filterStatus, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsInviteeCountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Generate unique code used to invite people. One per customer.
         * @summary Generate referral code
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsPostRequest} customersCustomerIdReferralsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsPost: function (customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsPost(customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Referral Founds Account actual balance. Cached for 10 seconds.
         * @summary Get Referral Founds Account actual balance
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalanceGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsRfaBalanceGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsRfaBalanceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Release or abort blocked funds on RFA
         * @summary Release or abort blocked funds on RFA
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsRfaBalancePatchRequest} customersCustomerIdReferralsRfaBalancePatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalancePatch: function (customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsRfaBalancePatch(customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsRfaBalancePatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Start using money from RFA (blocking funds). Endpoint for external applications such as PPI. Within this API much more convenient is to use field \"referralFoundsAccountMoney\" in:  ``` PATCH /customers/{customerId}/transactions ```
         * @summary Initiate Referral Founds Account Usage
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsRfaBalancePostRequest} customersCustomerIdReferralsRfaBalancePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalancePost: function (customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsRfaBalancePost(customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsRfaBalancePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Referral Founds Account operations list. Cached for 10 seconds.
         * @summary Get Referral Founds Account operations list
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaOperationsGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdReferralsRfaOperationsGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.customersCustomerIdReferralsRfaOperationsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get inviter groups list with awards
         * @summary Get inviter groups list
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsGroupGet: function (acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.referralsGroupGet(acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.referralsGroupGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * One of main keys is required - for example \"inviteeMoneyAward\"
         * @summary Update group settings
         * @param {string} groupId Group ID.
         * @param {ReferralsGroupGroupIdPatchRequest} referralsGroupGroupIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsGroupGroupIdPatch: function (groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.referralsGroupGroupIdPatch(groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.referralsGroupGroupIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check code existence
         * @summary Validate invitation code
         * @param {string} invitationCode Referral invitation code.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInvitationCodeGet: function (invitationCode, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.referralsInvitationCodeGet(invitationCode, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.referralsInvitationCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Inviter group
         * @summary Get Inviter details
         * @param {string} inviterId Inviter Id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInviterInviterIdGet: function (inviterId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.referralsInviterInviterIdGet(inviterId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.referralsInviterInviterIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Edit inviter
         * @summary Edit Inviter
         * @param {string} inviterId Inviter Id.
         * @param {ReferralsInviterInviterIdPatchRequest} referralsInviterInviterIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInviterInviterIdPatch: function (inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.referralsInviterInviterIdPatch(inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReferralSystemApi.referralsInviterInviterIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ReferralSystemApiFp = ReferralSystemApiFp;
/**
 * ReferralSystemApi - factory interface
 * @export
 */
var ReferralSystemApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReferralSystemApiFp)(configuration);
    return {
        /**
         * Get RFA details (money, status) for transaction
         * @summary Get RFA details for transaction
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCustomerIdReferralsTransactionTransactionIdGet: function (customerId, transactionId, acceptLanguage, options) {
            return localVarFp.customerCustomerIdReferralsTransactionTransactionIdGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get customer referral code
         * @summary Get customer referral code
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get invitation for specific {invitationType} type.
         * @summary Get invitation to send
         * @param {number} customerId Customer id.
         * @param {string} invitationType Invitation type.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsInvitationInvitationTypeGet: function (customerId, invitationType, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsInvitationInvitationTypeGet(customerId, invitationType, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get invitees count for inviter with optional filter by status
         * @summary Get invitees count for inviter
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterStatus] Filter by invitee status, for example /customers/123/referrals/invitee/count?filter[status]&#x3D;active. Allowed statuses: awaiting_activation, active, threshold_fulfilled, expired
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsInviteeCountGet: function (customerId, acceptLanguage, filterStatus, options) {
            return localVarFp.customersCustomerIdReferralsInviteeCountGet(customerId, acceptLanguage, filterStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate unique code used to invite people. One per customer.
         * @summary Generate referral code
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsPostRequest} customersCustomerIdReferralsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsPost: function (customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsPost(customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Referral Founds Account actual balance. Cached for 10 seconds.
         * @summary Get Referral Founds Account actual balance
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalanceGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsRfaBalanceGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Release or abort blocked funds on RFA
         * @summary Release or abort blocked funds on RFA
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsRfaBalancePatchRequest} customersCustomerIdReferralsRfaBalancePatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalancePatch: function (customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsRfaBalancePatch(customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Start using money from RFA (blocking funds). Endpoint for external applications such as PPI. Within this API much more convenient is to use field \"referralFoundsAccountMoney\" in:  ``` PATCH /customers/{customerId}/transactions ```
         * @summary Initiate Referral Founds Account Usage
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdReferralsRfaBalancePostRequest} customersCustomerIdReferralsRfaBalancePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaBalancePost: function (customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsRfaBalancePost(customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Referral Founds Account operations list. Cached for 10 seconds.
         * @summary Get Referral Founds Account operations list
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdReferralsRfaOperationsGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdReferralsRfaOperationsGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get inviter groups list with awards
         * @summary Get inviter groups list
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsGroupGet: function (acceptLanguage, options) {
            return localVarFp.referralsGroupGet(acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * One of main keys is required - for example \"inviteeMoneyAward\"
         * @summary Update group settings
         * @param {string} groupId Group ID.
         * @param {ReferralsGroupGroupIdPatchRequest} referralsGroupGroupIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsGroupGroupIdPatch: function (groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options) {
            return localVarFp.referralsGroupGroupIdPatch(groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check code existence
         * @summary Validate invitation code
         * @param {string} invitationCode Referral invitation code.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInvitationCodeGet: function (invitationCode, acceptLanguage, options) {
            return localVarFp.referralsInvitationCodeGet(invitationCode, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Inviter group
         * @summary Get Inviter details
         * @param {string} inviterId Inviter Id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInviterInviterIdGet: function (inviterId, acceptLanguage, options) {
            return localVarFp.referralsInviterInviterIdGet(inviterId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Edit inviter
         * @summary Edit Inviter
         * @param {string} inviterId Inviter Id.
         * @param {ReferralsInviterInviterIdPatchRequest} referralsInviterInviterIdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referralsInviterInviterIdPatch: function (inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options) {
            return localVarFp.referralsInviterInviterIdPatch(inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReferralSystemApiFactory = ReferralSystemApiFactory;
/**
 * ReferralSystemApi - object-oriented interface
 * @export
 * @class ReferralSystemApi
 * @extends {BaseAPI}
 */
var ReferralSystemApi = /** @class */ (function (_super) {
    __extends(ReferralSystemApi, _super);
    function ReferralSystemApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get RFA details (money, status) for transaction
     * @summary Get RFA details for transaction
     * @param {number} customerId Customer id.
     * @param {string} transactionId Transaction id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customerCustomerIdReferralsTransactionTransactionIdGet = function (customerId, transactionId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customerCustomerIdReferralsTransactionTransactionIdGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get customer referral code
     * @summary Get customer referral code
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get invitation for specific {invitationType} type.
     * @summary Get invitation to send
     * @param {number} customerId Customer id.
     * @param {string} invitationType Invitation type.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsInvitationInvitationTypeGet = function (customerId, invitationType, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsInvitationInvitationTypeGet(customerId, invitationType, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get invitees count for inviter with optional filter by status
     * @summary Get invitees count for inviter
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterStatus] Filter by invitee status, for example /customers/123/referrals/invitee/count?filter[status]&#x3D;active. Allowed statuses: awaiting_activation, active, threshold_fulfilled, expired
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsInviteeCountGet = function (customerId, acceptLanguage, filterStatus, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsInviteeCountGet(customerId, acceptLanguage, filterStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate unique code used to invite people. One per customer.
     * @summary Generate referral code
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdReferralsPostRequest} customersCustomerIdReferralsPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsPost = function (customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsPost(customerId, customersCustomerIdReferralsPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Referral Founds Account actual balance. Cached for 10 seconds.
     * @summary Get Referral Founds Account actual balance
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsRfaBalanceGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsRfaBalanceGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Release or abort blocked funds on RFA
     * @summary Release or abort blocked funds on RFA
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdReferralsRfaBalancePatchRequest} customersCustomerIdReferralsRfaBalancePatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsRfaBalancePatch = function (customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsRfaBalancePatch(customerId, customersCustomerIdReferralsRfaBalancePatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Start using money from RFA (blocking funds). Endpoint for external applications such as PPI. Within this API much more convenient is to use field \"referralFoundsAccountMoney\" in:  ``` PATCH /customers/{customerId}/transactions ```
     * @summary Initiate Referral Founds Account Usage
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdReferralsRfaBalancePostRequest} customersCustomerIdReferralsRfaBalancePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsRfaBalancePost = function (customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsRfaBalancePost(customerId, customersCustomerIdReferralsRfaBalancePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Referral Founds Account operations list. Cached for 10 seconds.
     * @summary Get Referral Founds Account operations list
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.customersCustomerIdReferralsRfaOperationsGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).customersCustomerIdReferralsRfaOperationsGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get inviter groups list with awards
     * @summary Get inviter groups list
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.referralsGroupGet = function (acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).referralsGroupGet(acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * One of main keys is required - for example \"inviteeMoneyAward\"
     * @summary Update group settings
     * @param {string} groupId Group ID.
     * @param {ReferralsGroupGroupIdPatchRequest} referralsGroupGroupIdPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.referralsGroupGroupIdPatch = function (groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).referralsGroupGroupIdPatch(groupId, referralsGroupGroupIdPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check code existence
     * @summary Validate invitation code
     * @param {string} invitationCode Referral invitation code.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.referralsInvitationCodeGet = function (invitationCode, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).referralsInvitationCodeGet(invitationCode, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Inviter group
     * @summary Get Inviter details
     * @param {string} inviterId Inviter Id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.referralsInviterInviterIdGet = function (inviterId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).referralsInviterInviterIdGet(inviterId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Edit inviter
     * @summary Edit Inviter
     * @param {string} inviterId Inviter Id.
     * @param {ReferralsInviterInviterIdPatchRequest} referralsInviterInviterIdPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralSystemApi
     */
    ReferralSystemApi.prototype.referralsInviterInviterIdPatch = function (inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ReferralSystemApiFp)(this.configuration).referralsInviterInviterIdPatch(inviterId, referralsInviterInviterIdPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReferralSystemApi;
}(base_1.BaseAPI));
exports.ReferralSystemApi = ReferralSystemApi;
/**
 * RegistrationApi - axios parameter creator
 * @export
 */
var RegistrationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Method to activate an account. Should be used after user registration with token from email.
         * @summary Customer account activation
         * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersAccountActivationPost: function (customersAccountActivationPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'customersAccountActivationPostRequest' is not null or undefined
                    (0, common_1.assertParamExists)('customersAccountActivationPost', 'customersAccountActivationPostRequest', customersAccountActivationPostRequest);
                    localVarPath = "/customers/accountActivation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersAccountActivationPostRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * If all data is correct you can proceed to step 3 - showed in location. Step is not necessary
         * @summary Financial validation registration step
         * @param {CustomersRegistrationStepFinancialValidationPostRequest} customersRegistrationStepFinancialValidationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepFinancialValidationPost: function (customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersRegistrationStepFinancialValidationPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersRegistrationStepFinancialValidationPost', 'customersRegistrationStepFinancialValidationPostRequest', customersRegistrationStepFinancialValidationPostRequest);
                            localVarPath = "/customers/registrationStepFinancialValidation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRegistrationStepFinancialValidationPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If all data are correct, saves data in server session - needed for next step.
         * @summary First registration step
         * @param {CustomersRegistrationStepFirstPostRequest} customersRegistrationStepFirstPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepFirstPost: function (customersRegistrationStepFirstPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersRegistrationStepFirstPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersRegistrationStepFirstPost', 'customersRegistrationStepFirstPostRequest', customersRegistrationStepFirstPostRequest);
                            localVarPath = "/customers/registrationStepFirst";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRegistrationStepFirstPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If all data is correct you can proceed to step 3 - showed in location.
         * @summary Second registration step
         * @param {CustomersRegistrationStepSecondPostRequest} customersRegistrationStepSecondPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepSecondPost: function (customersRegistrationStepSecondPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersRegistrationStepSecondPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersRegistrationStepSecondPost', 'customersRegistrationStepSecondPostRequest', customersRegistrationStepSecondPostRequest);
                            localVarPath = "/customers/registrationStepSecond";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRegistrationStepSecondPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Verifies client that already has an account created by one of the agents. Correct SMS token is required to proceed with registration. The customer data will be updated and an email with activation token will be sent. Continue with `customers/activateAccount` to finish the registration process.
         * @summary Third registration step - offline clients
         * @param {CustomersRegistrationStepThirdPatchRequest} customersRegistrationStepThirdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepThirdPatch: function (customersRegistrationStepThirdPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersRegistrationStepThirdPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersRegistrationStepThirdPatch', 'customersRegistrationStepThirdPatchRequest', customersRegistrationStepThirdPatchRequest);
                            localVarPath = "/customers/registrationStepThird";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRegistrationStepThirdPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If all data is correct, creates customer account and sends activation email. Then use customers/accountActivation to activate it with token from email. In case that customer already have an account in system that was created by one of the agents, send an verification token to the client via SMS. This token should be then passed to `customers/registrationStepThird` `PATCH` endpoint, and - if it\'s correct - an activation email will be sent. Then proceed email token with `customers/accountActivation`.
         * @summary Third registration step - new / offline clients
         * @param {CustomersRegistrationStepThirdPostRequest} customersRegistrationStepThirdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepThirdPost: function (customersRegistrationStepThirdPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customersRegistrationStepThirdPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersRegistrationStepThirdPost', 'customersRegistrationStepThirdPostRequest', customersRegistrationStepThirdPostRequest);
                            localVarPath = "/customers/registrationStepThird";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRegistrationStepThirdPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RegistrationApiAxiosParamCreator = RegistrationApiAxiosParamCreator;
/**
 * RegistrationApi - functional programming interface
 * @export
 */
var RegistrationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RegistrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Method to activate an account. Should be used after user registration with token from email.
         * @summary Customer account activation
         * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersAccountActivationPost: function (customersAccountActivationPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersAccountActivationPost(customersAccountActivationPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RegistrationApi.customersAccountActivationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data is correct you can proceed to step 3 - showed in location. Step is not necessary
         * @summary Financial validation registration step
         * @param {CustomersRegistrationStepFinancialValidationPostRequest} customersRegistrationStepFinancialValidationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepFinancialValidationPost: function (customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRegistrationStepFinancialValidationPost(customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RegistrationApi.customersRegistrationStepFinancialValidationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data are correct, saves data in server session - needed for next step.
         * @summary First registration step
         * @param {CustomersRegistrationStepFirstPostRequest} customersRegistrationStepFirstPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepFirstPost: function (customersRegistrationStepFirstPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRegistrationStepFirstPost(customersRegistrationStepFirstPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RegistrationApi.customersRegistrationStepFirstPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data is correct you can proceed to step 3 - showed in location.
         * @summary Second registration step
         * @param {CustomersRegistrationStepSecondPostRequest} customersRegistrationStepSecondPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepSecondPost: function (customersRegistrationStepSecondPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRegistrationStepSecondPost(customersRegistrationStepSecondPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RegistrationApi.customersRegistrationStepSecondPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Verifies client that already has an account created by one of the agents. Correct SMS token is required to proceed with registration. The customer data will be updated and an email with activation token will be sent. Continue with `customers/activateAccount` to finish the registration process.
         * @summary Third registration step - offline clients
         * @param {CustomersRegistrationStepThirdPatchRequest} customersRegistrationStepThirdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepThirdPatch: function (customersRegistrationStepThirdPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRegistrationStepThirdPatch(customersRegistrationStepThirdPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RegistrationApi.customersRegistrationStepThirdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data is correct, creates customer account and sends activation email. Then use customers/accountActivation to activate it with token from email. In case that customer already have an account in system that was created by one of the agents, send an verification token to the client via SMS. This token should be then passed to `customers/registrationStepThird` `PATCH` endpoint, and - if it\'s correct - an activation email will be sent. Then proceed email token with `customers/accountActivation`.
         * @summary Third registration step - new / offline clients
         * @param {CustomersRegistrationStepThirdPostRequest} customersRegistrationStepThirdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepThirdPost: function (customersRegistrationStepThirdPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersRegistrationStepThirdPost(customersRegistrationStepThirdPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RegistrationApi.customersRegistrationStepThirdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RegistrationApiFp = RegistrationApiFp;
/**
 * RegistrationApi - factory interface
 * @export
 */
var RegistrationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RegistrationApiFp)(configuration);
    return {
        /**
         * Method to activate an account. Should be used after user registration with token from email.
         * @summary Customer account activation
         * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersAccountActivationPost: function (customersAccountActivationPostRequest, acceptLanguage, options) {
            return localVarFp.customersAccountActivationPost(customersAccountActivationPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data is correct you can proceed to step 3 - showed in location. Step is not necessary
         * @summary Financial validation registration step
         * @param {CustomersRegistrationStepFinancialValidationPostRequest} customersRegistrationStepFinancialValidationPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepFinancialValidationPost: function (customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options) {
            return localVarFp.customersRegistrationStepFinancialValidationPost(customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data are correct, saves data in server session - needed for next step.
         * @summary First registration step
         * @param {CustomersRegistrationStepFirstPostRequest} customersRegistrationStepFirstPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepFirstPost: function (customersRegistrationStepFirstPostRequest, acceptLanguage, options) {
            return localVarFp.customersRegistrationStepFirstPost(customersRegistrationStepFirstPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data is correct you can proceed to step 3 - showed in location.
         * @summary Second registration step
         * @param {CustomersRegistrationStepSecondPostRequest} customersRegistrationStepSecondPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepSecondPost: function (customersRegistrationStepSecondPostRequest, acceptLanguage, options) {
            return localVarFp.customersRegistrationStepSecondPost(customersRegistrationStepSecondPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verifies client that already has an account created by one of the agents. Correct SMS token is required to proceed with registration. The customer data will be updated and an email with activation token will be sent. Continue with `customers/activateAccount` to finish the registration process.
         * @summary Third registration step - offline clients
         * @param {CustomersRegistrationStepThirdPatchRequest} customersRegistrationStepThirdPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepThirdPatch: function (customersRegistrationStepThirdPatchRequest, acceptLanguage, options) {
            return localVarFp.customersRegistrationStepThirdPatch(customersRegistrationStepThirdPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data is correct, creates customer account and sends activation email. Then use customers/accountActivation to activate it with token from email. In case that customer already have an account in system that was created by one of the agents, send an verification token to the client via SMS. This token should be then passed to `customers/registrationStepThird` `PATCH` endpoint, and - if it\'s correct - an activation email will be sent. Then proceed email token with `customers/accountActivation`.
         * @summary Third registration step - new / offline clients
         * @param {CustomersRegistrationStepThirdPostRequest} customersRegistrationStepThirdPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersRegistrationStepThirdPost: function (customersRegistrationStepThirdPostRequest, acceptLanguage, options) {
            return localVarFp.customersRegistrationStepThirdPost(customersRegistrationStepThirdPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RegistrationApiFactory = RegistrationApiFactory;
/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
var RegistrationApi = /** @class */ (function (_super) {
    __extends(RegistrationApi, _super);
    function RegistrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Method to activate an account. Should be used after user registration with token from email.
     * @summary Customer account activation
     * @param {CustomersAccountActivationPostRequest} customersAccountActivationPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.customersAccountActivationPost = function (customersAccountActivationPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).customersAccountActivationPost(customersAccountActivationPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data is correct you can proceed to step 3 - showed in location. Step is not necessary
     * @summary Financial validation registration step
     * @param {CustomersRegistrationStepFinancialValidationPostRequest} customersRegistrationStepFinancialValidationPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.customersRegistrationStepFinancialValidationPost = function (customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).customersRegistrationStepFinancialValidationPost(customersRegistrationStepFinancialValidationPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data are correct, saves data in server session - needed for next step.
     * @summary First registration step
     * @param {CustomersRegistrationStepFirstPostRequest} customersRegistrationStepFirstPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.customersRegistrationStepFirstPost = function (customersRegistrationStepFirstPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).customersRegistrationStepFirstPost(customersRegistrationStepFirstPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data is correct you can proceed to step 3 - showed in location.
     * @summary Second registration step
     * @param {CustomersRegistrationStepSecondPostRequest} customersRegistrationStepSecondPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.customersRegistrationStepSecondPost = function (customersRegistrationStepSecondPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).customersRegistrationStepSecondPost(customersRegistrationStepSecondPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verifies client that already has an account created by one of the agents. Correct SMS token is required to proceed with registration. The customer data will be updated and an email with activation token will be sent. Continue with `customers/activateAccount` to finish the registration process.
     * @summary Third registration step - offline clients
     * @param {CustomersRegistrationStepThirdPatchRequest} customersRegistrationStepThirdPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.customersRegistrationStepThirdPatch = function (customersRegistrationStepThirdPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).customersRegistrationStepThirdPatch(customersRegistrationStepThirdPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data is correct, creates customer account and sends activation email. Then use customers/accountActivation to activate it with token from email. In case that customer already have an account in system that was created by one of the agents, send an verification token to the client via SMS. This token should be then passed to `customers/registrationStepThird` `PATCH` endpoint, and - if it\'s correct - an activation email will be sent. Then proceed email token with `customers/accountActivation`.
     * @summary Third registration step - new / offline clients
     * @param {CustomersRegistrationStepThirdPostRequest} customersRegistrationStepThirdPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.customersRegistrationStepThirdPost = function (customersRegistrationStepThirdPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).customersRegistrationStepThirdPost(customersRegistrationStepThirdPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RegistrationApi;
}(base_1.BaseAPI));
exports.RegistrationApi = RegistrationApi;
/**
 * RepeatPaymentsApi - axios parameter creator
 * @export
 */
var RepeatPaymentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns list of repeat payments.
         * @summary Get list of repeat payment
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments?page&#x3D;1&#x60;.
         * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments?limit&#x3D;1&#x60;.
         * @param {number} sort Sort list of repeat payment.  Available sorting by: * startDate * finishDate * name  For example: &#x60;/customers/{customerId}/repeatPayments?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterName] Filter by name value. For example /customers/{customerId}/repeatPayments?filter[name]&#x3D;TEST.
         * @param {string} [filterStartDate] Filter by startDate value. For example /customers/{customerId}/repeatPayments?filter[startDate]&#x3D;2012-01-01.
         * @param {string} [filterFinishDate] Filter by finishDate value. For example /customers/{customerId}/repeatPayments?filter[finishDate]&#x3D;2030-01-01.
         * @param {string} [filterStatus] Filter by repeat payment status, for example /customers/{customerId}/repeatPayments?filter[status]&#x3D;active. To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
         * @param {string} [optionsStatus] To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
         * @param {CustomersCustomerIdRepeatPaymentsGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsGet: function (customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsGet', 'customerId', customerId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsGet', 'page', page);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsGet', 'limit', limit);
                            // verify required parameter 'sort' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsGet', 'sort', sort);
                            localVarPath = "/customers/{customerId}/repeatPayments"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (filterName !== undefined) {
                                localVarQueryParameter['filter[name]'] = filterName;
                            }
                            if (filterStartDate !== undefined) {
                                localVarQueryParameter['filter[startDate]'] = filterStartDate;
                            }
                            if (filterFinishDate !== undefined) {
                                localVarQueryParameter['filter[finishDate]'] = filterFinishDate;
                            }
                            if (filterStatus !== undefined) {
                                localVarQueryParameter['filter[status]'] = filterStatus;
                            }
                            if (optionsStatus !== undefined) {
                                localVarQueryParameter['options[status]'] = optionsStatus;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns available periods. Needed during setup/edit repeat payment.
         * @summary Get periods of repeat payment
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsPeriodsGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsPeriodsGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/repeatPayments/periods"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If value in server session is correct - delete repeat payment.
         * @summary Delete repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete: function (customerId, repeatPaymentId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete', 'customerId', customerId);
                            // verify required parameter 'repeatPaymentId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete', 'repeatPaymentId', repeatPaymentId);
                            localVarPath = "/customers/{customerId}/repeatPayments/{repeatPaymentId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("repeatPaymentId", "}"), encodeURIComponent(String(repeatPaymentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns single repeat payment data.
         * @summary Get repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdGet: function (customerId, repeatPaymentId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdGet', 'customerId', customerId);
                            // verify required parameter 'repeatPaymentId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdGet', 'repeatPaymentId', repeatPaymentId);
                            localVarPath = "/customers/{customerId}/repeatPayments/{repeatPaymentId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("repeatPaymentId", "}"), encodeURIComponent(String(repeatPaymentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns list of repeat payments.
         * @summary Get list of repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?page&#x3D;1&#x60;.
         * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?limit&#x3D;1&#x60;.
         * @param {number} sort Sort list of repeat payment schedules.  Available sorting by: * date  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet: function (customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet', 'customerId', customerId);
                            // verify required parameter 'repeatPaymentId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet', 'repeatPaymentId', repeatPaymentId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet', 'page', page);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet', 'limit', limit);
                            // verify required parameter 'sort' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet', 'sort', sort);
                            localVarPath = "/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("repeatPaymentId", "}"), encodeURIComponent(String(repeatPaymentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete repeat payment single schedule
         * @summary Delete repeat payment single schedule
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {number} scheduleId Schedule ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete: function (customerId, repeatPaymentId, scheduleId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete', 'customerId', customerId);
                            // verify required parameter 'repeatPaymentId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete', 'repeatPaymentId', repeatPaymentId);
                            // verify required parameter 'scheduleId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete', 'scheduleId', scheduleId);
                            localVarPath = "/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule/{scheduleId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("repeatPaymentId", "}"), encodeURIComponent(String(repeatPaymentId)))
                                .replace("{".concat("scheduleId", "}"), encodeURIComponent(String(scheduleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check if data is correct - needed for next step.
         * @summary First repeat payment step.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep1PostRequest} customersCustomerIdRepeatPaymentsStep1PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep1Post: function (customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep1Post', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdRepeatPaymentsStep1PostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep1Post', 'customersCustomerIdRepeatPaymentsStep1PostRequest', customersCustomerIdRepeatPaymentsStep1PostRequest);
                            localVarPath = "/customers/{customerId}/repeatPayments/step1"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdRepeatPaymentsStep1PostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check data are correct - needed for next step.
         * @summary Second repeat payment step
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep2PostRequest} customersCustomerIdRepeatPaymentsStep2PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep2Post: function (customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep2Post', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdRepeatPaymentsStep2PostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep2Post', 'customersCustomerIdRepeatPaymentsStep2PostRequest', customersCustomerIdRepeatPaymentsStep2PostRequest);
                            localVarPath = "/customers/{customerId}/repeatPayments/step2"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdRepeatPaymentsStep2PostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If all data are correct, saves changes repeat payment and sent e-mail to customer.
         * @summary Update repeat payment - step 4
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep4PatchRequest} customersCustomerIdRepeatPaymentsStep4PatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep4Patch: function (customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep4Patch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdRepeatPaymentsStep4PatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep4Patch', 'customersCustomerIdRepeatPaymentsStep4PatchRequest', customersCustomerIdRepeatPaymentsStep4PatchRequest);
                            localVarPath = "/customers/{customerId}/repeatPayments/step4"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdRepeatPaymentsStep4PatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If all data are correct, created new repeat payment and sent e-mail to customer.
         * @summary Fourth repeat payment step
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep4PostRequest} customersCustomerIdRepeatPaymentsStep4PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep4Post: function (customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep4Post', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdRepeatPaymentsStep4PostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdRepeatPaymentsStep4Post', 'customersCustomerIdRepeatPaymentsStep4PostRequest', customersCustomerIdRepeatPaymentsStep4PostRequest);
                            localVarPath = "/customers/{customerId}/repeatPayments/step4"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdRepeatPaymentsStep4PostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RepeatPaymentsApiAxiosParamCreator = RepeatPaymentsApiAxiosParamCreator;
/**
 * RepeatPaymentsApi - functional programming interface
 * @export
 */
var RepeatPaymentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RepeatPaymentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns list of repeat payments.
         * @summary Get list of repeat payment
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments?page&#x3D;1&#x60;.
         * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments?limit&#x3D;1&#x60;.
         * @param {number} sort Sort list of repeat payment.  Available sorting by: * startDate * finishDate * name  For example: &#x60;/customers/{customerId}/repeatPayments?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterName] Filter by name value. For example /customers/{customerId}/repeatPayments?filter[name]&#x3D;TEST.
         * @param {string} [filterStartDate] Filter by startDate value. For example /customers/{customerId}/repeatPayments?filter[startDate]&#x3D;2012-01-01.
         * @param {string} [filterFinishDate] Filter by finishDate value. For example /customers/{customerId}/repeatPayments?filter[finishDate]&#x3D;2030-01-01.
         * @param {string} [filterStatus] Filter by repeat payment status, for example /customers/{customerId}/repeatPayments?filter[status]&#x3D;active. To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
         * @param {string} [optionsStatus] To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
         * @param {CustomersCustomerIdRepeatPaymentsGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsGet: function (customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsGet(customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns available periods. Needed during setup/edit repeat payment.
         * @summary Get periods of repeat payment
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsPeriodsGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsPeriodsGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsPeriodsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If value in server session is correct - delete repeat payment.
         * @summary Delete repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete: function (customerId, repeatPaymentId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete(customerId, repeatPaymentId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns single repeat payment data.
         * @summary Get repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdGet: function (customerId, repeatPaymentId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsRepeatPaymentIdGet(customerId, repeatPaymentId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsRepeatPaymentIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns list of repeat payments.
         * @summary Get list of repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?page&#x3D;1&#x60;.
         * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?limit&#x3D;1&#x60;.
         * @param {number} sort Sort list of repeat payment schedules.  Available sorting by: * date  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet: function (customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet(customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete repeat payment single schedule
         * @summary Delete repeat payment single schedule
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {number} scheduleId Schedule ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete: function (customerId, repeatPaymentId, scheduleId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete(customerId, repeatPaymentId, scheduleId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check if data is correct - needed for next step.
         * @summary First repeat payment step.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep1PostRequest} customersCustomerIdRepeatPaymentsStep1PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep1Post: function (customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsStep1Post(customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsStep1Post']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check data are correct - needed for next step.
         * @summary Second repeat payment step
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep2PostRequest} customersCustomerIdRepeatPaymentsStep2PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep2Post: function (customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsStep2Post(customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsStep2Post']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data are correct, saves changes repeat payment and sent e-mail to customer.
         * @summary Update repeat payment - step 4
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep4PatchRequest} customersCustomerIdRepeatPaymentsStep4PatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep4Patch: function (customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsStep4Patch(customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsStep4Patch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data are correct, created new repeat payment and sent e-mail to customer.
         * @summary Fourth repeat payment step
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep4PostRequest} customersCustomerIdRepeatPaymentsStep4PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep4Post: function (customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdRepeatPaymentsStep4Post(customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RepeatPaymentsApi.customersCustomerIdRepeatPaymentsStep4Post']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RepeatPaymentsApiFp = RepeatPaymentsApiFp;
/**
 * RepeatPaymentsApi - factory interface
 * @export
 */
var RepeatPaymentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RepeatPaymentsApiFp)(configuration);
    return {
        /**
         * Returns list of repeat payments.
         * @summary Get list of repeat payment
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments?page&#x3D;1&#x60;.
         * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments?limit&#x3D;1&#x60;.
         * @param {number} sort Sort list of repeat payment.  Available sorting by: * startDate * finishDate * name  For example: &#x60;/customers/{customerId}/repeatPayments?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterName] Filter by name value. For example /customers/{customerId}/repeatPayments?filter[name]&#x3D;TEST.
         * @param {string} [filterStartDate] Filter by startDate value. For example /customers/{customerId}/repeatPayments?filter[startDate]&#x3D;2012-01-01.
         * @param {string} [filterFinishDate] Filter by finishDate value. For example /customers/{customerId}/repeatPayments?filter[finishDate]&#x3D;2030-01-01.
         * @param {string} [filterStatus] Filter by repeat payment status, for example /customers/{customerId}/repeatPayments?filter[status]&#x3D;active. To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
         * @param {string} [optionsStatus] To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
         * @param {CustomersCustomerIdRepeatPaymentsGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsGet: function (customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsGet(customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns available periods. Needed during setup/edit repeat payment.
         * @summary Get periods of repeat payment
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsPeriodsGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsPeriodsGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If value in server session is correct - delete repeat payment.
         * @summary Delete repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete: function (customerId, repeatPaymentId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete(customerId, repeatPaymentId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns single repeat payment data.
         * @summary Get repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdGet: function (customerId, repeatPaymentId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsRepeatPaymentIdGet(customerId, repeatPaymentId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of repeat payments.
         * @summary Get list of repeat payment
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?page&#x3D;1&#x60;.
         * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?limit&#x3D;1&#x60;.
         * @param {number} sort Sort list of repeat payment schedules.  Available sorting by: * date  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?sort&#x3D;name.&#x60;
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet: function (customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet(customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete repeat payment single schedule
         * @summary Delete repeat payment single schedule
         * @param {number} customerId Customer id.
         * @param {number} repeatPaymentId Repeat payment ID
         * @param {number} scheduleId Schedule ID
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete: function (customerId, repeatPaymentId, scheduleId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete(customerId, repeatPaymentId, scheduleId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check if data is correct - needed for next step.
         * @summary First repeat payment step.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep1PostRequest} customersCustomerIdRepeatPaymentsStep1PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep1Post: function (customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsStep1Post(customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check data are correct - needed for next step.
         * @summary Second repeat payment step
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep2PostRequest} customersCustomerIdRepeatPaymentsStep2PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep2Post: function (customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsStep2Post(customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data are correct, saves changes repeat payment and sent e-mail to customer.
         * @summary Update repeat payment - step 4
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep4PatchRequest} customersCustomerIdRepeatPaymentsStep4PatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep4Patch: function (customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsStep4Patch(customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data are correct, created new repeat payment and sent e-mail to customer.
         * @summary Fourth repeat payment step
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdRepeatPaymentsStep4PostRequest} customersCustomerIdRepeatPaymentsStep4PostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdRepeatPaymentsStep4Post: function (customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdRepeatPaymentsStep4Post(customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RepeatPaymentsApiFactory = RepeatPaymentsApiFactory;
/**
 * RepeatPaymentsApi - object-oriented interface
 * @export
 * @class RepeatPaymentsApi
 * @extends {BaseAPI}
 */
var RepeatPaymentsApi = /** @class */ (function (_super) {
    __extends(RepeatPaymentsApi, _super);
    function RepeatPaymentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns list of repeat payments.
     * @summary Get list of repeat payment
     * @param {number} customerId Customer id.
     * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments?page&#x3D;1&#x60;.
     * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments?limit&#x3D;1&#x60;.
     * @param {number} sort Sort list of repeat payment.  Available sorting by: * startDate * finishDate * name  For example: &#x60;/customers/{customerId}/repeatPayments?sort&#x3D;name.&#x60;
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterName] Filter by name value. For example /customers/{customerId}/repeatPayments?filter[name]&#x3D;TEST.
     * @param {string} [filterStartDate] Filter by startDate value. For example /customers/{customerId}/repeatPayments?filter[startDate]&#x3D;2012-01-01.
     * @param {string} [filterFinishDate] Filter by finishDate value. For example /customers/{customerId}/repeatPayments?filter[finishDate]&#x3D;2030-01-01.
     * @param {string} [filterStatus] Filter by repeat payment status, for example /customers/{customerId}/repeatPayments?filter[status]&#x3D;active. To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
     * @param {string} [optionsStatus] To get all inactive repeat payments /customers/{customerId}/repeatPayments?filter[status]&#x3D;active&amp;options[status]&#x3D;ne.
     * @param {CustomersCustomerIdRepeatPaymentsGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsGet = function (customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsGet(customerId, page, limit, sort, acceptLanguage, filterName, filterStartDate, filterFinishDate, filterStatus, optionsStatus, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns available periods. Needed during setup/edit repeat payment.
     * @summary Get periods of repeat payment
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsPeriodsGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsPeriodsGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If value in server session is correct - delete repeat payment.
     * @summary Delete repeat payment
     * @param {number} customerId Customer id.
     * @param {number} repeatPaymentId Repeat payment ID
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete = function (customerId, repeatPaymentId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsRepeatPaymentIdDelete(customerId, repeatPaymentId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns single repeat payment data.
     * @summary Get repeat payment
     * @param {number} customerId Customer id.
     * @param {number} repeatPaymentId Repeat payment ID
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsRepeatPaymentIdGet = function (customerId, repeatPaymentId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsRepeatPaymentIdGet(customerId, repeatPaymentId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of repeat payments.
     * @summary Get list of repeat payment
     * @param {number} customerId Customer id.
     * @param {number} repeatPaymentId Repeat payment ID
     * @param {number} page Number of result. Start is 0.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?page&#x3D;1&#x60;.
     * @param {number} limit Size of result. Min is 1.  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?limit&#x3D;1&#x60;.
     * @param {number} sort Sort list of repeat payment schedules.  Available sorting by: * date  For example: &#x60;/customers/{customerId}/repeatPayments/{repeatPaymentId}/schedule?sort&#x3D;name.&#x60;
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {CustomersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet = function (customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGet(customerId, repeatPaymentId, page, limit, sort, acceptLanguage, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete repeat payment single schedule
     * @summary Delete repeat payment single schedule
     * @param {number} customerId Customer id.
     * @param {number} repeatPaymentId Repeat payment ID
     * @param {number} scheduleId Schedule ID
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete = function (customerId, repeatPaymentId, scheduleId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleScheduleIdDelete(customerId, repeatPaymentId, scheduleId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check if data is correct - needed for next step.
     * @summary First repeat payment step.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdRepeatPaymentsStep1PostRequest} customersCustomerIdRepeatPaymentsStep1PostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsStep1Post = function (customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsStep1Post(customerId, customersCustomerIdRepeatPaymentsStep1PostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check data are correct - needed for next step.
     * @summary Second repeat payment step
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdRepeatPaymentsStep2PostRequest} customersCustomerIdRepeatPaymentsStep2PostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsStep2Post = function (customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsStep2Post(customerId, customersCustomerIdRepeatPaymentsStep2PostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data are correct, saves changes repeat payment and sent e-mail to customer.
     * @summary Update repeat payment - step 4
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdRepeatPaymentsStep4PatchRequest} customersCustomerIdRepeatPaymentsStep4PatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsStep4Patch = function (customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsStep4Patch(customerId, customersCustomerIdRepeatPaymentsStep4PatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data are correct, created new repeat payment and sent e-mail to customer.
     * @summary Fourth repeat payment step
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdRepeatPaymentsStep4PostRequest} customersCustomerIdRepeatPaymentsStep4PostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepeatPaymentsApi
     */
    RepeatPaymentsApi.prototype.customersCustomerIdRepeatPaymentsStep4Post = function (customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RepeatPaymentsApiFp)(this.configuration).customersCustomerIdRepeatPaymentsStep4Post(customerId, customersCustomerIdRepeatPaymentsStep4PostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RepeatPaymentsApi;
}(base_1.BaseAPI));
exports.RepeatPaymentsApi = RepeatPaymentsApi;
/**
 * @export
 */
exports.CustomersCustomerIdRepeatPaymentsGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * @export
 */
exports.CustomersCustomerIdRepeatPaymentsRepeatPaymentIdScheduleGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * SantanderApi - axios parameter creator
 * @export
 */
var SantanderApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Validate transaction data (for now check blik santander)
         * @summary Validate transaction data
         * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionValidatedataPost: function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'amlTransactionValidatedataPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('amlTransactionValidatedataPost', 'amlTransactionValidatedataPostRequest', amlTransactionValidatedataPostRequest);
                            localVarPath = "/aml/transaction/validatedata";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(amlTransactionValidatedataPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
         * @summary Santander Cheque Blik Transaction
         * @param {SantanderChequePostRequest} santanderChequePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderChequePost: function (santanderChequePostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'santanderChequePostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('santanderChequePost', 'santanderChequePostRequest', santanderChequePostRequest);
                            localVarPath = "/santander/cheque";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(santanderChequePostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Method to check transactionId id ready for replacement
         * @summary Santander Live Transaction get Transaction for replacement
         * @param {string} transactionId Transaction Id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderTransactionForReplacementTransactionIdGet: function (transactionId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('santanderTransactionForReplacementTransactionIdGet', 'transactionId', transactionId);
                            localVarPath = "/santander/transactionForReplacement/{transactionId}"
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SantanderApiAxiosParamCreator = SantanderApiAxiosParamCreator;
/**
 * SantanderApi - functional programming interface
 * @export
 */
var SantanderApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SantanderApiAxiosParamCreator)(configuration);
    return {
        /**
         * Validate transaction data (for now check blik santander)
         * @summary Validate transaction data
         * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionValidatedataPost: function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.amlTransactionValidatedataPost(amlTransactionValidatedataPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SantanderApi.amlTransactionValidatedataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
         * @summary Santander Cheque Blik Transaction
         * @param {SantanderChequePostRequest} santanderChequePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderChequePost: function (santanderChequePostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.santanderChequePost(santanderChequePostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SantanderApi.santanderChequePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Method to check transactionId id ready for replacement
         * @summary Santander Live Transaction get Transaction for replacement
         * @param {string} transactionId Transaction Id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderTransactionForReplacementTransactionIdGet: function (transactionId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.santanderTransactionForReplacementTransactionIdGet(transactionId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SantanderApi.santanderTransactionForReplacementTransactionIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SantanderApiFp = SantanderApiFp;
/**
 * SantanderApi - factory interface
 * @export
 */
var SantanderApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SantanderApiFp)(configuration);
    return {
        /**
         * Validate transaction data (for now check blik santander)
         * @summary Validate transaction data
         * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amlTransactionValidatedataPost: function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
            return localVarFp.amlTransactionValidatedataPost(amlTransactionValidatedataPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
         * @summary Santander Cheque Blik Transaction
         * @param {SantanderChequePostRequest} santanderChequePostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderChequePost: function (santanderChequePostRequest, acceptLanguage, options) {
            return localVarFp.santanderChequePost(santanderChequePostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Method to check transactionId id ready for replacement
         * @summary Santander Live Transaction get Transaction for replacement
         * @param {string} transactionId Transaction Id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        santanderTransactionForReplacementTransactionIdGet: function (transactionId, acceptLanguage, options) {
            return localVarFp.santanderTransactionForReplacementTransactionIdGet(transactionId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SantanderApiFactory = SantanderApiFactory;
/**
 * SantanderApi - object-oriented interface
 * @export
 * @class SantanderApi
 * @extends {BaseAPI}
 */
var SantanderApi = /** @class */ (function (_super) {
    __extends(SantanderApi, _super);
    function SantanderApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Validate transaction data (for now check blik santander)
     * @summary Validate transaction data
     * @param {AmlTransactionValidatedataPostRequest} amlTransactionValidatedataPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SantanderApi
     */
    SantanderApi.prototype.amlTransactionValidatedataPost = function (amlTransactionValidatedataPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SantanderApiFp)(this.configuration).amlTransactionValidatedataPost(amlTransactionValidatedataPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create request for Cheque Blik Transfer to Santander, with phone number and encrypted PIN. After maximum 20 minutes cheque will be ready to use in every ATM. Client system should send PIN and information to beneficiary.
     * @summary Santander Cheque Blik Transaction
     * @param {SantanderChequePostRequest} santanderChequePostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SantanderApi
     */
    SantanderApi.prototype.santanderChequePost = function (santanderChequePostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SantanderApiFp)(this.configuration).santanderChequePost(santanderChequePostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Method to check transactionId id ready for replacement
     * @summary Santander Live Transaction get Transaction for replacement
     * @param {string} transactionId Transaction Id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SantanderApi
     */
    SantanderApi.prototype.santanderTransactionForReplacementTransactionIdGet = function (transactionId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SantanderApiFp)(this.configuration).santanderTransactionForReplacementTransactionIdGet(transactionId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SantanderApi;
}(base_1.BaseAPI));
exports.SantanderApi = SantanderApi;
/**
 * ScanIdApi - axios parameter creator
 * @export
 */
var ScanIdApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get url for id scan.
         * @summary Get url for id scan.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idscanCustomerIdUrlGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('idscanCustomerIdUrlGet', 'customerId', customerId);
                            localVarPath = "/idscan/{customerId}/url"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Webhook about scan file.
         * @summary Webhook about scan file.
         * @param {IdscanWebhookPostRequest} [idscanWebhookPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idscanWebhookPost: function (idscanWebhookPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/idscan/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(idscanWebhookPostRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ScanIdApiAxiosParamCreator = ScanIdApiAxiosParamCreator;
/**
 * ScanIdApi - functional programming interface
 * @export
 */
var ScanIdApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ScanIdApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get url for id scan.
         * @summary Get url for id scan.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idscanCustomerIdUrlGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.idscanCustomerIdUrlGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScanIdApi.idscanCustomerIdUrlGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Webhook about scan file.
         * @summary Webhook about scan file.
         * @param {IdscanWebhookPostRequest} [idscanWebhookPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idscanWebhookPost: function (idscanWebhookPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.idscanWebhookPost(idscanWebhookPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScanIdApi.idscanWebhookPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ScanIdApiFp = ScanIdApiFp;
/**
 * ScanIdApi - factory interface
 * @export
 */
var ScanIdApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ScanIdApiFp)(configuration);
    return {
        /**
         * Get url for id scan.
         * @summary Get url for id scan.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idscanCustomerIdUrlGet: function (customerId, acceptLanguage, options) {
            return localVarFp.idscanCustomerIdUrlGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Webhook about scan file.
         * @summary Webhook about scan file.
         * @param {IdscanWebhookPostRequest} [idscanWebhookPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idscanWebhookPost: function (idscanWebhookPostRequest, options) {
            return localVarFp.idscanWebhookPost(idscanWebhookPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ScanIdApiFactory = ScanIdApiFactory;
/**
 * ScanIdApi - object-oriented interface
 * @export
 * @class ScanIdApi
 * @extends {BaseAPI}
 */
var ScanIdApi = /** @class */ (function (_super) {
    __extends(ScanIdApi, _super);
    function ScanIdApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get url for id scan.
     * @summary Get url for id scan.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanIdApi
     */
    ScanIdApi.prototype.idscanCustomerIdUrlGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.ScanIdApiFp)(this.configuration).idscanCustomerIdUrlGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Webhook about scan file.
     * @summary Webhook about scan file.
     * @param {IdscanWebhookPostRequest} [idscanWebhookPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanIdApi
     */
    ScanIdApi.prototype.idscanWebhookPost = function (idscanWebhookPostRequest, options) {
        var _this = this;
        return (0, exports.ScanIdApiFp)(this.configuration).idscanWebhookPost(idscanWebhookPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ScanIdApi;
}(base_1.BaseAPI));
exports.ScanIdApi = ScanIdApi;
/**
 * SurveysApi - axios parameter creator
 * @export
 */
var SurveysApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * List of customer sources.
         * @summary Get list of available customer sources
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example /customer_company_info_sources?page&#x3D;1.
         * @param {number} [limit] Size of result. Min is 1. For example /customer_company_info_sources?limit&#x3D;1.
         * @param {string} [sort] Sort by customer_company_info_sources fields (name, namePl). For example /customer_company_info_sources?sort&#x3D;name&amp;direction&#x3D;desc.
         * @param {CustomerCompanyInfoSourcesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCompanyInfoSourcesGet: function (acceptLanguage, page, limit, sort, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/customer_company_info_sources";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Sets customer source on their account. Can only set a source if one is not already set.
         * @summary Set customer source for account
         * @param {number} customerId Customer id.
         * @param {SurveysCustomerSourcesCustomerCustomerIdPatchRequest} surveysCustomerSourcesCustomerCustomerIdPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysCustomerSourcesCustomerCustomerIdPatch: function (customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('surveysCustomerSourcesCustomerCustomerIdPatch', 'customerId', customerId);
                            // verify required parameter 'surveysCustomerSourcesCustomerCustomerIdPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('surveysCustomerSourcesCustomerCustomerIdPatch', 'surveysCustomerSourcesCustomerCustomerIdPatchRequest', surveysCustomerSourcesCustomerCustomerIdPatchRequest);
                            localVarPath = "/surveys/customerSources/customer/{customerId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(surveysCustomerSourcesCustomerCustomerIdPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list of active customer sources.
         * @summary Get customer sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysCustomerSourcesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/surveys/customerSources/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get survey.
         * @summary Get survey.
         * @param {string} surveyId Survey unique id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyIdGet: function (surveyId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'surveyId' is not null or undefined
                            (0, common_1.assertParamExists)('surveysSurveyIdGet', 'surveyId', surveyId);
                            localVarPath = "/surveys/{surveyId}"
                                .replace("{".concat("surveyId", "}"), encodeURIComponent(String(surveyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get one random question.
         * @summary Get one random question.
         * @param {SurveysSurveyTypeIdQuestionGetSurveyTypeIdEnum} surveyTypeId Survey type id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyTypeIdQuestionGet: function (surveyTypeId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'surveyTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('surveysSurveyTypeIdQuestionGet', 'surveyTypeId', surveyTypeId);
                            localVarPath = "/surveys/{surveyTypeId}/question"
                                .replace("{".concat("surveyTypeId", "}"), encodeURIComponent(String(surveyTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Save survey result.
         * @summary Save survey result.
         * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostSurveyTypeIdEnum} surveyTypeId Survey type id. One of: - 1 - PPI After TRX - 2 - PPI After RPI - 3 - Mobile After TRX - 4 - Mobile After RPI - 5 - PPI3 After TRX - 6 - PPI3 After RPI
         * @param {number} questionId Question ID.
         * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest} surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyTypeIdQuestionQuestionIdAnswerPost: function (surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'surveyTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('surveysSurveyTypeIdQuestionQuestionIdAnswerPost', 'surveyTypeId', surveyTypeId);
                            // verify required parameter 'questionId' is not null or undefined
                            (0, common_1.assertParamExists)('surveysSurveyTypeIdQuestionQuestionIdAnswerPost', 'questionId', questionId);
                            // verify required parameter 'surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('surveysSurveyTypeIdQuestionQuestionIdAnswerPost', 'surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest', surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest);
                            localVarPath = "/surveys/{surveyTypeId}/question/{questionId}/answer"
                                .replace("{".concat("surveyTypeId", "}"), encodeURIComponent(String(surveyTypeId)))
                                .replace("{".concat("questionId", "}"), encodeURIComponent(String(questionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Save transaction survey result.
         * @summary Save transaction survey result.
         * @param {string} trxId Transaction id
         * @param {SurveysTrxIdAnswersPostRequest} surveysTrxIdAnswersPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysTrxIdAnswersPost: function (trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'trxId' is not null or undefined
                            (0, common_1.assertParamExists)('surveysTrxIdAnswersPost', 'trxId', trxId);
                            // verify required parameter 'surveysTrxIdAnswersPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('surveysTrxIdAnswersPost', 'surveysTrxIdAnswersPostRequest', surveysTrxIdAnswersPostRequest);
                            localVarPath = "/surveys/{trxId}/answers"
                                .replace("{".concat("trxId", "}"), encodeURIComponent(String(trxId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(surveysTrxIdAnswersPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SurveysApiAxiosParamCreator = SurveysApiAxiosParamCreator;
/**
 * SurveysApi - functional programming interface
 * @export
 */
var SurveysApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SurveysApiAxiosParamCreator)(configuration);
    return {
        /**
         * List of customer sources.
         * @summary Get list of available customer sources
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example /customer_company_info_sources?page&#x3D;1.
         * @param {number} [limit] Size of result. Min is 1. For example /customer_company_info_sources?limit&#x3D;1.
         * @param {string} [sort] Sort by customer_company_info_sources fields (name, namePl). For example /customer_company_info_sources?sort&#x3D;name&amp;direction&#x3D;desc.
         * @param {CustomerCompanyInfoSourcesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCompanyInfoSourcesGet: function (acceptLanguage, page, limit, sort, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerCompanyInfoSourcesGet(acceptLanguage, page, limit, sort, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.customerCompanyInfoSourcesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Sets customer source on their account. Can only set a source if one is not already set.
         * @summary Set customer source for account
         * @param {number} customerId Customer id.
         * @param {SurveysCustomerSourcesCustomerCustomerIdPatchRequest} surveysCustomerSourcesCustomerCustomerIdPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysCustomerSourcesCustomerCustomerIdPatch: function (customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.surveysCustomerSourcesCustomerCustomerIdPatch(customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.surveysCustomerSourcesCustomerCustomerIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list of active customer sources.
         * @summary Get customer sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysCustomerSourcesGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.surveysCustomerSourcesGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.surveysCustomerSourcesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get survey.
         * @summary Get survey.
         * @param {string} surveyId Survey unique id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyIdGet: function (surveyId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.surveysSurveyIdGet(surveyId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.surveysSurveyIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get one random question.
         * @summary Get one random question.
         * @param {SurveysSurveyTypeIdQuestionGetSurveyTypeIdEnum} surveyTypeId Survey type id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyTypeIdQuestionGet: function (surveyTypeId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.surveysSurveyTypeIdQuestionGet(surveyTypeId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.surveysSurveyTypeIdQuestionGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Save survey result.
         * @summary Save survey result.
         * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostSurveyTypeIdEnum} surveyTypeId Survey type id. One of: - 1 - PPI After TRX - 2 - PPI After RPI - 3 - Mobile After TRX - 4 - Mobile After RPI - 5 - PPI3 After TRX - 6 - PPI3 After RPI
         * @param {number} questionId Question ID.
         * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest} surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyTypeIdQuestionQuestionIdAnswerPost: function (surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.surveysSurveyTypeIdQuestionQuestionIdAnswerPost(surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.surveysSurveyTypeIdQuestionQuestionIdAnswerPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Save transaction survey result.
         * @summary Save transaction survey result.
         * @param {string} trxId Transaction id
         * @param {SurveysTrxIdAnswersPostRequest} surveysTrxIdAnswersPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysTrxIdAnswersPost: function (trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.surveysTrxIdAnswersPost(trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SurveysApi.surveysTrxIdAnswersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SurveysApiFp = SurveysApiFp;
/**
 * SurveysApi - factory interface
 * @export
 */
var SurveysApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SurveysApiFp)(configuration);
    return {
        /**
         * List of customer sources.
         * @summary Get list of available customer sources
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {number} [page] Number of result. Start is 1. For example /customer_company_info_sources?page&#x3D;1.
         * @param {number} [limit] Size of result. Min is 1. For example /customer_company_info_sources?limit&#x3D;1.
         * @param {string} [sort] Sort by customer_company_info_sources fields (name, namePl). For example /customer_company_info_sources?sort&#x3D;name&amp;direction&#x3D;desc.
         * @param {CustomerCompanyInfoSourcesGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCompanyInfoSourcesGet: function (acceptLanguage, page, limit, sort, direction, options) {
            return localVarFp.customerCompanyInfoSourcesGet(acceptLanguage, page, limit, sort, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sets customer source on their account. Can only set a source if one is not already set.
         * @summary Set customer source for account
         * @param {number} customerId Customer id.
         * @param {SurveysCustomerSourcesCustomerCustomerIdPatchRequest} surveysCustomerSourcesCustomerCustomerIdPatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysCustomerSourcesCustomerCustomerIdPatch: function (customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options) {
            return localVarFp.surveysCustomerSourcesCustomerCustomerIdPatch(customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of active customer sources.
         * @summary Get customer sources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysCustomerSourcesGet: function (options) {
            return localVarFp.surveysCustomerSourcesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get survey.
         * @summary Get survey.
         * @param {string} surveyId Survey unique id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyIdGet: function (surveyId, acceptLanguage, options) {
            return localVarFp.surveysSurveyIdGet(surveyId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get one random question.
         * @summary Get one random question.
         * @param {SurveysSurveyTypeIdQuestionGetSurveyTypeIdEnum} surveyTypeId Survey type id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyTypeIdQuestionGet: function (surveyTypeId, acceptLanguage, options) {
            return localVarFp.surveysSurveyTypeIdQuestionGet(surveyTypeId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Save survey result.
         * @summary Save survey result.
         * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostSurveyTypeIdEnum} surveyTypeId Survey type id. One of: - 1 - PPI After TRX - 2 - PPI After RPI - 3 - Mobile After TRX - 4 - Mobile After RPI - 5 - PPI3 After TRX - 6 - PPI3 After RPI
         * @param {number} questionId Question ID.
         * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest} surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysSurveyTypeIdQuestionQuestionIdAnswerPost: function (surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options) {
            return localVarFp.surveysSurveyTypeIdQuestionQuestionIdAnswerPost(surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Save transaction survey result.
         * @summary Save transaction survey result.
         * @param {string} trxId Transaction id
         * @param {SurveysTrxIdAnswersPostRequest} surveysTrxIdAnswersPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveysTrxIdAnswersPost: function (trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options) {
            return localVarFp.surveysTrxIdAnswersPost(trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SurveysApiFactory = SurveysApiFactory;
/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
var SurveysApi = /** @class */ (function (_super) {
    __extends(SurveysApi, _super);
    function SurveysApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List of customer sources.
     * @summary Get list of available customer sources
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {number} [page] Number of result. Start is 1. For example /customer_company_info_sources?page&#x3D;1.
     * @param {number} [limit] Size of result. Min is 1. For example /customer_company_info_sources?limit&#x3D;1.
     * @param {string} [sort] Sort by customer_company_info_sources fields (name, namePl). For example /customer_company_info_sources?sort&#x3D;name&amp;direction&#x3D;desc.
     * @param {CustomerCompanyInfoSourcesGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.customerCompanyInfoSourcesGet = function (acceptLanguage, page, limit, sort, direction, options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).customerCompanyInfoSourcesGet(acceptLanguage, page, limit, sort, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sets customer source on their account. Can only set a source if one is not already set.
     * @summary Set customer source for account
     * @param {number} customerId Customer id.
     * @param {SurveysCustomerSourcesCustomerCustomerIdPatchRequest} surveysCustomerSourcesCustomerCustomerIdPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.surveysCustomerSourcesCustomerCustomerIdPatch = function (customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).surveysCustomerSourcesCustomerCustomerIdPatch(customerId, surveysCustomerSourcesCustomerCustomerIdPatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of active customer sources.
     * @summary Get customer sources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.surveysCustomerSourcesGet = function (options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).surveysCustomerSourcesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get survey.
     * @summary Get survey.
     * @param {string} surveyId Survey unique id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.surveysSurveyIdGet = function (surveyId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).surveysSurveyIdGet(surveyId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get one random question.
     * @summary Get one random question.
     * @param {SurveysSurveyTypeIdQuestionGetSurveyTypeIdEnum} surveyTypeId Survey type id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.surveysSurveyTypeIdQuestionGet = function (surveyTypeId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).surveysSurveyTypeIdQuestionGet(surveyTypeId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Save survey result.
     * @summary Save survey result.
     * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostSurveyTypeIdEnum} surveyTypeId Survey type id. One of: - 1 - PPI After TRX - 2 - PPI After RPI - 3 - Mobile After TRX - 4 - Mobile After RPI - 5 - PPI3 After TRX - 6 - PPI3 After RPI
     * @param {number} questionId Question ID.
     * @param {SurveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest} surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.surveysSurveyTypeIdQuestionQuestionIdAnswerPost = function (surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).surveysSurveyTypeIdQuestionQuestionIdAnswerPost(surveyTypeId, questionId, surveysSurveyTypeIdQuestionQuestionIdAnswerPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Save transaction survey result.
     * @summary Save transaction survey result.
     * @param {string} trxId Transaction id
     * @param {SurveysTrxIdAnswersPostRequest} surveysTrxIdAnswersPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveysApi
     */
    SurveysApi.prototype.surveysTrxIdAnswersPost = function (trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.SurveysApiFp)(this.configuration).surveysTrxIdAnswersPost(trxId, surveysTrxIdAnswersPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SurveysApi;
}(base_1.BaseAPI));
exports.SurveysApi = SurveysApi;
/**
 * @export
 */
exports.CustomerCompanyInfoSourcesGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * @export
 */
exports.SurveysSurveyTypeIdQuestionGetSurveyTypeIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
};
/**
 * @export
 */
exports.SurveysSurveyTypeIdQuestionQuestionIdAnswerPostSurveyTypeIdEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
};
/**
 * TransactionsApi - axios parameter creator
 * @export
 */
var TransactionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get RFA details (money, status) for transaction
         * @summary Get RFA details for transaction
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCustomerIdReferralsTransactionTransactionIdGet: function (customerId, transactionId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customerCustomerIdReferralsTransactionTransactionIdGet', 'customerId', customerId);
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('customerCustomerIdReferralsTransactionTransactionIdGet', 'transactionId', transactionId);
                            localVarPath = "/customer/{customerId}/referrals/transaction/{transactionId}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List of products for logged user.
         * @summary Get list of products for logged user
         * @param {number} customerId Customer id.
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdProductsLoggedGet: function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdProductsLoggedGet', 'customerId', customerId);
                            // verify required parameter 'filterCurrencyIn' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdProductsLoggedGet', 'filterCurrencyIn', filterCurrencyIn);
                            // verify required parameter 'filterCurrencyOut' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdProductsLoggedGet', 'filterCurrencyOut', filterCurrencyOut);
                            localVarPath = "/customers/{customerId}/products/logged"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterCurrencyIn !== undefined) {
                                localVarQueryParameter['filter[currencyIn]'] = filterCurrencyIn;
                            }
                            if (filterCurrencyOut !== undefined) {
                                localVarQueryParameter['filter[currencyOut]'] = filterCurrencyOut;
                            }
                            if (filterProductType !== undefined) {
                                localVarQueryParameter['filter[productType]'] = filterProductType;
                            }
                            if (filterClientType !== undefined) {
                                localVarQueryParameter['filter[clientType]'] = filterClientType;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list active promotional code.
         * @summary Get promotional codes list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
         * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPromotionCodesGet: function (customerId, acceptLanguage, filterProductId, filterCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdPromotionCodesGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/promotionCodes"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterProductId !== undefined) {
                                localVarQueryParameter['filter[productId]'] = filterProductId;
                            }
                            if (filterCode !== undefined) {
                                localVarQueryParameter['filter[code]'] = filterCode;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send email with pdf file
         * @summary Send email with pdf file
         * @param {number} customerId Customer id. When brand is set to \&#39;b2b\&#39;, the expected id is an business customer id.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetBrandEnum} brand brand like b2b, ppi
         * @param {number} download 0 for email, 1 for download
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
         * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsDateTimeEnum} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
         * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
         * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
         * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;-date to get DESC.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
         * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
         * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
         * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsBrandStatementDownloadGet: function (customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsBrandStatementDownloadGet', 'customerId', customerId);
                            // verify required parameter 'brand' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsBrandStatementDownloadGet', 'brand', brand);
                            // verify required parameter 'download' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsBrandStatementDownloadGet', 'download', download);
                            localVarPath = "/customers/{customerId}/transactions/{brand}/statement/{download}"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("brand", "}"), encodeURIComponent(String(brand)))
                                .replace("{".concat("download", "}"), encodeURIComponent(String(download)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterIdEncrypted !== undefined) {
                                localVarQueryParameter['filter[id_encrypted]'] = filterIdEncrypted;
                            }
                            if (filterDateTime !== undefined) {
                                localVarQueryParameter['filter[date_time]'] = filterDateTime;
                            }
                            if (optionsDateTime !== undefined) {
                                localVarQueryParameter['options[date_time]'] = optionsDateTime;
                            }
                            if (filterSendingAmount !== undefined) {
                                localVarQueryParameter['filter[sending_amount]'] = filterSendingAmount;
                            }
                            if (optionsSendingAmount !== undefined) {
                                localVarQueryParameter['options[sending_amount]'] = optionsSendingAmount;
                            }
                            if (filterPayoutAmount !== undefined) {
                                localVarQueryParameter['filter[payout_amount]'] = filterPayoutAmount;
                            }
                            if (optionsPayoutAmount !== undefined) {
                                localVarQueryParameter['options[payout_amount]'] = optionsPayoutAmount;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (filterBeneficiaryFirstname !== undefined) {
                                localVarQueryParameter['filter[beneficiary_firstname]'] = filterBeneficiaryFirstname;
                            }
                            if (optionsBeneficiaryFirstname !== undefined) {
                                localVarQueryParameter['options[beneficiary_firstname]'] = optionsBeneficiaryFirstname;
                            }
                            if (filterBeneficiaryLastname !== undefined) {
                                localVarQueryParameter['filter[beneficiary_lastname]'] = filterBeneficiaryLastname;
                            }
                            if (optionsBeneficiaryLastname !== undefined) {
                                localVarQueryParameter['options[beneficiary_lastname]'] = optionsBeneficiaryLastname;
                            }
                            if (filterBeneficiaryCompanyName !== undefined) {
                                localVarQueryParameter['filter[beneficiary_company_name]'] = filterBeneficiaryCompanyName;
                            }
                            if (optionsBeneficiaryCompanyName !== undefined) {
                                localVarQueryParameter['options[beneficiary_company_name]'] = optionsBeneficiaryCompanyName;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check if all data are correct and limits are not exceeded
         * @summary Check possibility to make transaction without beneficiary. Action is in first step before choose beneficiary and add transaction
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsCheckPostRequest} customersCustomerIdTransactionsCheckPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsCheckPost: function (customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsCheckPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdTransactionsCheckPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsCheckPost', 'customersCustomerIdTransactionsCheckPostRequest', customersCustomerIdTransactionsCheckPostRequest);
                            localVarPath = "/customers/{customerId}/transactions/check"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdTransactionsCheckPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get list of transaction purpose.
         * @summary Get list of transaction purpose.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesTransactionPurposesGet: function (customerId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsDictionariesTransactionPurposesGet', 'customerId', customerId);
                            localVarPath = "/customers/{customerId}/transactions/dictionaries/transactionPurposes"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List of of customers transactions.
         * @summary Get list of customers transactions
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/transactions?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/transactions?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
         * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
         * @param {string} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
         * @param {CustomersCustomerIdTransactionsGetFilterTypeEnum} [filterType] Use only if api client can\&#39;t change Accept Header value. Return history in pdf /customers/123/transactions?filter[type]&#x3D;pdf. Anothers options: base64 and mail
         * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
         * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
         * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;date_time.
         * @param {CustomersCustomerIdTransactionsGetDirectionEnum} [direction] sorting direction DESC and ASC. /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc
         * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
         * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
         * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
         * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
         * @param {CustomersCustomerIdTransactionsGetFilterStatusEnum} [filterStatus] Filter by transaction status - possible options are [completed, waiting]. For example /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc&amp;filter[status]&#x3D;completed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsGet: function (customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsGet', 'customerId', customerId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsGet', 'page', page);
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsGet', 'limit', limit);
                            localVarPath = "/customers/{customerId}/transactions"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filterIdEncrypted !== undefined) {
                                localVarQueryParameter['filter[id_encrypted]'] = filterIdEncrypted;
                            }
                            if (filterDateTime !== undefined) {
                                localVarQueryParameter['filter[date_time]'] = filterDateTime;
                            }
                            if (optionsDateTime !== undefined) {
                                localVarQueryParameter['options[date_time]'] = optionsDateTime;
                            }
                            if (filterType !== undefined) {
                                localVarQueryParameter['filter[type]'] = filterType;
                            }
                            if (filterSendingAmount !== undefined) {
                                localVarQueryParameter['filter[sending_amount]'] = filterSendingAmount;
                            }
                            if (optionsSendingAmount !== undefined) {
                                localVarQueryParameter['options[sending_amount]'] = optionsSendingAmount;
                            }
                            if (filterPayoutAmount !== undefined) {
                                localVarQueryParameter['filter[payout_amount]'] = filterPayoutAmount;
                            }
                            if (optionsPayoutAmount !== undefined) {
                                localVarQueryParameter['options[payout_amount]'] = optionsPayoutAmount;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            if (fields !== undefined) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (filterBeneficiaryFirstname !== undefined) {
                                localVarQueryParameter['filter[beneficiary_firstname]'] = filterBeneficiaryFirstname;
                            }
                            if (optionsBeneficiaryFirstname !== undefined) {
                                localVarQueryParameter['options[beneficiary_firstname]'] = optionsBeneficiaryFirstname;
                            }
                            if (filterBeneficiaryLastname !== undefined) {
                                localVarQueryParameter['filter[beneficiary_lastname]'] = filterBeneficiaryLastname;
                            }
                            if (optionsBeneficiaryLastname !== undefined) {
                                localVarQueryParameter['options[beneficiary_lastname]'] = optionsBeneficiaryLastname;
                            }
                            if (filterBeneficiaryCompanyName !== undefined) {
                                localVarQueryParameter['filter[beneficiary_company_name]'] = filterBeneficiaryCompanyName;
                            }
                            if (optionsBeneficiaryCompanyName !== undefined) {
                                localVarQueryParameter['options[beneficiary_company_name]'] = optionsBeneficiaryCompanyName;
                            }
                            if (filterStatus !== undefined) {
                                localVarQueryParameter['filter[status]'] = filterStatus;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This URL is used for two scenarios:   1. Transaction information update and initiate card payment process (after payment card input/selection).   2. Transaction completion after 3D-Secure process (3D-secure process is initiated by Location 202 response).     In this scenario only \"type\" and \"id\" parameters are required.
         * @summary Transaction update after select/input payment card and initiate card payment process or transaction completion after 3D-Secure process.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsPatchRequest} customersCustomerIdTransactionsPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsPatch: function (customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsPatch', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdTransactionsPatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsPatch', 'customersCustomerIdTransactionsPatchRequest', customersCustomerIdTransactionsPatchRequest);
                            localVarPath = "/customers/{customerId}/transactions"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdTransactionsPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If all data are correct, saves data in database and saves ID transaction in server session.
         * @summary Save transaction after selecting beneficiary.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsPostRequest} customersCustomerIdTransactionsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsPost: function (customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsPost', 'customerId', customerId);
                            // verify required parameter 'customersCustomerIdTransactionsPostRequest' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsPost', 'customersCustomerIdTransactionsPostRequest', customersCustomerIdTransactionsPostRequest);
                            localVarPath = "/customers/{customerId}/transactions"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdTransactionsPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the status of the transaction based on SagePay response relayed by MsCardPayment. Send confirmation to client via email and SMS, generate SAP records.
         * @summary Confirm that the payment processing for transaction has succeed. Exclusively for MsCardPayment app.
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersCustomerIdTransactionsTransactionIdCompletionPatchRequest} [customersCustomerIdTransactionsTransactionIdCompletionPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdCompletionPatch: function (customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsTransactionIdCompletionPatch', 'customerId', customerId);
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsTransactionIdCompletionPatch', 'transactionId', transactionId);
                            localVarPath = "/customers/{customerId}/transactions/{transactionId}/completion"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send transaction receipt as pdf to customer e-mail
         * @summary Send transaction receipt as pdf to customer e-mail
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdReceiptGet: function (customerId, transactionId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsTransactionIdReceiptGet', 'customerId', customerId);
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsTransactionIdReceiptGet', 'transactionId', transactionId);
                            localVarPath = "/customers/{customerId}/transactions/{transactionId}/receipt"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Download transaction receipt as pdf
         * @summary Download transaction receipt as pdf
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdReceiptPdfGet: function (customerId, transactionId, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsTransactionIdReceiptPdfGet', 'customerId', customerId);
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('customersCustomerIdTransactionsTransactionIdReceiptPdfGet', 'transactionId', transactionId);
                            localVarPath = "/customers/{customerId}/transactions/{transactionId}/receipt/pdf"
                                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)))
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Calculator.
         * @summary Calculator
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCalculatorPost: function (acceptLanguage, productsCalculatorPostRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/products/calculator";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productsCalculatorPostRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List of products.
         * @summary Get list of products
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1. You can get currency id from /currencies/in endpoint.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2. You can get currency id  from /currencies/out endpoint.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGet: function (filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'filterCurrencyIn' is not null or undefined
                            (0, common_1.assertParamExists)('productsGet', 'filterCurrencyIn', filterCurrencyIn);
                            // verify required parameter 'filterCurrencyOut' is not null or undefined
                            (0, common_1.assertParamExists)('productsGet', 'filterCurrencyOut', filterCurrencyOut);
                            localVarPath = "/products";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterCurrencyIn !== undefined) {
                                localVarQueryParameter['filter[currencyIn]'] = filterCurrencyIn;
                            }
                            if (filterCurrencyOut !== undefined) {
                                localVarQueryParameter['filter[currencyOut]'] = filterCurrencyOut;
                            }
                            if (filterProductType !== undefined) {
                                localVarQueryParameter['filter[productType]'] = filterProductType;
                            }
                            if (filterClientType !== undefined) {
                                localVarQueryParameter['filter[clientType]'] = filterClientType;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get transaction tracking data.
         * @summary Get transaction tracking data.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTrackingTransactionIdGetFilterTypeEnum} [filterType] Display transactions depending of type. For example ?filter[type]&#x3D;funcik return only funcik transactions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTrackingTransactionIdGet: function (transactionId, acceptLanguage, filterType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('transactionsTrackingTransactionIdGet', 'transactionId', transactionId);
                            localVarPath = "/transactions/tracking/{transactionId}"
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (filterType !== undefined) {
                                localVarQueryParameter['filter[type]'] = filterType;
                            }
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Block transaction
         * @summary Block transaction.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTransactionIdBlockPatchRequest} [transactionsTransactionIdBlockPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTransactionIdBlockPatch: function (transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('transactionsTransactionIdBlockPatch', 'transactionId', transactionId);
                            localVarPath = "/transactions/{transactionId}/block"
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(transactionsTransactionIdBlockPatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Unblock held transaction
         * @summary Unblock held transaction.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTransactionIdReleasePatchRequest} [transactionsTransactionIdReleasePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTransactionIdReleasePatch: function (transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transactionId' is not null or undefined
                            (0, common_1.assertParamExists)('transactionsTransactionIdReleasePatch', 'transactionId', transactionId);
                            localVarPath = "/transactions/{transactionId}/release"
                                .replace("{".concat("transactionId", "}"), encodeURIComponent(String(transactionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication SignatureAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Signature", configuration)
                                // authentication XRequestAuth required
                            ];
                        case 1:
                            // authentication SignatureAuth required
                            _a.sent();
                            // authentication XRequestAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Request", configuration)
                                // authentication AuthorizationAuth required
                            ];
                        case 2:
                            // authentication XRequestAuth required
                            _a.sent();
                            // authentication AuthorizationAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)
                                // authentication DateAuth required
                            ];
                        case 3:
                            // authentication AuthorizationAuth required
                            _a.sent();
                            // authentication DateAuth required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Date", configuration)];
                        case 4:
                            // authentication DateAuth required
                            _a.sent();
                            if (acceptLanguage != null) {
                                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(transactionsTransactionIdReleasePatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TransactionsApiAxiosParamCreator = TransactionsApiAxiosParamCreator;
/**
 * TransactionsApi - functional programming interface
 * @export
 */
var TransactionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TransactionsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get RFA details (money, status) for transaction
         * @summary Get RFA details for transaction
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCustomerIdReferralsTransactionTransactionIdGet: function (customerId, transactionId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customerCustomerIdReferralsTransactionTransactionIdGet(customerId, transactionId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customerCustomerIdReferralsTransactionTransactionIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * List of products for logged user.
         * @summary Get list of products for logged user
         * @param {number} customerId Customer id.
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdProductsLoggedGet: function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdProductsLoggedGet(customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdProductsLoggedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list active promotional code.
         * @summary Get promotional codes list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
         * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPromotionCodesGet: function (customerId, acceptLanguage, filterProductId, filterCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdPromotionCodesGet(customerId, acceptLanguage, filterProductId, filterCode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdPromotionCodesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send email with pdf file
         * @summary Send email with pdf file
         * @param {number} customerId Customer id. When brand is set to \&#39;b2b\&#39;, the expected id is an business customer id.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetBrandEnum} brand brand like b2b, ppi
         * @param {number} download 0 for email, 1 for download
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
         * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsDateTimeEnum} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
         * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
         * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
         * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;-date to get DESC.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
         * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
         * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
         * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsBrandStatementDownloadGet: function (customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsBrandStatementDownloadGet(customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsBrandStatementDownloadGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check if all data are correct and limits are not exceeded
         * @summary Check possibility to make transaction without beneficiary. Action is in first step before choose beneficiary and add transaction
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsCheckPostRequest} customersCustomerIdTransactionsCheckPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsCheckPost: function (customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsCheckPost(customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsCheckPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get list of transaction purpose.
         * @summary Get list of transaction purpose.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesTransactionPurposesGet: function (customerId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsDictionariesTransactionPurposesGet(customerId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsDictionariesTransactionPurposesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * List of of customers transactions.
         * @summary Get list of customers transactions
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/transactions?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/transactions?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
         * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
         * @param {string} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
         * @param {CustomersCustomerIdTransactionsGetFilterTypeEnum} [filterType] Use only if api client can\&#39;t change Accept Header value. Return history in pdf /customers/123/transactions?filter[type]&#x3D;pdf. Anothers options: base64 and mail
         * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
         * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
         * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;date_time.
         * @param {CustomersCustomerIdTransactionsGetDirectionEnum} [direction] sorting direction DESC and ASC. /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc
         * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
         * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
         * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
         * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
         * @param {CustomersCustomerIdTransactionsGetFilterStatusEnum} [filterStatus] Filter by transaction status - possible options are [completed, waiting]. For example /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc&amp;filter[status]&#x3D;completed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsGet: function (customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsGet(customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * This URL is used for two scenarios:   1. Transaction information update and initiate card payment process (after payment card input/selection).   2. Transaction completion after 3D-Secure process (3D-secure process is initiated by Location 202 response).     In this scenario only \"type\" and \"id\" parameters are required.
         * @summary Transaction update after select/input payment card and initiate card payment process or transaction completion after 3D-Secure process.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsPatchRequest} customersCustomerIdTransactionsPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsPatch: function (customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsPatch(customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * If all data are correct, saves data in database and saves ID transaction in server session.
         * @summary Save transaction after selecting beneficiary.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsPostRequest} customersCustomerIdTransactionsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsPost: function (customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsPost(customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the status of the transaction based on SagePay response relayed by MsCardPayment. Send confirmation to client via email and SMS, generate SAP records.
         * @summary Confirm that the payment processing for transaction has succeed. Exclusively for MsCardPayment app.
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersCustomerIdTransactionsTransactionIdCompletionPatchRequest} [customersCustomerIdTransactionsTransactionIdCompletionPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdCompletionPatch: function (customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsTransactionIdCompletionPatch(customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsTransactionIdCompletionPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send transaction receipt as pdf to customer e-mail
         * @summary Send transaction receipt as pdf to customer e-mail
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdReceiptGet: function (customerId, transactionId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsTransactionIdReceiptGet(customerId, transactionId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsTransactionIdReceiptGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Download transaction receipt as pdf
         * @summary Download transaction receipt as pdf
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdReceiptPdfGet: function (customerId, transactionId, acceptLanguage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.customersCustomerIdTransactionsTransactionIdReceiptPdfGet(customerId, transactionId, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.customersCustomerIdTransactionsTransactionIdReceiptPdfGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Calculator.
         * @summary Calculator
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCalculatorPost: function (acceptLanguage, productsCalculatorPostRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsCalculatorPost(acceptLanguage, productsCalculatorPostRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.productsCalculatorPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * List of products.
         * @summary Get list of products
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1. You can get currency id from /currencies/in endpoint.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2. You can get currency id  from /currencies/out endpoint.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGet: function (filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsGet(filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.productsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get transaction tracking data.
         * @summary Get transaction tracking data.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTrackingTransactionIdGetFilterTypeEnum} [filterType] Display transactions depending of type. For example ?filter[type]&#x3D;funcik return only funcik transactions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTrackingTransactionIdGet: function (transactionId, acceptLanguage, filterType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.transactionsTrackingTransactionIdGet(transactionId, acceptLanguage, filterType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.transactionsTrackingTransactionIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Block transaction
         * @summary Block transaction.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTransactionIdBlockPatchRequest} [transactionsTransactionIdBlockPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTransactionIdBlockPatch: function (transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.transactionsTransactionIdBlockPatch(transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.transactionsTransactionIdBlockPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Unblock held transaction
         * @summary Unblock held transaction.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTransactionIdReleasePatchRequest} [transactionsTransactionIdReleasePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTransactionIdReleasePatch: function (transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.transactionsTransactionIdReleasePatch(transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TransactionsApi.transactionsTransactionIdReleasePatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TransactionsApiFp = TransactionsApiFp;
/**
 * TransactionsApi - factory interface
 * @export
 */
var TransactionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TransactionsApiFp)(configuration);
    return {
        /**
         * Get RFA details (money, status) for transaction
         * @summary Get RFA details for transaction
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCustomerIdReferralsTransactionTransactionIdGet: function (customerId, transactionId, acceptLanguage, options) {
            return localVarFp.customerCustomerIdReferralsTransactionTransactionIdGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of products for logged user.
         * @summary Get list of products for logged user
         * @param {number} customerId Customer id.
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdProductsLoggedGet: function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            return localVarFp.customersCustomerIdProductsLoggedGet(customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list active promotional code.
         * @summary Get promotional codes list.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
         * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdPromotionCodesGet: function (customerId, acceptLanguage, filterProductId, filterCode, options) {
            return localVarFp.customersCustomerIdPromotionCodesGet(customerId, acceptLanguage, filterProductId, filterCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send email with pdf file
         * @summary Send email with pdf file
         * @param {number} customerId Customer id. When brand is set to \&#39;b2b\&#39;, the expected id is an business customer id.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetBrandEnum} brand brand like b2b, ppi
         * @param {number} download 0 for email, 1 for download
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
         * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsDateTimeEnum} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
         * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
         * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
         * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;-date to get DESC.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetDirectionEnum} [direction] sorting direction DESC and ASC
         * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
         * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
         * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
         * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
         * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsBrandStatementDownloadGet: function (customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options) {
            return localVarFp.customersCustomerIdTransactionsBrandStatementDownloadGet(customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check if all data are correct and limits are not exceeded
         * @summary Check possibility to make transaction without beneficiary. Action is in first step before choose beneficiary and add transaction
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsCheckPostRequest} customersCustomerIdTransactionsCheckPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsCheckPost: function (customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsCheckPost(customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of transaction purpose.
         * @summary Get list of transaction purpose.
         * @param {number} customerId Customer id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsDictionariesTransactionPurposesGet: function (customerId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsDictionariesTransactionPurposesGet(customerId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of of customers transactions.
         * @summary Get list of customers transactions
         * @param {number} customerId Customer id.
         * @param {number} page Number of result. Start is 0. For example /customers/123/transactions?page&#x3D;1.
         * @param {number} limit Size of result. Min is 1. For example /customers/123/transactions?limit&#x3D;1.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
         * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
         * @param {string} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
         * @param {CustomersCustomerIdTransactionsGetFilterTypeEnum} [filterType] Use only if api client can\&#39;t change Accept Header value. Return history in pdf /customers/123/transactions?filter[type]&#x3D;pdf. Anothers options: base64 and mail
         * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
         * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
         * @param {CustomersCustomerIdTransactionsGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
         * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;date_time.
         * @param {CustomersCustomerIdTransactionsGetDirectionEnum} [direction] sorting direction DESC and ASC. /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc
         * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
         * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
         * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
         * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
         * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
         * @param {CustomersCustomerIdTransactionsGetFilterStatusEnum} [filterStatus] Filter by transaction status - possible options are [completed, waiting]. For example /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc&amp;filter[status]&#x3D;completed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsGet: function (customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options) {
            return localVarFp.customersCustomerIdTransactionsGet(customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This URL is used for two scenarios:   1. Transaction information update and initiate card payment process (after payment card input/selection).   2. Transaction completion after 3D-Secure process (3D-secure process is initiated by Location 202 response).     In this scenario only \"type\" and \"id\" parameters are required.
         * @summary Transaction update after select/input payment card and initiate card payment process or transaction completion after 3D-Secure process.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsPatchRequest} customersCustomerIdTransactionsPatchRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsPatch: function (customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsPatch(customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If all data are correct, saves data in database and saves ID transaction in server session.
         * @summary Save transaction after selecting beneficiary.
         * @param {number} customerId Customer id.
         * @param {CustomersCustomerIdTransactionsPostRequest} customersCustomerIdTransactionsPostRequest
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsPost: function (customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsPost(customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the status of the transaction based on SagePay response relayed by MsCardPayment. Send confirmation to client via email and SMS, generate SAP records.
         * @summary Confirm that the payment processing for transaction has succeed. Exclusively for MsCardPayment app.
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {CustomersCustomerIdTransactionsTransactionIdCompletionPatchRequest} [customersCustomerIdTransactionsTransactionIdCompletionPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdCompletionPatch: function (customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options) {
            return localVarFp.customersCustomerIdTransactionsTransactionIdCompletionPatch(customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send transaction receipt as pdf to customer e-mail
         * @summary Send transaction receipt as pdf to customer e-mail
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdReceiptGet: function (customerId, transactionId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsTransactionIdReceiptGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Download transaction receipt as pdf
         * @summary Download transaction receipt as pdf
         * @param {number} customerId Customer id.
         * @param {string} transactionId Transaction id
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdTransactionsTransactionIdReceiptPdfGet: function (customerId, transactionId, acceptLanguage, options) {
            return localVarFp.customersCustomerIdTransactionsTransactionIdReceiptPdfGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Calculator.
         * @summary Calculator
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCalculatorPost: function (acceptLanguage, productsCalculatorPostRequest, options) {
            return localVarFp.productsCalculatorPost(acceptLanguage, productsCalculatorPostRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of products.
         * @summary Get list of products
         * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1. You can get currency id from /currencies/in endpoint.
         * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2. You can get currency id  from /currencies/out endpoint.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
         * @param {ClientType} [filterClientType] Display products by client type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGet: function (filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
            return localVarFp.productsGet(filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get transaction tracking data.
         * @summary Get transaction tracking data.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTrackingTransactionIdGetFilterTypeEnum} [filterType] Display transactions depending of type. For example ?filter[type]&#x3D;funcik return only funcik transactions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTrackingTransactionIdGet: function (transactionId, acceptLanguage, filterType, options) {
            return localVarFp.transactionsTrackingTransactionIdGet(transactionId, acceptLanguage, filterType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Block transaction
         * @summary Block transaction.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTransactionIdBlockPatchRequest} [transactionsTransactionIdBlockPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTransactionIdBlockPatch: function (transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options) {
            return localVarFp.transactionsTransactionIdBlockPatch(transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Unblock held transaction
         * @summary Unblock held transaction.
         * @param {string} transactionId Transaction id.
         * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
         * @param {TransactionsTransactionIdReleasePatchRequest} [transactionsTransactionIdReleasePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionsTransactionIdReleasePatch: function (transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options) {
            return localVarFp.transactionsTransactionIdReleasePatch(transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TransactionsApiFactory = TransactionsApiFactory;
/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
var TransactionsApi = /** @class */ (function (_super) {
    __extends(TransactionsApi, _super);
    function TransactionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get RFA details (money, status) for transaction
     * @summary Get RFA details for transaction
     * @param {number} customerId Customer id.
     * @param {string} transactionId Transaction id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customerCustomerIdReferralsTransactionTransactionIdGet = function (customerId, transactionId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customerCustomerIdReferralsTransactionTransactionIdGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of products for logged user.
     * @summary Get list of products for logged user
     * @param {number} customerId Customer id.
     * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1.
     * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
     * @param {ClientType} [filterClientType] Display products by client type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdProductsLoggedGet = function (customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdProductsLoggedGet(customerId, filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list active promotional code.
     * @summary Get promotional codes list.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterProductId] Filter by Product type. For example /customers/{customerId}/promotionCode?filter[productId]&#x3D;18.
     * @param {string} [filterCode] Filter by Code value. For example /customers/{customerId}/promotionCode?filter[code]&#x3D;TEST.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdPromotionCodesGet = function (customerId, acceptLanguage, filterProductId, filterCode, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdPromotionCodesGet(customerId, acceptLanguage, filterProductId, filterCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send email with pdf file
     * @summary Send email with pdf file
     * @param {number} customerId Customer id. When brand is set to \&#39;b2b\&#39;, the expected id is an business customer id.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetBrandEnum} brand brand like b2b, ppi
     * @param {number} download 0 for email, 1 for download
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
     * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsDateTimeEnum} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
     * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
     * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
     * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;-date to get DESC.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetDirectionEnum} [direction] sorting direction DESC and ASC
     * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
     * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
     * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
     * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
     * @param {CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsBrandStatementDownloadGet = function (customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsBrandStatementDownloadGet(customerId, brand, download, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check if all data are correct and limits are not exceeded
     * @summary Check possibility to make transaction without beneficiary. Action is in first step before choose beneficiary and add transaction
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdTransactionsCheckPostRequest} customersCustomerIdTransactionsCheckPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsCheckPost = function (customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsCheckPost(customerId, customersCustomerIdTransactionsCheckPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of transaction purpose.
     * @summary Get list of transaction purpose.
     * @param {number} customerId Customer id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsDictionariesTransactionPurposesGet = function (customerId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsDictionariesTransactionPurposesGet(customerId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of of customers transactions.
     * @summary Get list of customers transactions
     * @param {number} customerId Customer id.
     * @param {number} page Number of result. Start is 0. For example /customers/123/transactions?page&#x3D;1.
     * @param {number} limit Size of result. Min is 1. For example /customers/123/transactions?limit&#x3D;1.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterIdEncrypted] Filter by transaction id. For example /customers/123/transactions?filter[id_encrypted]&#x3D;134.
     * @param {string} [filterDateTime] Filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2012-01-01.
     * @param {string} [optionsDateTime] Option for filter by date_time. For example /customers/123/transactions?filter[date_time]&#x3D;2017-03-03|2017-03-03&amp;options[date_time]&#x3D;between /customers/123/transactions?filter[date_time]&#x3D;2017-03-03&amp;options[date_time]&#x3D;lte
     * @param {CustomersCustomerIdTransactionsGetFilterTypeEnum} [filterType] Use only if api client can\&#39;t change Accept Header value. Return history in pdf /customers/123/transactions?filter[type]&#x3D;pdf. Anothers options: base64 and mail
     * @param {string} [filterSendingAmount] Filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10.
     * @param {CustomersCustomerIdTransactionsGetOptionsSendingAmountEnum} [optionsSendingAmount] Option for filter by sending amount. For example /customers/123/transactions?filter[sending_amount]&#x3D;10|100&amp;options[sending_amount]&#x3D;between /customers/123/transactions?filter[sending_amount]&#x3D;10&amp;options[sending_amount]&#x3D;lte
     * @param {string} [filterPayoutAmount] Filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10.
     * @param {CustomersCustomerIdTransactionsGetOptionsPayoutAmountEnum} [optionsPayoutAmount] Option for filter by payout_amount. For example /customers/123/transactions?filter[payout_amount]&#x3D;10|100&amp;options[payout_amount]&#x3D;between /customers/123/transactions?filter[payout_amount]&#x3D;10&amp;options[payout_amount]&#x3D;lte
     * @param {string} [sort] Sort by transaction fields. For example /customers/123/transactions?sort&#x3D;date_time.
     * @param {CustomersCustomerIdTransactionsGetDirectionEnum} [direction] sorting direction DESC and ASC. /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc
     * @param {string} [fields] Choose fields which You want to get. Default You will have all fields. For example /customers/123/transactions?fields&#x3D;id,amount,date.
     * @param {string} [filterBeneficiaryFirstname] Filter by beneficiary firstname /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John.
     * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryFirstnameEnum} [optionsBeneficiaryFirstname] Option for filter by firstname. For example /customers/123/transactions?filter[beneficiary_firstname]&#x3D;John&amp;options[beneficiary_firstname]&#x3D;like
     * @param {string} [filterBeneficiaryLastname] Filter by beneficiary lastname /customers/123/transactions?filter[beneficiary_lastname]&#x3D;Doe.
     * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryLastnameEnum} [optionsBeneficiaryLastname] Option for filter by lastname. For example /customers/123/transactions?filter[beneficiary_lastname]&#x3D;John&amp;options[beneficiary_lastname]&#x3D;like
     * @param {string} [filterBeneficiaryCompanyName] Filter by beneficiary company name /customers/123/transactions?filter[beneficiary_company_name]&#x3D;1MM.
     * @param {CustomersCustomerIdTransactionsGetOptionsBeneficiaryCompanyNameEnum} [optionsBeneficiaryCompanyName] Option for filter by company_name. For example /customers/123/transactions?filter[beneficiary_company_name]&#x3D;John &amp;options[beneficiary_company_name]&#x3D;like
     * @param {CustomersCustomerIdTransactionsGetFilterStatusEnum} [filterStatus] Filter by transaction status - possible options are [completed, waiting]. For example /customers/123/transactions?sort&#x3D;date_time&amp;direction&#x3D;desc&amp;filter[status]&#x3D;completed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsGet = function (customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsGet(customerId, page, limit, acceptLanguage, filterIdEncrypted, filterDateTime, optionsDateTime, filterType, filterSendingAmount, optionsSendingAmount, filterPayoutAmount, optionsPayoutAmount, sort, direction, fields, filterBeneficiaryFirstname, optionsBeneficiaryFirstname, filterBeneficiaryLastname, optionsBeneficiaryLastname, filterBeneficiaryCompanyName, optionsBeneficiaryCompanyName, filterStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This URL is used for two scenarios:   1. Transaction information update and initiate card payment process (after payment card input/selection).   2. Transaction completion after 3D-Secure process (3D-secure process is initiated by Location 202 response).     In this scenario only \"type\" and \"id\" parameters are required.
     * @summary Transaction update after select/input payment card and initiate card payment process or transaction completion after 3D-Secure process.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdTransactionsPatchRequest} customersCustomerIdTransactionsPatchRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsPatch = function (customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsPatch(customerId, customersCustomerIdTransactionsPatchRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If all data are correct, saves data in database and saves ID transaction in server session.
     * @summary Save transaction after selecting beneficiary.
     * @param {number} customerId Customer id.
     * @param {CustomersCustomerIdTransactionsPostRequest} customersCustomerIdTransactionsPostRequest
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsPost = function (customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsPost(customerId, customersCustomerIdTransactionsPostRequest, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the status of the transaction based on SagePay response relayed by MsCardPayment. Send confirmation to client via email and SMS, generate SAP records.
     * @summary Confirm that the payment processing for transaction has succeed. Exclusively for MsCardPayment app.
     * @param {number} customerId Customer id.
     * @param {string} transactionId Transaction id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {CustomersCustomerIdTransactionsTransactionIdCompletionPatchRequest} [customersCustomerIdTransactionsTransactionIdCompletionPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsTransactionIdCompletionPatch = function (customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsTransactionIdCompletionPatch(customerId, transactionId, acceptLanguage, customersCustomerIdTransactionsTransactionIdCompletionPatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send transaction receipt as pdf to customer e-mail
     * @summary Send transaction receipt as pdf to customer e-mail
     * @param {number} customerId Customer id.
     * @param {string} transactionId Transaction id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsTransactionIdReceiptGet = function (customerId, transactionId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsTransactionIdReceiptGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Download transaction receipt as pdf
     * @summary Download transaction receipt as pdf
     * @param {number} customerId Customer id.
     * @param {string} transactionId Transaction id
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.customersCustomerIdTransactionsTransactionIdReceiptPdfGet = function (customerId, transactionId, acceptLanguage, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).customersCustomerIdTransactionsTransactionIdReceiptPdfGet(customerId, transactionId, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Calculator.
     * @summary Calculator
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {ProductsCalculatorPostRequest} [productsCalculatorPostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.productsCalculatorPost = function (acceptLanguage, productsCalculatorPostRequest, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).productsCalculatorPost(acceptLanguage, productsCalculatorPostRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of products.
     * @summary Get list of products
     * @param {string} filterCurrencyIn Filter by id of input currency. For example /products?filter[currencyIn]&#x3D;1. You can get currency id from /currencies/in endpoint.
     * @param {string} filterCurrencyOut Filter by id of output currency. For example /products?filter[currencyOut]&#x3D;2. You can get currency id  from /currencies/out endpoint.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {string} [filterProductType] Filter by id of productType. For example /products?filter[productType]&#x3D;3.
     * @param {ClientType} [filterClientType] Display products by client type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.productsGet = function (filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).productsGet(filterCurrencyIn, filterCurrencyOut, acceptLanguage, filterProductType, filterClientType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get transaction tracking data.
     * @summary Get transaction tracking data.
     * @param {string} transactionId Transaction id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {TransactionsTrackingTransactionIdGetFilterTypeEnum} [filterType] Display transactions depending of type. For example ?filter[type]&#x3D;funcik return only funcik transactions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.transactionsTrackingTransactionIdGet = function (transactionId, acceptLanguage, filterType, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).transactionsTrackingTransactionIdGet(transactionId, acceptLanguage, filterType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Block transaction
     * @summary Block transaction.
     * @param {string} transactionId Transaction id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {TransactionsTransactionIdBlockPatchRequest} [transactionsTransactionIdBlockPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.transactionsTransactionIdBlockPatch = function (transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).transactionsTransactionIdBlockPatch(transactionId, acceptLanguage, transactionsTransactionIdBlockPatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Unblock held transaction
     * @summary Unblock held transaction.
     * @param {string} transactionId Transaction id.
     * @param {string} [acceptLanguage] Language of API responses. Allowed values: \&quot;pl_PL\&quot;, \&quot;en_US\&quot;
     * @param {TransactionsTransactionIdReleasePatchRequest} [transactionsTransactionIdReleasePatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.transactionsTransactionIdReleasePatch = function (transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options) {
        var _this = this;
        return (0, exports.TransactionsApiFp)(this.configuration).transactionsTransactionIdReleasePatch(transactionId, acceptLanguage, transactionsTransactionIdReleasePatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TransactionsApi;
}(base_1.BaseAPI));
exports.TransactionsApi = TransactionsApi;
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetBrandEnum = {
    B2b: 'b2b',
    Ppi: 'ppi'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsDateTimeEnum = {
    Between: 'between',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    Ne: 'ne',
    Eq: 'eq'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsSendingAmountEnum = {
    Between: 'between',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    Ne: 'ne',
    Eq: 'eq'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsPayoutAmountEnum = {
    Between: 'between',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    Ne: 'ne',
    Eq: 'eq'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryFirstnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryLastnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsBrandStatementDownloadGetOptionsBeneficiaryCompanyNameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetFilterTypeEnum = {
    Between: 'between',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    Ne: 'ne',
    Eq: 'eq'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetOptionsSendingAmountEnum = {
    Between: 'between',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    Ne: 'ne',
    Eq: 'eq'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetOptionsPayoutAmountEnum = {
    Between: 'between',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte',
    Ne: 'ne',
    Eq: 'eq'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetDirectionEnum = {
    Desc: 'DESC',
    Asc: 'ASC'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetOptionsBeneficiaryFirstnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetOptionsBeneficiaryLastnameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetOptionsBeneficiaryCompanyNameEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Like: 'like'
};
/**
 * @export
 */
exports.CustomersCustomerIdTransactionsGetFilterStatusEnum = {
    Completed: 'completed',
    Waiting: 'waiting'
};
/**
 * @export
 */
exports.TransactionsTrackingTransactionIdGetFilterTypeEnum = {
    Ppi3: 'ppi3',
    MobileApi: 'mobile_api',
    Funcik: 'funcik',
    Minutka: 'minutka'
};
